define('viewmodels/RaSocialization/SocializationResponse',['knockout', 'plugins/router', 'durandal/app', 'services/appsecurity', 'services/navigation', 'durandal/system', 'services/logger', 'viewmodels/landing', 'viewmodels/survey/SurveyTracking', 'services/utils', 'viewmodels/RaSocialization/Administration', 'viewmodels/GeneralSettings'],
    function (ko, router, app, appsecurity, navigation, system, logger, SurveyDashBoard, SurveyTrackingVM, utils, Administration, ObjGeneralSettings) {
        var SrViewModel = {
            activate: activate,
            attached: attached,
            appsecurity: appsecurity,
            utils: utils,
            SurveyDashBoard: SurveyDashBoard,
            ObjGeneralSettings: ObjGeneralSettings,
            SurveyTrackingVM: SurveyTrackingVM,
            Administration: Administration,
            PageHeaderName: ko.observable(),
            BusinessUnitId: ko.observable(),
            BusinessUnitName: ko.observable(),
            SurveyTypesList: ko.observable(),
            RootTabList: ko.observable(),
            AssessmentTypeId: ko.observable(),
            SurveyActionsList: ko.observableArray([]),
            SurveyActionsListValidation: ko.observable([]),
            SurveyId: ko.observable(),
            SurveyTypeId: ko.observable(),
            inhHeatMapDataList: ko.observableArray([]),
            inhHeatMapDataListDUP: ko.observableArray([]),
            LocaleCheckFlag: ko.observable(false),
            cntrlHeatMapDataList: ko.observableArray([]),
            residualHeatMapDataList: ko.observableArray([]),
            cntrlHeatMapDataListDUP: ko.observableArray([]),
            residualHeatMapDataListDUP: ko.observableArray([]),
            inhHeatMapFinalData: ko.observable(),
            inhHeatMapFinalDataDUP: ko.observable(),
            cntrlHeatMapFinalData: ko.observable(),
            residualHeatMapFinalData: ko.observable(),
            inhHeatMapDrpDwn: ko.observableArray(),
            cntrlHeatMapDrpDwn: ko.observableArray(),
            resHeatMapDrpDwn: ko.observableArray(),
            inhFactorHeatMapDrpDwn: ko.observableArray(),
            OverrideCommentsCharsLimit: ko.observable(4000),
            OverrideCommentsChars: ko.observable(4000),
            overrideCommentsDetails: ko.observable(),
            overrideRequestList: ko.observableArray(),
            overrideRequestListRecal: ko.observableArray(),
            overrideActionList: ko.observableArray(),
            approveDenyDetails: ko.observable(),
            overrideCommentsList: ko.observable(),
            OcKeypress: OcKeypress,
            OcKeyUp: OcKeyUp,
            expandCollapseColumns: ko.observableArray([]),
            OVERRIDE_FLAG: ko.observable(),
            APPROVER_FLAG: ko.observable(),
            AssignmentReadOnlyFlag: ko.observable(false),
            readOnlyFlag: ko.observable(false),
            createTab: createTab,
            NavigateToAssignment: NavigateToAssignment,
            NavigateToDashboard: NavigateToDashboard,
            ResponseMoveArray: ko.observable(),
            tabType: ko.observable(''),
            surveyDetails: ko.observable(),
            GetActions: GetActions,
            heatMapView: ko.observable(false),
            heatMapViewNA: ko.observable(true),
            heatMapSwitchNA: heatMapSwitchNA,
            expandCollapse: ko.observable('C'),
            contentTabVisible: ko.observable(),
            DataTableColumnWidth: ko.observable('&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'),
            addEditOverrideComment: addEditOverrideComment,
            btnClickPerformAction: btnClickPerformAction,
            showInhHeatMap: ko.observable(false),
            showCntrlHeatMap: ko.observable(false),
            showResdHeatMap: ko.observable(false),
            TaxonomyLevelList: ko.observableArray([]),
            SelectedTaxonomyOption: ko.observable(),

            workflowModelList: ko.observableArray([]),
            ColorApproved: ko.observable('blue'),
            ColorDenied: ko.observable('black'),
            ColorPending: ko.observable('grey'),
            FileExtension: ko.observable('.pdf'),
            SSId: ko.observable(0),
            InhRiskDriversText: ko.observable(),
            CntrlRiskDriversText: ko.observable(),
            OtherRiskDriversText: ko.observable(),
            KeyMethodologyText: ko.observable(),
            WarningInfoLebel: ko.observable(''),
            ControlNarratives: ko.observableArray([]),

            TableUid: ko.observable(),
            TableType: ko.observable(),
            InherentNarratives: ko.observableArray([]),
            // OrgAUConlspan: ko.observable(4),
            DistinctRiskLevelList: ko.observableArray([]),
            ClickedSurveyType: ko.observable(0),
            ClickedSurveyTypeText: ko.observable('qldr'),
            QualResponseListData: ko.observableArray([]),
            valuechange: valuechange,
            RemoveArray: ko.observableArray([]),
            ControlColumnDetails: ko.observableArray([]),
            QualColumnDetails: ko.observableArray([]),
            tabTypeDetails: ko.observableArray([]),

            Query: ko.observable(''),
            ControlsResponseData: ko.observableArray([]),
            ClickedQualType: ko.observable('qualitative'),
            FormatValueData: FormatValueData,

            User: ko.observable(),
            ErrorChars: ko.observable(''),
            ToggleNavigationMenu1: ToggleNavigationMenu1,
            ToggleNavigationMenu2: ToggleNavigationMenu2,
            CollapseAllTreeView: CollapseAllTreeView,
            ExpandAllTreeView: ExpandAllTreeView,
            SearchTreeView: SearchTreeView,
            BreadCrumbArray: ko.observableArray([]),
            AreaLeveljstree: ko.observableArray([]),
            isAllSubCategorySurveyCompleteFlag: ko.observable(),
            isSaveResponseClick: ko.observable(false),
            selectedTreeNode: ko.observableArray([]),
            SurveyTypeClicked: ko.observable(),
            Zat_id_Tree: ko.observable(),
            Type: ko.observable(),
            ClickedRiskAreaId: ko.observable(),
            ClickedRiskAreaName: ko.observable(),
            TaxonomyLevelListFlag: ko.observable(false),
            SelectedTaxonomyOptionFlag: ko.observable(false),
            FormatValueDataLevel: FormatValueDataLevel,
            valuechangeLevel: valuechangeLevel,
            SelectedTaxonomyOptionText: ko.observable(''),
            DisplayExportDropdown: DisplayExportDropdown,
            NavigateToSocioExportReport: NavigateToSocioExportReport,
            inhHeatMapDataListDUPRaw: ko.observableArray([]),
            residualHeatMapDataListDUPRaw: ko.observableArray([]),
            cntrlHeatMapDataListDUPRaw: ko.observableArray([]),
            NavigateToSocioHistoricExportReport: NavigateToSocioHistoricExportReport,
            SelectedTaxonomyOptionRefresh: ko.observable(),
            ChangesTabClick: ko.observable(false),

            SurveyName: ko.observable(),
            SurveyIconClass: ko.observable(),
            DueDate: ko.observable(),
            SurveyStatus: ko.observable(),
            PendingWith: ko.observable(),
            SurveyStateColor: ko.observable(),
            SurveyClassification: ko.observable(),
            IsSocioSurveyCompleted: ko.observable(),
            IsSocioSurveyPending: ko.observable(),
            BUList: ko.observable(),
            ComponentName_Survey: ko.observable(),
            ProfileName_Survey: ko.observable(),
            SurveyStateName: ko.observable(),
            ViewSelectedReport: ViewSelectedReport,
            showSurveyInfoClick: showSurveyInfoClick,
            UserList: ko.observable(),
            CurrentRATtype: ko.observable(),
            showOverallSummaryDiv: showOverallSummaryDiv,
            NarrationComment: ko.observable(),
            NarrationCommentId: ko.observable(),
            RemovePlugins: ko.observable('Styles,Format,Outdent,Indent,RemoveFormat,Subscript,Superscript,elementspath,save,image,flash,iframe,link,smiley,find,pagebreak,templates,about,maximize,showblocks,newpage,language,scayt,HorizontalRule,SpecialChar,Source,blockquote,wsc,Superscript, Subscript, Outdent, Indent,Strike'),//tabletools
            RemoveButtons: ko.observable('Styles,Format,Outdent,Indent,RemoveFormat,Subscript,Superscript,Copy,Cut,Paste,Undo,Redo,Print,Form,TextField,Textarea,Button,SelectAll,CreateDiv,Table,PasteText,PasteFromWord,Select,HiddenField,HorizontalRule,SpecialChar,Source,Superscript, Subscript, Outdent, Indent,Strike'),
            RemainingChars: ko.observable(4000),
            SaveSurveySummary: SaveSurveySummary,
            InhColumnFlag: ko.observable(false),
            ContColumnFlag: ko.observable(false),
            ResColumnFlag: ko.observable(false),
            OrgAUConlspanInh: ko.observable(1),
            OrgAUConlspanCont: ko.observable(1),
            OrgAUConlspanRes: ko.observable(1),
            OverridePopup: OverridePopup,
            OverridePopupOverall: OverridePopupOverall,
            IsOverallOverride: ko.observable(),
            ColumnType: ko.observable(''),
            SaveOverrideComment: SaveOverrideComment,
            //SetRiskColorValue: SetRiskColorValue,
            Multilist: ko.observableArray([]),
            AMLContMultilist: ko.observableArray([]),
            SurveySummaryCommentId: ko.observable(0),
            SurveySummaryComment: ko.observable(''),
            SummaryCommentBy: ko.observable(''),
            SummaryCommentCreatedDate: ko.observable(''),
            UploadDocument: UploadDocument,
            UploadComment: ko.observable(''),
            ProgressMessage: ko.observable(''),
            ProgressPercent: ko.observable(),
            DownloadDocument: DownloadDocument,
            DeleteDocument: DeleteDocument,
            SummaryDocumentsList: ko.observableArray([]),
            PushbackComment: ko.observable(''),
            SelectedActionEventId: ko.observable(),
            NavigatedFromDashboard: ko.observable(),
            ClearResult: ClearResult,
            searchResults: ko.observableArray([]),
            IsRationaleFlag: ko.observable(),
            reqComment: reqComment,
            editOverrideRequest: editOverrideRequest,
            SelectedCommentId: ko.observable(''),
            OverrideComments: ko.observableArray([]),
            CurrentProfileOfAssessmentId: ko.observable(),
            SurveyTimelineComments: ko.observableArray([]),
            MaxTaxonomyLevel: ko.observable(3),
            AssessmentType: ko.observable(2),  // 2 = CRA and 1 = AML/OFAC
            CopyComment: CopyComment,
            DocumentListFinal: ko.observableArray([]),
            //AML

            expandInherent: expandInherent,
            expandControl: expandControl,
            expandResidual: expandResidual,
            showInherent: ko.observable(true),
            Inhstate: ko.observable(true),
            Cntstate: ko.observable(false),
            showControl: ko.observable(false),
            Resstate: ko.observable(false),
            showResidual: ko.observable(false),
            InherentFilter: InherentFilter,
            ControlFilter: ControlFilter,
            ResidualFilter: ResidualFilter,
            FilterALL: FilterALL,
            filterAllRes: ko.observable(true),
            filterAllCnt: ko.observable(true),
            filterAllInh: ko.observable(true),


            //Latest survey code

            Is_RefreshCopyProfile: ko.observable(false),

            MCILevels: ko.observableArray([]),
            MCIMaxLevel: ko.observable(0),
            // CheckMCILevel: CheckMCILevel,
            MCIRawLevels: ko.observableArray([]),

            QueryMCI: ko.observable(''),
            MCILevelsDup: ko.observableArray([]),
            AoCHeaderMessage: ko.observable(''),
            AoCInstructions: ko.observable(''),
            AoCInstructionsMsg: ko.observable(''),
            ColumnDetails: ko.observable(''),

            ShowDocumentConent: ShowDocumentConent,
            ShowCommentContent: ShowCommentContent,
            UsersRoleWFList: ko.observableArray([]),
            PreviousPage: ko.observable(''),
            NavigatedFromTracking: ko.observable(false),
            NavigateToTracking: NavigateToTracking,
            RiskType: ko.observable('ALL'),
            editableTypes: ko.observableArray([]),
            ColspanValue: ko.observable(1),

            InhRiskThemeDetails: ko.observableArray([]),
            ContRiskThemeDetails: ko.observableArray([]),
            clickLevel: clickLevel,
            clickLevelCntrl: clickLevelCntrl,
            expand: expand,
            collapse: collapse,
            SearchResult_Main: SearchResult_Main,
            ResetSearch_Main: ResetSearch_Main,
            SearchResult: SearchResult,
            ResetSearch: ResetSearch,
            EditableAreaName: ko.observable('Risk Area'),
            OverrideType: ko.observable(''),
            SelectedComponentId: ko.observable(),
            overrideDropDownList: ko.observableArray([]),
            AggregateBUDetailsInherent: ko.observableArray([]),
            AggregateBUDetailsControl: ko.observableArray([]),
            AggregateBUDetailsResidual: ko.observableArray([]),
            CRAAggregateBUInformation: ko.observableArray([]),
            ResHeatMapData: ko.observableArray([]),
            ResHeatMapDataDUP: ko.observableArray([]),
            CollapseAll: CollapseAll,
            ExpandAll: ExpandAll,

            EditableBUName: ko.observable(''),
            BUColSpan: ko.observable(3),

            //Overall heatmap layout
            SelectedBUs: ko.observable(''),
            ORG_TabID: ko.observable(0),
            BusinessUnitListForFilters: ko.observableArray([]),
            BusinessUnitListForFiltersDUP: ko.observableArray([]),
            BusinessUnitListDUP: ko.observableArray([]),
            OrgLvlDrpDwnList: ko.observableArray([]),
            OrgLvlValueList: ko.observableArray([]),
            SelectedCheckedList: ko.observableArray([]),
            SelectedCheckedBUList: ko.observableArray([]),
            BUTitle: ko.observable('Business Unit'),
            SubCheckboxSelected: SubCheckboxSelected,
            BusinessUnitList: ko.observableArray([]),
            ClearOrgFilterSelection: ClearOrgFilterSelection,
            DistinctFileredBUs: ko.observableArray([]),
            ClearBUFilterSelection: ClearBUFilterSelection,
            FinalOrgFilterList: ko.observableArray([]),
            NumberOfBUsSelected: ko.observable(),
            IsSideNavOpen: ko.observable(0),
            BUFiltersApplied: ko.observable(false),
            openSideNav: openSideNav,
            closeSideNav: closeSideNav,
            OverAllHeatMapView: ko.observable(true),
            ApplyBuFilters: ApplyBuFilters,
            ClearAllBuFilters: ClearAllBuFilters,
            SocType: ko.observable('Normal'),
            SubOrgLevelList: ko.observableArray([]),
            uniqueEditableTypes: ko.observableArray([]),
            showWFDescription: showWFDescription,
            showTimelineComments: showTimelineComments,
            TimelineCommentsFlag: ko.observable(true),
            ShowFinalLevel: ko.observable(),
            ShowApplicableFilter: ko.observable(),
            ShowHeatmapScore: ko.observable(false),
            ShowScoreSwitch: ShowScoreSwitch,
            ActionsPopupHeading: ko.observable(''),
            showMoreInstructions: showMoreInstructions,
            Instructions: ko.observable(),
            IsSurveyReadOnly: ko.observable()
        };
        return SrViewModel;
        function activate() {
            try {

                SrViewModel.tabType("");
                if (SrViewModel.ObjGeneralSettings === undefined || SrViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((SrViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || SrViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && SrViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    SrViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {

                        if (SrViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || SrViewModel.ObjGeneralSettings.LocalizedTextList() == null || SrViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || SrViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || SrViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                            SrViewModel.LocaleCheckFlag(false);
                        else
                            SrViewModel.LocaleCheckFlag(true);
                    });
                }
                else {
                    if (SrViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || SrViewModel.ObjGeneralSettings.LocalizedTextList() == null || SrViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || SrViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || SrViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        SrViewModel.LocaleCheckFlag(false);
                    else
                        SrViewModel.LocaleCheckFlag(true);
                }
                if (SrViewModel.SurveyTrackingVM.RoutedFrom() == "Tracking") {
                    SrViewModel.PreviousPage("tracking");
                    SrViewModel.BusinessUnitName(SrViewModel.SurveyTrackingVM.ResponseMoveArray().BusinessUnitName());
                    SrViewModel.BusinessUnitId(SrViewModel.SurveyTrackingVM.ResponseMoveArray().SurveyId());//to-do: its derat uid only
                    SrViewModel.SurveyId(SrViewModel.SurveyTrackingVM.ResponseMoveArray().SurveyId());
                    //SrViewModel.SurveyTypeId(SrViewModel.Administration.ResponseMoveArray().GroupShortName());
                    SrViewModel.readOnlyFlag(true);
                    SrViewModel.SurveyName(SrViewModel.SurveyTrackingVM.ResponseMoveArray().SurveyName());
                    SrViewModel.AssessmentTypeId(SrViewModel.SurveyTrackingVM.ResponseMoveArray().AssessmentTypeId());
                    SrViewModel.AssessmentType(SrViewModel.SurveyTrackingVM.ResponseMoveArray().GroupId());

                    SrViewModel.NavigatedFromTracking(true);
                    SrViewModel.NavigatedFromDashboard(false);
                    SrViewModel.SelectedTaxonomyOptionFlag(false);
                    SrViewModel.AssignmentReadOnlyFlag(true);
                    SrViewModel.appsecurity.WriteAccess(false);
                    SrViewModel.SurveyIconClass(SrViewModel.SurveyTrackingVM.ResponseMoveArray().SurveyIconClass());
                    SrViewModel.DueDate(SrViewModel.SurveyTrackingVM.ResponseMoveArray().DueDate());
                    SrViewModel.SurveyStatus(SrViewModel.SurveyTrackingVM.ResponseMoveArray().SurveyStatus());
                    SrViewModel.PendingWith(SrViewModel.SurveyTrackingVM.ResponseMoveArray().PendingAt());
                    SrViewModel.CurrentProfileOfAssessmentId(SrViewModel.SurveyTrackingVM.ResponseMoveArray().CurrentProfileOfAssessmentId());
                    SrViewModel.UserList(SrViewModel.SurveyTrackingVM.ResponseMoveArray().UserList());
                    SrViewModel.PageHeaderName(SrViewModel.SurveyTrackingVM.ResponseMoveArray().BusinessUnitName());
                    SrViewModel.SocType(SrViewModel.SurveyTrackingVM.ResponseMoveArray().SocType());
                    SrViewModel.SurveyClassification(SrViewModel.SurveyTrackingVM.ResponseMoveArray().SurveyType());     // SUR, SOC, ACT
                    SrViewModel.IsSocioSurveyCompleted(SrViewModel.SurveyTrackingVM.ResponseMoveArray().IsCompletedFlag());
                    SrViewModel.IsSocioSurveyPending(SrViewModel.SurveyTrackingVM.ResponseMoveArray().IsPendingFlag());
                    SrViewModel.BUList(SrViewModel.SurveyTrackingVM.ResponseMoveArray().BUList());
                    SrViewModel.ComponentName_Survey(SrViewModel.SurveyTrackingVM.ResponseMoveArray().ComponentName());
                    SrViewModel.ProfileName_Survey(SrViewModel.SurveyTrackingVM.ResponseMoveArray().ProfileName());
                    SrViewModel.SurveyStateName(SrViewModel.SurveyTrackingVM.ResponseMoveArray().SurveyStateName());
                    SrViewModel.IsSurveyReadOnly(true); //read-only view from tracking
                }

                else if (SrViewModel.Administration.ResponseMoveArray() != undefined && appsecurity.SocializationReadOnly() == true) {
                    SrViewModel.PageHeaderName(SrViewModel.Administration.ResponseMoveArray().BusinessUnitName());
                    SrViewModel.BusinessUnitName(SrViewModel.Administration.ResponseMoveArray().BusinessUnitName());
                    SrViewModel.BusinessUnitId(SrViewModel.Administration.ResponseMoveArray().SurveyId());//to-do: its derat uid only
                    SrViewModel.SurveyId(SrViewModel.Administration.ResponseMoveArray().SurveyId());
                    SrViewModel.SurveyTypeId(SrViewModel.Administration.ResponseMoveArray().SurveyTypeId());
                    SrViewModel.readOnlyFlag(SrViewModel.Administration.ResponseMoveArray().ReadOnly_FLAG());
                    SrViewModel.AssessmentTypeId(SrViewModel.Administration.ResponseMoveArray().RatId());
                    SrViewModel.AssessmentType(SrViewModel.Administration.ResponseMoveArray().AssessmentType());
                    SrViewModel.SocType(SrViewModel.Administration.ResponseMoveArray().SocType())
                    SrViewModel.NavigatedFromTracking(false);
                    SrViewModel.NavigatedFromDashboard(false);
                    SrViewModel.SelectedTaxonomyOptionFlag(false);
                    SrViewModel.AssignmentReadOnlyFlag(true);
                    SrViewModel.appsecurity.WriteAccess(false);
                    SrViewModel.SurveyIconClass(SrViewModel.Administration.ResponseMoveArray().SurveyIconClass());
                    SrViewModel.DueDate(SrViewModel.Administration.ResponseMoveArray().DueDate());
                    SrViewModel.SurveyStatus(SrViewModel.Administration.ResponseMoveArray().SurveyStatus());
                    SrViewModel.PendingWith(SrViewModel.Administration.ResponseMoveArray().PendingWith());
                    SrViewModel.SurveyStateColor(SrViewModel.Administration.ResponseMoveArray().SurveyStateColor());
                    SrViewModel.UserList(SrViewModel.Administration.ResponseMoveArray().UserList());
                    SrViewModel.SurveyName(SrViewModel.Administration.ResponseMoveArray().SurveyName());
                    SrViewModel.CurrentProfileOfAssessmentId(SrViewModel.Administration.ResponseMoveArray().CurrentProfileOfAssessmentId());
                    SrViewModel.BUList(SrViewModel.Administration.ResponseMoveArray().BUList());
                    SrViewModel.SurveyClassification(SrViewModel.Administration.ResponseMoveArray().SurveyClassification());     // SUR, SOC, ACT
                    SrViewModel.IsSocioSurveyCompleted(SrViewModel.Administration.ResponseMoveArray().IsCompletedFlag());
                    SrViewModel.ComponentName_Survey(SrViewModel.Administration.ResponseMoveArray().SurveyType());
                    SrViewModel.ProfileName_Survey(SrViewModel.Administration.ResponseMoveArray().ProfileName());
                    SrViewModel.SurveyStateName(SrViewModel.Administration.ResponseMoveArray().SurveyStateName());
                    SrViewModel.IsSurveyReadOnly(true); //read-only view from Administration
                }

                else if (SrViewModel.SurveyDashBoard.ResponseMoveArray() != undefined && appsecurity.SocializationReadOnly() == false) {
                    SrViewModel.NavigatedFromTracking(false);
                    SrViewModel.NavigatedFromDashboard(true);
                    SrViewModel.AssignmentReadOnlyFlag(false);
                    SrViewModel.appsecurity.WriteAccess(true);
                    SrViewModel.AssessmentType(SrViewModel.SurveyDashBoard.ResponseMoveArray().AssessmentType());
                    SrViewModel.AssessmentTypeId(SrViewModel.SurveyDashBoard.ResponseMoveArray().AssessmentTypeId());
                    SrViewModel.PageHeaderName(SrViewModel.SurveyDashBoard.ResponseMoveArray().BusinessUnitName());
                    SrViewModel.SurveyId(SrViewModel.SurveyDashBoard.ResponseMoveArray().SurveyId());
                    SrViewModel.SurveyName(SrViewModel.SurveyDashBoard.ResponseMoveArray().SurveyName());
                    SrViewModel.BusinessUnitName(SrViewModel.SurveyDashBoard.ResponseMoveArray().BusinessUnitName());
                    SrViewModel.BusinessUnitId(SrViewModel.SurveyDashBoard.ResponseMoveArray().SurveyId());//to-do: its derat uid only
                    SrViewModel.readOnlyFlag(SrViewModel.SurveyDashBoard.ResponseMoveArray().ReadOnly_FLAG());
                    SrViewModel.CurrentProfileOfAssessmentId(SrViewModel.SurveyDashBoard.ResponseMoveArray().CurrentProfileOfAssessmentId());
                    SrViewModel.SelectedTaxonomyOptionFlag(false);
                    SrViewModel.SurveyIconClass(SrViewModel.SurveyDashBoard.ResponseMoveArray().SurveyIconClass());
                    SrViewModel.DueDate(SrViewModel.SurveyDashBoard.ResponseMoveArray().DueDate());
                    SrViewModel.SurveyStatus(SrViewModel.SurveyDashBoard.ResponseMoveArray().SurveyStatus());
                    SrViewModel.PendingWith(SrViewModel.SurveyDashBoard.ResponseMoveArray().PendingWith());
                    SrViewModel.SurveyStateColor(SrViewModel.SurveyDashBoard.ResponseMoveArray().SurveyStateColor());
                    SrViewModel.UserList(SrViewModel.SurveyDashBoard.ResponseMoveArray().UserList());
                    SrViewModel.SocType(SrViewModel.SurveyDashBoard.ResponseMoveArray().SocType());
                    SrViewModel.SurveyClassification(SrViewModel.SurveyDashBoard.ResponseMoveArray().SurveyType());     // SUR, SOC, ACT
                    SrViewModel.IsSocioSurveyCompleted(SrViewModel.SurveyDashBoard.ResponseMoveArray().IsCompletedFlag());
                    SrViewModel.IsSocioSurveyPending(SrViewModel.SurveyDashBoard.ResponseMoveArray().IsPendingFlag());
                    SrViewModel.BUList(SrViewModel.SurveyDashBoard.ResponseMoveArray().BUList());
                    SrViewModel.ComponentName_Survey(SrViewModel.SurveyDashBoard.ResponseMoveArray().ComponentName_Survey());
                    SrViewModel.ProfileName_Survey(SrViewModel.SurveyDashBoard.ResponseMoveArray().ProfileName_Survey());
                    SrViewModel.SurveyStateName(SrViewModel.SurveyDashBoard.ResponseMoveArray().SurveyStateName());
                    SrViewModel.IsSurveyReadOnly(SrViewModel.SurveyDashBoard.ResponseMoveArray().IsSurveyReadOnly());
                }

                else if (SrViewModel.SurveyTrackingVM == undefined && SrViewModel.SurveyTrackingVM.ResponseMoveArray() == undefined && appsecurity.SocializationReadOnly() == false) {
                    router.navigate("survey/SurveyTracking", true);
                }

                else if (SrViewModel.SurveyDashBoard == undefined && SrViewModel.SurveyDashBoard.ResponseMoveArray() == undefined && appsecurity.SocializationReadOnly() == false) {
                    SrViewModel.SurveyDashBoard.NavigatedFrom("Response");
                    router.navigate("Landing", true);
                }
                else if (SrViewModel.Administration.ResponseMoveArray() == undefined && appsecurity.SocializationReadOnly() == true) {
                    router.navigate("RaSocialization/Administration", true);
                }
                if (SrViewModel.IsSocioSurveyCompleted()) {
                    SrViewModel.SelectedTaxonomyOptionFlag(false);
                    SrViewModel.AssignmentReadOnlyFlag(true);
                    SrViewModel.appsecurity.WriteAccess(false);
                }
                if (SrViewModel.IsSurveyReadOnly()) {
                    SrViewModel.AssignmentReadOnlyFlag(true);
                    SrViewModel.appsecurity.WriteAccess(false);
                    SrViewModel.readOnlyFlag(true);
                }
                SrViewModel.BreadCrumbArray([]);

                SrViewModel.SelectedBUs(SrViewModel.BusinessUnitId());

                SrViewModel.BUTitle((SrViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || SrViewModel.ObjGeneralSettings.LocalizedTextList() == null || SrViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || SrViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || SrViewModel.ObjGeneralSettings.LocalizedIndexList() == null || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits') == -1) ? 'Business Unit' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits')].Name());

                SrViewModel.NumberOfBUsSelected(0);

            } catch (e) {
                var msg = 'Exception: ' + e.statusText + ' | Source: activate() method in SocializationResponse.js';
                logger.logMessage(msg);

                if (appsecurity.SocializationReadOnly() == false) {
                    SrViewModel.SurveyDashBoard.NavigatedFrom("Response");
                    router.navigate("Landing", true);
                }
                else
                    router.navigate("RaSocialization/Administration", true);
            }
        }

        function attached() {
            try {
                ClearSearchText();
                $("#divNavSwitch2").hide();
                SrViewModel.RiskType('ALL');
                SrViewModel.SelectedTaxonomyOption(null);
                SrViewModel.SelectedTaxonomyOptionFlag(false);
                SrViewModel.contentTabVisible(false);
                SrViewModel.ChangesTabClick(false);
                //SrViewModel.heatMapViewNA(true);
                $('#noHeatmapavailable').hide();
                SrViewModel.ShowHeatmapScore(false);
                if (SrViewModel.SurveyTrackingVM.RoutedFrom() == "Tracking") {
                    SrViewModel.expandCollapseColumns([]);
                    SrViewModel.expandCollapseColumns.push(new expandCollapseModel({ colType: "Inherent" }));
                    SrViewModel.expandCollapseColumns.push(new expandCollapseModel({ colType: "Controls" }));
                    SrViewModel.expandCollapseColumns.push(new expandCollapseModel({ colType: "Residual" }));
                    if (SrViewModel.SocType() === 'Overall') {
                        GetBusinessLevel();
                    }
                    else {
                        SrViewModel.SubOrgLevelList([]);
                        GetAllSurveyType();
                    }
                    GetUser();
                    SrViewModel.tabType('HEATMAP_TYPE2');
                    GetTaxonomyList();
                    GetSurveyLevelComments("PBC");
                    SrViewModel.SurveyTrackingVM.RoutedFrom("");
                    GetInstructions();
                }
                else if (SrViewModel.Administration.ResponseMoveArray() != undefined) {
                    SrViewModel.expandCollapseColumns([]);
                    GetSurveyLevelComments("PBC");
                    SrViewModel.expandCollapseColumns.push(new expandCollapseModel({ colType: "Inherent" }));
                    SrViewModel.expandCollapseColumns.push(new expandCollapseModel({ colType: "Controls" }));
                    SrViewModel.expandCollapseColumns.push(new expandCollapseModel({ colType: "Residual" }));
                    if (SrViewModel.SocType() === 'Overall') {
                        GetBusinessLevel();

                    }
                    else {
                        SrViewModel.SubOrgLevelList([]);
                        GetAllSurveyType();
                    }
                    GetUser();
                    SrViewModel.tabType('HEATMAP_TYPE2');
                    GetTaxonomyList();
                    GetInstructions();
                }
                else if (SrViewModel.SurveyDashBoard.ResponseMoveArray() == undefined && appsecurity.SocializationReadOnly() == false) {
                    SrViewModel.SurveyDashBoard.NavigatedFrom("Response");
                    router.navigate("Landing", true);
                }
                else if (SrViewModel.Administration.ResponseMoveArray() == undefined && appsecurity.SocializationReadOnly() == true) {
                    router.navigate("#RaSocialization/Administration", true);
                }
                // Clear Old Values
                SrViewModel.heatMapView(false);
                //filter code
                SrViewModel.SelectedCheckedBUList([]);
                SrViewModel.SelectedCheckedList([]);
                //SrViewModel.SelectedBUs('');
                closeSideNav();
                SrViewModel.BUFiltersApplied(false);
                SrViewModel.NumberOfBUsSelected(0);
                $('.badge').css({ 'display': 'none' });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function GetBusinessLevel() {
            try {
                return $.ajax({
                    url: "/api/Configuration/getAllBusinessUnitLevels?type=" + SrViewModel.AssessmentTypeId() + "&Page_Type=SC",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            } catch (e) {

                var msg = 'Exception: ' + e + ' | Source: ajax call in GetBusinessLevel() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        if (jsonResult.length > 0) {
                            if (jsonResult[0].Incident_Description != null) {
                                logger.logError(jsonResult[0].Incident_Description + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else {
                                var MappedBUModelList = $.map(jsonResult, function (result) {
                                    var BusinessLevelModelObj = new BusinessLevelModel(result);
                                    return BusinessLevelModelObj;
                                });

                                SrViewModel.SubOrgLevelList(MappedBUModelList);
                                GetAllSurveyType();
                            }
                        }
                        else 
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                    }
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess call in GetBusinessLevel() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetBusinessLevel() method in SocializationResponse.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetBusinessLevel() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            }
        }

        function BusinessLevelModel(item) {
            try {
                var self = this;
                self.BusinessLevelId = ko.observable($('<div/>').html(item.BuLId).text());
                self.BusinessLevelName = ko.observable($('<div/>').html(item.BuLevelName).text());

            } catch (e) {
                var msg = 'exception' + e + ' | Source:BusinessLevelModel() in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function GetAllSurveyType() {
            return $.ajax({
                url: "/api/Survey/GetSurveyTabsSocialization?DE_RAT_UID=" + SrViewModel.SurveyId(),
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            }).success(function (jsonResult, status) {

                if (jsonResult != null) {
                    if (jsonResult[-777] != undefined && jsonResult[-777].length != 0) {
                        logger.logError(jsonResult[-777][0].TabName + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                    }
                    else {
                        SrViewModel.SurveyTypesList(jsonResult);
                        SrViewModel.RootTabList(SrViewModel.SurveyTypesList()[-999]);
                        SrViewModel.CurrentRATtype(SrViewModel.RootTabList()[0].TabType);
                        if (SrViewModel.RootTabList() != undefined && SrViewModel.RootTabList().length > 0)
                            createTab(SrViewModel.RootTabList()[0].TabId, (SrViewModel.RootTabList()[0].Level + 1), SrViewModel.RootTabList()[0].TableUID, SrViewModel.CurrentRATtype(), SrViewModel.RootTabList()[0].TabName)
                    }
                }
                else {
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                }

            }).fail(function (error, status) {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        });
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllSurveyType() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            });
        }

        function createTab(tabId, level, tableUID, tabType, tabName) {
            try {
                SrViewModel.ClickedSurveyType(0)
                SrViewModel.tabType(tabType);

                SrViewModel.tabTypeDetails([]);
                for (var i = 0; i < SrViewModel.SurveyTypesList()[1].length; i++) {
                    if (SrViewModel.SurveyTypesList()[1][i].TabId === tabId) {
                        SrViewModel.tabTypeDetails(SrViewModel.SurveyTypesList()[1][i]);
                        break;
                    }
                }

                if (level == 1) {
                    SrViewModel.AssessmentTypeId(tableUID);
                }
                var childTabList = SrViewModel.SurveyTypesList()[tabId];

                if (SrViewModel.SocType() === 'Overall') {
                    var ttype = "HEATMAP_TYPE1";
                    if (SrViewModel.AssessmentType() == 2)
                        ttype = "HEATMAP_TYPE2";

                    SrViewModel.SelectedBUs('');

                    if (childTabList != undefined && childTabList.length > 0) {
                        if (SrViewModel.SubOrgLevelList() != undefined) {
                            for (k = 0; k < SrViewModel.SubOrgLevelList().length; k++) {
                                var itemTo = ({
                                    'Level': 1,
                                    'ParentUID': 1,
                                    'TabId': SrViewModel.SubOrgLevelList()[k].BusinessLevelId(),
                                    'TabName': SrViewModel.SubOrgLevelList()[k].BusinessLevelName(),
                                    'TabType': ttype,
                                    'TableUID': -1
                                });
                                    childTabList.splice(k + 1, 0, itemTo);
                            }
                        }
                    }
                }

                if (childTabList && childTabList.length > 0 && level < 2) {

                    var href = 'Level' + (level + 1);
                    var tabTemplate = `<div class="nav-tabs-custom">
                    <ul id="ComponentTabs" class="nav nav-tabs tab-margin">`;
                    for (var j = 0; j < childTabList.length; j++) {
                        tabTemplate += `<li class="" data-bind="click: function() {$root.createTab(` + childTabList[j].TabId + `,` + (childTabList[j].Level + 1) + `,` + childTabList[j].TableUID + `,'` + childTabList[j].TabType + `')}">
                         <a href="#`+ href + `" data-bind="text: '` + childTabList[j].TabName + `'"></a>
                        </li>`;
                    }
                    tabTemplate += `</ul></div > <div id="` + href + `"></div> `;

                    ko.cleanNode(document.getElementById('Level' + level));
                    document.getElementById('Level' + level).innerHTML = tabTemplate;
                    ko.applyBindings(SrViewModel, document.getElementById('Level' + level));
                    $($('#Level' + level + ' li').get(0)).trigger('click');
                    $($('#Level' + level + ' li').get(0)).addClass('active');
                    $('#' + SrViewModel.CurrentRATtype()).addClass('active');

                } else {

                    SrViewModel.contentTabVisible(false);
                    document.getElementById('Level' + level).innerHTML = "";
                    $('#ComponentTabs li').removeClass('active');
                    $('#adddivtabdiv li').removeClass('active');
                    $('#' + tabType).addClass('active');
                    event.currentTarget.className = 'active';
                    $('#Level' + level + ' li').addClass('active');
                    $('#' + SrViewModel.CurrentRATtype()).addClass('active');

                    if (tabType && (tabType.indexOf('HEATMAP') >= 0)) {
                        SrViewModel.ORG_TabID(0);
                        if ((tableUID == -5 || tableUID == -1) && tabId != 2)
                            SrViewModel.ORG_TabID(tabId)   // only for overall socio survey - ORG_TabID = 0 for BUs and EBL_UID for Org Levels
                        GetAllHeatmapData();
                        $("#heatMapType2Socialization").show();
                    }
                    else if (tabType && (tabType.indexOf('REQUESTS') >= 0)) {
                        $("#heatMapType2Socialization").hide();
                        SrViewModel.TaxonomyLevelListFlag(true);
                        $("#TaxonomyLevelsId").val("")
                        GetOverridesData();
                    }
                    else if (tabType && (tabType.indexOf('SURVEY GROUP') >= 0)) {
                        SrViewModel.TaxonomyLevelListFlag(true);
                        SrViewModel.contentTabVisible(true);
                        SrViewModel.ClickedSurveyType(-99999)

                        $(".nav-tabs a").click(function () {
                            $(this).tab('show');
                        });

                        //////////////////////
                        $("#divNavSwitch2").hide();
                        $('#searchFeature').val('');
                        $("#heatMapType2Socialization").hide();


                        var tabName = SrViewModel.tabTypeDetails().TabName;
                        if (tabName.toLocaleLowerCase().indexOf("internal") != -1 || tabName.toLocaleLowerCase().indexOf("external") != -1 || tabName.toLocaleLowerCase().indexOf("qualitative") != -1) {
                            SrViewModel.ClickedQualType('');
                            if (tabName.toLocaleLowerCase().indexOf("internal") != -1) {
                                SrViewModel.ClickedQualType("Internal");
                            }
                            else if (tabName.toLocaleLowerCase().indexOf("external") != -1) {
                                SrViewModel.ClickedQualType("External");
                            } else if (tabName.toLocaleLowerCase().indexOf("qualitative") != -1) {
                                SrViewModel.ClickedQualType("Qualitative");
                            }

                            SrViewModel.ClickedSurveyTypeText('qldr');
                            SrViewModel.Zat_id_Tree(tableUID);

                            InitiateLevelTree();

                        } else if (tabName.toLocaleLowerCase().indexOf("controls") != -1) {
                            SrViewModel.ClickedSurveyTypeText('cdr');
                            SrViewModel.Zat_id_Tree(tableUID);
                            InitiateLevelTree();
                        }

                    }

                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: createTab() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function GetInstructions(TableId) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getAllInstructions = {
                    url: "/api/Configuration/GetInstructions",
                    type: "POST",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        "AreaId": SrViewModel.SurveyId(),
                        "AreaType": SrViewModel.SurveyClassification(),
                        "Type": "SOC-B",
                        "SurveyId": SrViewModel.SurveyId(),
                        "ZATId": SrViewModel.AssessmentTypeId() // this param sends RAT_ID for socialization
                    }),
                    headers: headers
                };
                return $.ajax(getAllInstructions)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetInstructions() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    SrViewModel.Instructions('');
                    $('#AreaInstructionsDiv').hide();
                    if (jsonResult !== null && jsonResult.Instruction != "") {
                        if (jsonResult.AreaId == -99) {
                            logger.logError(jsonResult.AreaType + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                        }
                        else {
                            SrViewModel.Instructions(jsonResult.Instruction);
                            $('#AreaInstructionsDiv').show();
                        }
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                    }
                } catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetInstructions() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [(!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetInstructions() method in SocializationResponse.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail in GetInstructions() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            }
        }

        function showMoreInstructions() {
            try {
                if ($('#InstructionsMoreBtn').is(':visible')) {
                    $('#InstructionsMoreBtn').hide();
                    $('#InstructionsLessBtn').show();
                    $('#AreaInstructionsInnerDiv').removeClass("text-truncate-inst");
                    $('#AreaInstructionsInnerDiv').attr("style", "max-height:");
                }
                else {
                    $('#InstructionsLessBtn').hide();
                    $('#InstructionsMoreBtn').show();
                    $('#AreaInstructionsInnerDiv').addClass("text-truncate-inst");
                    $('#AreaInstructionsInnerDiv').attr("style", "max-height:10vh !important;");
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: showMoreInstructions() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function GetOverridesData() {
            try {
                return $.ajax({
                    url: "/api/HeatMap/GetOverrideRequests?deRatUid=" + SrViewModel.BusinessUnitId(),
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                }).success(function (jsonResult, success) {
                    if (jsonResult != null) {

                        if (jsonResult.ErrorId == -99) {
                            logger.logError(jsonResult.ErrorCode + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                        }
                        else {
                            if ($.fn.dataTable.isDataTable('#tblOverrideRequests')) {
                                $('#tblOverrideRequests').DataTable().destroy();
                                $('#tblOverrideRequests tbody tr').remove();
                            }
                            if ($.fn.dataTable.isDataTable('#tblOverrideRequestsRecal')) {
                                $('#tblOverrideRequestsRecal').DataTable().destroy();
                                $('#tblOverrideRequestsRecal tbody tr').remove();
                            }
                            if (jsonResult.overrideReqModel) {
                                mappedReqData = $.map(jsonResult.overrideReqModel, function (result) {
                                    return new requestModel(result);
                                });
                                SrViewModel.overrideRequestList(mappedReqData);
                            }

                            if (jsonResult.overrideReqModelReCal) {
                                mappedReqRCData = $.map(jsonResult.overrideReqModelReCal, function (result) {
                                    return new requestModel(result);
                                });
                                SrViewModel.overrideRequestListRecal(mappedReqRCData);
                            }

                            if (jsonResult.overrideActionModel) {
                                SrViewModel.overrideActionList(jsonResult.overrideActionModel);
                            }
                            SrViewModel.contentTabVisible(true);
                            overrideDataTableReInitialize();
                        }
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                    }
                }).fail(function (error, status) {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetOverridesData() method in SocializationResponse.js';
                        logger.logMessage(msg);
                    }
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetOverridesData() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function GetAllHeatmapData() {
            try {
                $('#heatMapType2Socialization').hide();
                $('#heatMapAMLSocialization').hide();
                $('#loadingImgOrCalc').show();
                ClearSearchText();
                if (SrViewModel.AssessmentTypeId()) {
                    var DynamicUrl = '';
                    if (SrViewModel.SelectedBUs() === undefined)
                        SrViewModel.SelectedBUs('');

                    if (SrViewModel.ORG_TabID() == undefined)
                        SrViewModel.ORG_TabID(0);

                    if (SrViewModel.SelectedTaxonomyOption() == undefined || SrViewModel.SelectedTaxonomyOption() == null) {
                        SrViewModel.SelectedTaxonomyOption(0);
                       // DynamicUrl = "/api/HeatMap/GetHeatMapDataSocialization?SelectedDERATs=" + SrViewModel.SelectedBUs() + '&Assessment_ID=' + SrViewModel.AssessmentTypeId() + '&Level_ID=' + '' + '&AssessmentType=' + SrViewModel.AssessmentType() + '&RiskType=' + SrViewModel.RiskType() + '&ORG_TabID=' + SrViewModel.ORG_TabID();
                    }

                    DynamicUrl = "/api/HeatMap/GetHeatMapDataSocialization?SelectedDERATs=" + SrViewModel.SelectedBUs() + '&Assessment_ID=' + SrViewModel.AssessmentTypeId() + '&Level_ID=' + SrViewModel.SelectedTaxonomyOption() + '&AssessmentType=' + SrViewModel.AssessmentType() + '&RiskType=' + SrViewModel.RiskType() + '&ORG_TabID=' + SrViewModel.ORG_TabID();

                    return $.ajax({
                        url: DynamicUrl,
                        type: "GET",
                        headers: appsecurity.getSecurityHeaders()
                    }).success(function (jsonResult, success) {
                        if (jsonResult != null) {

                            if (jsonResult.ErrorId == -99) {
                                logger.logError(jsonResult.ErrorCode + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else {
                                $('#noHeatmapavailable').hide();
                                SrViewModel.ShowHeatmapScore(false);

                                // Map Business Units.
                                if (jsonResult.businessUnitsModel.length > 0) {
                                    var mappedBusinessUnitData = $.map(jsonResult.businessUnitsModel, function (result) {
                                        return new BusinessUnitModel(result);
                                    });
                                    SrViewModel.ResHeatMapData([]);
                                    SrViewModel.ResHeatMapDataDUP([]);
                                    SrViewModel.ResHeatMapData(mappedBusinessUnitData);
                                    SrViewModel.ResHeatMapDataDUP(mappedBusinessUnitData);
                                    SrViewModel.ShowFinalLevel(jsonResult.businessUnitsModel[0].ShowFinalLevel);
                                    SrViewModel.ShowApplicableFilter(jsonResult.businessUnitsModel[0].ShowApplicableFilter);
                                }

                                SrViewModel.editableTypes([]);
                                if (jsonResult.ResponseTypesModel.length > 0) {
                                    var mappedResponseListData = $.map(jsonResult.ResponseTypesModel, function (result) {
                                        return new ResponseColumnsModel(result);
                                    });
                                    SrViewModel.editableTypes(mappedResponseListData);
                                }

                                SrViewModel.Multilist(jsonResult.Multilist);

                                if (SrViewModel.AssessmentType() != 2) {
                                    SrViewModel.AMLContMultilist([])
                                    SrViewModel.AMLContMultilist(jsonResult.AMLContMultilist);
                                }

                                SrViewModel.ColspanValue([]);
                                SrViewModel.ColspanValue(SrViewModel.editableTypes().length - 1);

                                if (SrViewModel.AssessmentType() == 2 && SrViewModel.RiskType() == "ALL" && SrViewModel.ShowFinalLevel())
                                    SrViewModel.ColspanValue(SrViewModel.editableTypes().length - 3);


                                if (SrViewModel.RiskType() != "ALL") {

                                    if (SrViewModel.RiskType() === "I") {
                                        SrViewModel.OrgAUConlspanInh(SrViewModel.editableTypes().length - 1);
                                        SrViewModel.showInherent(true);
                                        SrViewModel.showControl(false);
                                        SrViewModel.showResidual(false);
                                        $('#filter li a').removeClass("active");
                                        $('#FilterInh').addClass("active");
                                    } else if (SrViewModel.RiskType() === "C") {
                                        SrViewModel.OrgAUConlspanCont(SrViewModel.editableTypes().length - 1);
                                        SrViewModel.showInherent(false);
                                        SrViewModel.showControl(true);
                                        SrViewModel.showResidual(false);
                                        $('#filter li a').removeClass("active");
                                        $('#FilterCnt').addClass("active");
                                    } else if (SrViewModel.RiskType() === "R") {
                                        SrViewModel.OrgAUConlspanRes(SrViewModel.editableTypes().length - 1);
                                        SrViewModel.showInherent(false);
                                        SrViewModel.showControl(false);
                                        SrViewModel.showResidual(true);
                                        $('#filter li a').removeClass("active");
                                        $('#FilterRes').addClass("active");
                                    }
                                }
                                else {
                                    SrViewModel.OrgAUConlspanInh(2);
                                    SrViewModel.OrgAUConlspanCont(2);
                                    SrViewModel.OrgAUConlspanRes(2);

                                    SrViewModel.showInherent(true);
                                    SrViewModel.showControl(false);
                                    SrViewModel.Cntstate(false);
                                    SrViewModel.Resstate(false);
                                    SrViewModel.showResidual(false);
                                    $('#filter li a').removeClass("active");
                                    $('#FilterAll').addClass("active");
                                }

                                SrViewModel.InhColumnFlag(true);
                                SrViewModel.ContColumnFlag(true);
                                SrViewModel.ResColumnFlag(true);

                                if (SrViewModel.AssessmentType() == 2) {
                                    SrViewModel.CRAAggregateBUInformation([]);
                                    if (jsonResult.BuAggHeatMapDataSocialization != null && jsonResult.BuAggHeatMapDataSocialization != undefined) {
                                        if (jsonResult.BuAggHeatMapDataSocialization.length > 0) {
                                            SrViewModel.CRAAggregateBUInformation(jsonResult.BuAggHeatMapDataSocialization);
                                        }
                                    }

                                    if (jsonResult.HeatmapSFGModel != null && jsonResult.HeatmapSFGModel != undefined) {
                                        if (jsonResult.HeatmapSFGModel.length > 0) {
                                            SrViewModel.InhRiskThemeDetails(jsonResult.HeatmapSFGModel);
                                        }
                                    }

                                    $('#heatMapType2Socialization').show();

                                    SrViewModel.showInherent(true);
                                    SrViewModel.showControl(false);
                                    SrViewModel.showResidual(false);
                                }
                                else { //for aml
                                    SrViewModel.AggregateBUDetailsInherent([]);
                                    if (jsonResult.InherentBuAggHeatMapDataSocialization != null && jsonResult.InherentBuAggHeatMapDataSocialization != undefined) {
                                        if (jsonResult.InherentBuAggHeatMapDataSocialization.length > 0) {
                                            SrViewModel.AggregateBUDetailsInherent(jsonResult.InherentBuAggHeatMapDataSocialization);
                                            SrViewModel.inhHeatMapFinalData(jsonResult.InherentBuAggHeatMapDataSocialization);
                                        }
                                    }

                                    SrViewModel.AggregateBUDetailsControl([]);
                                    if (jsonResult.ControlBuAggHeatMapDataSocialization != null && jsonResult.ControlBuAggHeatMapDataSocialization != undefined) {
                                        if (jsonResult.ControlBuAggHeatMapDataSocialization.length > 0) {
                                            SrViewModel.AggregateBUDetailsControl(jsonResult.ControlBuAggHeatMapDataSocialization);
                                            SrViewModel.cntrlHeatMapFinalData(jsonResult.ControlBuAggHeatMapDataSocialization);

                                        }
                                    }

                                    SrViewModel.AggregateBUDetailsResidual([]);
                                    if (jsonResult.ResiduaBulHeatMapDataSocialization != null && jsonResult.ResiduaBulHeatMapDataSocialization != undefined) {
                                        if (jsonResult.ResiduaBulHeatMapDataSocialization.length > 0) {
                                            SrViewModel.AggregateBUDetailsResidual(jsonResult.ResiduaBulHeatMapDataSocialization);
                                            SrViewModel.residualHeatMapFinalData(jsonResult.ResiduaBulHeatMapDataSocialization);
                                        }
                                    }


                                    if (jsonResult.AMLInhHeatmapSFGModel != null && jsonResult.AMLInhHeatmapSFGModel != undefined) {
                                        if (jsonResult.AMLInhHeatmapSFGModel.length > 0) {
                                            SrViewModel.InhRiskThemeDetails(jsonResult.AMLInhHeatmapSFGModel);
                                        }
                                    }
                                    if (jsonResult.AMLContHeatmapSFGModel != null && jsonResult.AMLContHeatmapSFGModel != undefined) {
                                        if (jsonResult.AMLContHeatmapSFGModel.length > 0) {
                                            SrViewModel.ContRiskThemeDetails(jsonResult.AMLContHeatmapSFGModel);
                                        }
                                    }
                                    if (SrViewModel.RiskType() === "I") {
                                        SrViewModel.showInherent(true);
                                        SrViewModel.showControl(false);
                                        SrViewModel.showResidual(false);
                                    } else if (SrViewModel.RiskType() === "C") {
                                        SrViewModel.showInherent(false);
                                        SrViewModel.showControl(true);
                                        SrViewModel.showResidual(false);
                                    } else if (SrViewModel.RiskType() === "R") {
                                        SrViewModel.showInherent(false);
                                        SrViewModel.showControl(false);
                                        SrViewModel.showResidual(true);
                                    } else if (SrViewModel.RiskType() === "ALL") {
                                        SrViewModel.showInherent(true);
                                        SrViewModel.showControl(false);
                                        SrViewModel.showResidual(false);
                                        $("#spanCnh").addClass("fa-caret-right").removeClass("fa-caret-down");
                                        //$("#spanRes").addClass("fa-caret-right").removeClass("fa-caret-down");
                                    }

                                    $('#heatMapAMLSocialization').show();
                                }


                                SrViewModel.inhHeatMapDrpDwn(jsonResult.InhRiskDropDown);
                                SrViewModel.cntrlHeatMapDrpDwn(jsonResult.CntrlRiskDropDown);
                                SrViewModel.resHeatMapDrpDwn(jsonResult.ResidualRiskDropDown);
                                SrViewModel.inhFactorHeatMapDrpDwn(jsonResult.InhFactorDropDown);
                                SrViewModel.contentTabVisible(true);

                                $('#loadingImgOrCalc').hide();
                                //heatmapDataTableReInitialize();
                                ShowOnlyHighestLevelOnLoad();

                                if (SrViewModel.AssessmentType() != 2) { //AML
                                    $('#tblHeatMapSocializationAml tbody').scroll(function (e) {
                                        $('#tblHeatMapSocializationAml thead').css("left", -$("#tblHeatMapSocializationAml tbody").scrollLeft()); //fix the thead relative to the body scrolling
                                        $('#tblHeatMapSocializationAml thead th:nth-child(1)').css("left", $("#tblHeatMapSocializationAml tbody").scrollLeft()); //fix the first cell of the header
                                        $('#tblHeatMapSocializationAml tbody td:nth-child(1)').css("left", $("#tblHeatMapSocializationAml tbody").scrollLeft()); //fix the first column of tdbody
                                    });
                                } else {
                                    $('#tblHeatMapSocialization tbody').scroll(function (e) {
                                        $('#tblHeatMapSocialization thead').css("left", -$("#tblHeatMapSocialization tbody").scrollLeft()); //fix the thead relative to the body scrolling
                                        $('#tblHeatMapSocialization thead th:nth-child(1)').css("left", $("#tblHeatMapSocialization tbody").scrollLeft()); //fix the first cell of the header
                                        $('#tblHeatMapSocialization tbody td:nth-child(1)').css("left", $("#tblHeatMapSocialization tbody").scrollLeft()); //fix the first column of tdbody
                                    });

                                    //if (SrViewModel.InhRiskThemeDetails() != undefined) {

                                    //    SrViewModel.heatMapViewNA(true);

                                    //    for (var i = 0; i < SrViewModel.InhRiskThemeDetails().length; i++) {
                                    //        $(".taxo_" + SrViewModel.InhRiskThemeDetails()[i].Id).hide();
                                    //        $('#spandown' + SrViewModel.InhRiskThemeDetails()[i].Id).hide();
                                    //        $('#spanright' + SrViewModel.InhRiskThemeDetails()[i].Id).show();

                                    //        //if (SrViewModel.AssessmentType() == 2) {
                                    //        if (SrViewModel.heatMapViewNA() == true && (SrViewModel.InhRiskThemeDetails()[i].Show_Edit == false)) {
                                    //            $(".taxo_" + SrViewModel.InhRiskThemeDetails()[i].Id).hide();
                                    //        }
                                    //        else if (SrViewModel.InhRiskThemeDetails()[i].PId == 0) {
                                    //            $(".taxo_" + SrViewModel.InhRiskThemeDetails()[i].Id).show();
                                    //        }
                                    //        //}
                                    //    }
                                    //}
                                }
                            }
                        }

                        else {
                            $('#noHeatmapavailable').show();
                        }
                    });
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetAllHeatmapData() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function ShowOnlyHighestLevelOnLoad() {
            try {

                if (SrViewModel.InhRiskThemeDetails() != undefined) {
                    if (SrViewModel.InhRiskThemeDetails().length > 0) {
                        for (var m = 0; m < SrViewModel.InhRiskThemeDetails().length; m++) {
                            if (SrViewModel.InhRiskThemeDetails()[m].LevelId != 1) { //Highest level will always be 1 like for themes
                                $(".taxo_" + SrViewModel.InhRiskThemeDetails()[m].Id).hide();
                            } else {
                                $("#spandown" + SrViewModel.InhRiskThemeDetails()[m].Id).hide();
                                $("#spanright" + SrViewModel.InhRiskThemeDetails()[m].Id).show();
                            }
                        }
                    }
                }

                if (SrViewModel.ContRiskThemeDetails() != undefined) {
                    if (SrViewModel.ContRiskThemeDetails().length > 0) {
                        for (var m = 0; m < SrViewModel.ContRiskThemeDetails().length; m++) {
                            if (SrViewModel.ContRiskThemeDetails()[m].LevelId != 1) {
                                $(".taxo_" + SrViewModel.ContRiskThemeDetails()[m].Id).hide();
                            } else {
                                $("#spandown" + SrViewModel.ContRiskThemeDetails()[m].Id).hide();
                                $("#spanright" + SrViewModel.ContRiskThemeDetails()[m].Id).show();
                            }
                        }
                    }
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowOnlyHighestLevelOnLoad() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function ResponseColumnsModel(item) {
            try {
                var self = this;
                self.ResponseId = ko.observable(item.ZAT_ID);
                self.ResponseType = ko.observable(item.DISPLAY_NAME);
                self.ShowFlag = ko.observable(item.ZAT_SHOW);
                self.colId = ko.observable(item.ZAT_TYPE);
                self.ColType = ko.observable(item.ZAT_TYPE_SECONDARY);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResponseColumnsModel() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function BusinessUnitModel(item) {
            try {
                var self = this;
                self.BU_ID = ko.observable(item.BU_ID);
                self.BU_NAME = ko.observable($('<div/>').html(item.BU_NAME).text());
                self.BusinessUnitId = ko.observable($('<div/>').html(item.BuId).text());
                self.BusinessUnitName = ko.observable($('<div/>').html(item.BuName).text());
                self.Colstate = true;
                self.Colspan = "3";
                var value = item.BU_NAME
                var buVal = "";
                if (item.BU_NAME === undefined) {
                    buVal = item.BuName;
                } else {
                    buVal = item.BU_NAME;
                }
                if (buVal != undefined && buVal.length > 50) {
                    value = buVal.substring(0, 50) + '...';
                } else {
                    var space = buVal.length;
                    var spaceText = '';
                    for (j = 0; j < 5 - space; j++) {
                        spaceText += '&nbsp';
                    }
                    value = spaceText + buVal + spaceText;
                }

                self.BuName = ko.observable($('<div/>').html(value).text());

                self.AssessmentDate = ko.observable($('<div/>').html(item.BuAssessmentDate).text());
                self.BuStatus = ko.observable($('<div/>').html(item.BuStatus).text());
                self.SubLevelId = ko.observable(item.SubLevelId);
                self.isChecked = ko.observable(false);
                //if (item.FINAL_Flag != undefined) {
                //    SrViewModel.ShowFinalData(item.FINAL_Flag);
                //}

            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: BusinessUnitModel() in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function clickLevel(data, event) {
            try {
                var areaIndex = -1;
                ko.utils.arrayFilter(SrViewModel.InhRiskThemeDetails(), function (arr) {
                    if (arr.Id === data.Id) {
                        areaIndex = ko.utils.arrayIndexOf(SrViewModel.InhRiskThemeDetails(), arr);
                    }
                });

                if (SrViewModel.InhRiskThemeDetails()[areaIndex].LevelState == true) {
                    // collapses the content
                    $("#spandown" + data.Id).hide();
                    $("#spanright" + data.Id).show();
                    if (SrViewModel.InhRiskThemeDetails() != undefined)
                        SrViewModel.InhRiskThemeDetails()[areaIndex].LevelState = false;

                    if (data.LevelId != data.MaxLevel) {
                        for (var i = 0; i < SrViewModel.Multilist().length; i++) {
                            if (data.LevelId > SrViewModel.Multilist()[i].LevelId && SrViewModel.Multilist()[i].childHeatMapData != null && SrViewModel.Multilist()[i].childHeatMapData.length > 0) {
                                LastLevelHide(SrViewModel.Multilist()[i].childHeatMapData, data);
                            } else if (data.LevelId == SrViewModel.Multilist()[i].LevelId) {
                                if (data.Id == SrViewModel.Multilist()[i].Id) {
                                    if (SrViewModel.Multilist()[i].childHeatMapData != null && SrViewModel.Multilist()[i].childHeatMapData.length > 0) {
                                        RepeatTillLastLevelHide(SrViewModel.Multilist()[i].childHeatMapData);
                                    }
                                }
                            }
                        }
                    }

                }
                else {
                    // expands the content
                    $("#spandown" + data.Id).show();
                    $("#spanright" + data.Id).hide();
                    if (SrViewModel.InhRiskThemeDetails() != undefined)
                        SrViewModel.InhRiskThemeDetails()[areaIndex].LevelState = true;


                    if (data.LevelId != data.MaxLevel) {
                        for (var i = 0; i < SrViewModel.Multilist().length; i++) {
                            if (data.LevelId > SrViewModel.Multilist()[i].LevelId && SrViewModel.Multilist()[i].childHeatMapData != null && SrViewModel.Multilist()[i].childHeatMapData.length > 0) {
                                LastLevelShow(SrViewModel.Multilist()[i].childHeatMapData, data);
                            } else if (data.LevelId == SrViewModel.Multilist()[i].LevelId) {
                                if (data.Id == SrViewModel.Multilist()[i].Id) {
                                    if (SrViewModel.Multilist()[i].childHeatMapData != null && SrViewModel.Multilist()[i].childHeatMapData.length > 0) {
                                        RepeatTillLastLevelShow(SrViewModel.Multilist()[i].childHeatMapData, data);
                                    }
                                }
                            }
                        }
                    }

                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: clickLevel() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function clickLevelCntrl(data, event) {
            try {
                var areaIndex = -1;
                ko.utils.arrayFilter(SrViewModel.ContRiskThemeDetails(), function (arr) {
                    if (arr.Id === data.Id) {
                        areaIndex = ko.utils.arrayIndexOf(SrViewModel.ContRiskThemeDetails(), arr);
                    }
                });

                if (SrViewModel.ContRiskThemeDetails()[areaIndex].LevelState == true) {
                    // collapses the content
                    $("#spandown" + data.Id).hide();
                    $("#spanright" + data.Id).show();
                    if (SrViewModel.ContRiskThemeDetails() != undefined)
                        SrViewModel.ContRiskThemeDetails()[areaIndex].LevelState = false;

                    if (data.LevelId != data.MaxLevel) {
                        for (var i = 0; i < SrViewModel.AMLContMultilist().length; i++) {
                            if (data.LevelId > SrViewModel.AMLContMultilist()[i].LevelId && SrViewModel.AMLContMultilist()[i].childHeatMapData != null && SrViewModel.AMLContMultilist()[i].childHeatMapData.length > 0) {
                                LastLevelHide(SrViewModel.AMLContMultilist()[i].childHeatMapData, data);
                            } else if (data.LevelId == SrViewModel.AMLContMultilist()[i].LevelId) {
                                if (data.Id == SrViewModel.AMLContMultilist()[i].Id) {
                                    if (SrViewModel.AMLContMultilist()[i].childHeatMapData != null && SrViewModel.AMLContMultilist()[i].childHeatMapData.length > 0) {
                                        RepeatTillLastLevelHide(SrViewModel.AMLContMultilist()[i].childHeatMapData);
                                    }
                                }
                            }
                        }
                    }

                }
                else {
                    // expands the content
                    $("#spandown" + data.Id).show();
                    $("#spanright" + data.Id).hide();
                    if (SrViewModel.ContRiskThemeDetails() != undefined)
                        SrViewModel.ContRiskThemeDetails()[areaIndex].LevelState = true;


                    if (data.LevelId != data.MaxLevel) {
                        for (var i = 0; i < SrViewModel.AMLContMultilist().length; i++) {
                            if (data.LevelId > SrViewModel.AMLContMultilist()[i].LevelId && SrViewModel.AMLContMultilist()[i].childHeatMapData != null && SrViewModel.AMLContMultilist()[i].childHeatMapData.length > 0) {
                                LastLevelShow(SrViewModel.AMLContMultilist()[i].childHeatMapData, data);
                            } else if (data.LevelId == SrViewModel.AMLContMultilist()[i].LevelId) {
                                if (data.Id == SrViewModel.AMLContMultilist()[i].Id) {
                                    if (SrViewModel.AMLContMultilist()[i].childHeatMapData != null && SrViewModel.AMLContMultilist()[i].childHeatMapData.length > 0) {
                                        RepeatTillLastLevelShow(SrViewModel.AMLContMultilist()[i].childHeatMapData, data);
                                    }
                                }
                            }
                        }
                    }

                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: clickLevelCntrl() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function RepeatTillLastLevelShow(multiListData, clickedDataRow) {
            try {
                if (multiListData.length > 0) {
                    for (var j = 0; j < multiListData.length; j++) {

                        $(".taxo_" + multiListData[j].Id).show();
                        $('#spandown' + multiListData[j].Id).show();
                        $('#spanright' + multiListData[j].Id).hide();
                        //if (SrViewModel.AssessmentType() == 2)  && (SrViewModel.heatMapViewNA() && !multiListData[j].Show_Edit)) {
                        //    $(".taxo_" + multiListData[j].Id).hide();
                        //}

                        if (multiListData[j].childHeatMapData != null && multiListData[j].childHeatMapData.length > 0) {
                            RepeatTillLastLevelShow(multiListData[j].childHeatMapData, clickedDataRow);
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in RepeatTillLastLevel() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function RepeatTillLastLevelHide(multiListData) {
            try {
                if (multiListData.length > 0) {
                    for (var j = 0; j < multiListData.length; j++) {
                        $(".taxo_" + multiListData[j].Id).hide();
                        if (multiListData[j].childHeatMapData != null && multiListData[j].childHeatMapData.length > 0) {
                            RepeatTillLastLevelHide(multiListData[j].childHeatMapData);
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in RepeatTillLastLevelHide() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function LastLevelShow(dataObjChild, clickedDataRow) {
            try {
                for (var i = 0; i < dataObjChild.length; i++) {
                    if (clickedDataRow.LevelId == dataObjChild[i].LevelId && clickedDataRow.Id == dataObjChild[i].Id) {
                        RepeatTillLastLevelShow(dataObjChild[i].childHeatMapData, clickedDataRow);
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in LastLevelShow() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function LastLevelHide(dataObjChild, clickedDataRow) {
            try {
                for (var i = 0; i < dataObjChild.length; i++) {
                    if (clickedDataRow.LevelId == dataObjChild[i].LevelId && clickedDataRow.Id == dataObjChild[i].Id) {
                        RepeatTillLastLevelHide(dataObjChild[i].childHeatMapData);
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in LastLevelHide() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function ResetSearch_Main() {
            try {
                SrViewModel.Query('');
                if (SrViewModel.InhRiskThemeDetails() != undefined) {
                    for (var i = 0; i < SrViewModel.InhRiskThemeDetails().length; i++) {
                        $(".taxo_" + SrViewModel.InhRiskThemeDetails()[i].Id).show();
                        $('#spandown' + SrViewModel.InhRiskThemeDetails()[i].Id).show();
                        $('#spanright' + SrViewModel.InhRiskThemeDetails()[i].Id).hide();

                        if (SrViewModel.AssessmentType() == 2) { // && (SrViewModel.heatMapViewNA() && !SrViewModel.InhRiskThemeDetails()[i].Show_Edit)) {
                            $(".taxo_" + SrViewModel.InhRiskThemeDetails()[i].Id).hide();
                        } 
                    }
                }
                if (SrViewModel.AssessmentType() != 2) {
                    if (SrViewModel.ContRiskThemeDetails() != undefined) {
                        for (var j = 0; j < SrViewModel.ContRiskThemeDetails().length; j++) {
                            $(".taxo_" + SrViewModel.ContRiskThemeDetails()[j].Id).show();
                            $('#spandown' + SrViewModel.ContRiskThemeDetails()[j].Id).show();
                            $('#spanright' + SrViewModel.ContRiskThemeDetails()[j].Id).hide();
                        }
                    }
                }
                $('#expandA').hide();
                $('#collapseA').show();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResetSearch_Main() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function SearchResult_Main() {
            try {

                if (SrViewModel.AssessmentType() != 2) {
                    SearchResult_MainAML();
                } else {
                    if (SrViewModel.InhRiskThemeDetails() != undefined && SrViewModel.InhRiskThemeDetails().length > 0) {
                        var searchedList = '';
                        var q = SrViewModel.Query();

                        searchedList = ko.utils.arrayFilter(SrViewModel.InhRiskThemeDetails(), function (item) {
                            if (q != "") {
                                if (item.Name.toLowerCase().indexOf(q.toLowerCase()) >= 0) {
                                    return item.Name.toLowerCase().indexOf(q.toLowerCase()) >= 0;
                                }
                            }
                        });

                        for (var i = 0; i < SrViewModel.InhRiskThemeDetails().length; i++) {
                            $(".taxo_" + SrViewModel.InhRiskThemeDetails()[i].Id).hide();
                        }

                        if (SrViewModel.Query() != undefined && SrViewModel.Query() == "") {
                            //for empty keyboard input
                            for (var i = 0; i < SrViewModel.InhRiskThemeDetails().length; i++) {
                                //if ((SrViewModel.heatMapViewNA() && SrViewModel.InhRiskThemeDetails()[i].Show_Edit) || (!SrViewModel.heatMapViewNA())) {
                                    $(".taxo_" + SrViewModel.InhRiskThemeDetails()[i].Id).show();
                                    $('#spandown' + SrViewModel.InhRiskThemeDetails()[i].Id).show();
                                    $('#spanright' + SrViewModel.InhRiskThemeDetails()[i].Id).hide();
                                //}
                            }
                        }
                        if (searchedList != undefined) {
                            for (var j = 0; j < searchedList.length; j++) {
                                for (var i = 0; i < SrViewModel.InhRiskThemeDetails().length; i++) {
                                    if (SrViewModel.InhRiskThemeDetails()[i].Id == searchedList[j].Id) { // && ((SrViewModel.heatMapViewNA() && SrViewModel.InhRiskThemeDetails()[i].Show_Edit) || (!SrViewModel.heatMapViewNA()))) {
                                        $(".taxo_" + SrViewModel.InhRiskThemeDetails()[i].Id).show();
                                        $('#spandown' + SrViewModel.InhRiskThemeDetails()[i].Id).show();
                                        $('#spanright' + SrViewModel.InhRiskThemeDetails()[i].Id).hide();
                                    }
                                }
                            }
                        }
                        for (var i = 0; i < searchedList.length; i++) {
                            if (searchedList[i].LevelId < searchedList[i].MaxLevel) {
                                ko.utils.arrayFilter(SrViewModel.InhRiskThemeDetails(), function (param) {
                                    if (param.PId === searchedList[i].Id) { // && ((SrViewModel.heatMapViewNA() && SrViewModel.InhRiskThemeDetails()[i].Show_Edit) || (!SrViewModel.heatMapViewNA()))) {
                                        $(".taxo_" + param.Id).show();
                                        $('#spandown' + param.Id).show();
                                        $('#spanright' + param.Id).hide();
                                        IterateSearch(param.Id);
                                        //return true;
                                    }
                                });
                            }// < then max level
                        }
                    }
                    $('#expandA').hide();
                    $('#collapseA').show();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SearchResult_Main() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function IterateSearch(childId) {
            try {
                if (SrViewModel.InhRiskThemeDetails() != undefined && SrViewModel.InhRiskThemeDetails().length > 0) {
                    ko.utils.arrayFilter(SrViewModel.InhRiskThemeDetails(), function (param) {
                        if (param.PId === childId) {
                            IterateSearch(param.Id);
                            $(".taxo_" + param.Id).show();
                            $('#spandown' + param.Id).show();
                            $('#spanright' + param.Id).hide();
                            //return true;
                        }
                    });
                }
                if (SrViewModel.ContRiskThemeDetails() != undefined && SrViewModel.ContRiskThemeDetails().length > 0) {

                    ko.utils.arrayFilter(SrViewModel.ContRiskThemeDetails(), function (param) {
                        if (param.PId === childId) {
                            IterateSearch(param.Id);
                            $(".taxo_" + param.Id).show();
                            $('#spandown' + param.Id).show();
                            $('#spanright' + param.Id).hide();
                        }
                    });
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: IterateSearch() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function AMLChildrenVisible(List, flag) {
            try {
                for (var i = 0; i < List.length; i++) {
                    if (flag) {
                        $(".taxo_" + List[i].Id).show();
                        $('#spandown' + List[i].Id).show();
                        $('#spanright' + List[i].Id).hide();
                    } else {
                        $(".taxo_" + List[i].Id).hide();
                        $('#spanright' + List[i].Id).show();
                        $('#spandown' + List[i].Id).hide();
                    }
                    if (List[i].childHeatMapData != undefined && List[i].childHeatMapData.length > 0) {
                        AMLChildrenVisible(List[i].childHeatMapData, flag);
                    }
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AMLChildrenVisible() method in SocializationResponse.js';
                logger.logMessage(msg);
            }

        }

        function SearchResult_MainAML() {
            try {
                //inherent
                if (SrViewModel.RiskType() == 'I' || SrViewModel.RiskType() == 'ALL') {
                    if (SrViewModel.InhRiskThemeDetails() != undefined && SrViewModel.InhRiskThemeDetails().length > 0) {
                        var searchedList = '';
                        var q = SrViewModel.Query();

                        searchedList = ko.utils.arrayFilter(SrViewModel.InhRiskThemeDetails(), function (item) {
                            if (q != "") {
                                if (item.Name.toLowerCase().indexOf(q.toLowerCase()) >= 0) {
                                    return item.Name.toLowerCase().indexOf(q.toLowerCase()) >= 0;
                                }
                            }
                        });

                        for (var i = 0; i < SrViewModel.Multilist().length; i++) {
                            $(".taxo_" + SrViewModel.Multilist()[i].Id).hide();
                            $('#spandown' + SrViewModel.Multilist()[i].Id).hide();
                            $('#spanright' + SrViewModel.Multilist()[i].Id).show();
                            if (SrViewModel.Multilist()[i].childHeatMapData != undefined && SrViewModel.Multilist()[i].childHeatMapData.length > 0) {
                                AMLChildrenVisible(SrViewModel.Multilist()[i].childHeatMapData, false);
                            }
                        }

                        if (SrViewModel.Query() != undefined && SrViewModel.Query() == "") {
                            //for empty keyboard input
                            for (var i = 0; i < SrViewModel.Multilist().length; i++) {
                                $(".taxo_" + SrViewModel.Multilist()[i].Id).show();
                                $('#spanright' + SrViewModel.Multilist()[i].Id).hide();
                                $('#spandown' + SrViewModel.Multilist()[i].Id).show();
                                if (SrViewModel.Multilist()[i].childHeatMapData != undefined && SrViewModel.Multilist()[i].childHeatMapData.length > 0) {
                                    AMLChildrenVisible(SrViewModel.Multilist()[i].childHeatMapData, true);
                                }
                            }
                        }
                        if (searchedList != undefined) {
                            for (var j = 0; j < searchedList.length; j++) {
                                for (var i = 0; i < SrViewModel.InhRiskThemeDetails().length; i++) {
                                    if (SrViewModel.InhRiskThemeDetails()[i].Id == searchedList[j].Id) {

                                        $(".taxo_" + SrViewModel.InhRiskThemeDetails()[i].Id).show();
                                        $('#spandown' + SrViewModel.InhRiskThemeDetails()[i].Id).show();
                                        $('#spanright' + SrViewModel.InhRiskThemeDetails()[i].Id).hide();
                                    }
                                }
                            }
                        }
                        for (var i = 0; i < searchedList.length; i++) {
                            if (searchedList[i].LevelId < searchedList[i].MaxLevel) {
                                ko.utils.arrayFilter(SrViewModel.InhRiskThemeDetails(), function (param) {
                                    if (param.PId === searchedList[i].Id) {
                                        $(".taxo_" + param.Id).show();
                                        $('#spandown' + param.Id).show();
                                        $('#spanright' + param.Id).hide();
                                        IterateSearch(param.Id);
                                    }
                                });
                            }// < then max level
                        }
                    }
                }
                //controls
                if (SrViewModel.RiskType() == 'C' || SrViewModel.RiskType() == 'ALL') {
                    if (SrViewModel.ContRiskThemeDetails() != undefined && SrViewModel.ContRiskThemeDetails().length > 0) {
                        var searchedList = '';
                        var q = SrViewModel.Query();

                        searchedList = ko.utils.arrayFilter(SrViewModel.ContRiskThemeDetails(), function (item) {
                            if (q != "") {
                                if (item.Name.toLowerCase().indexOf(q.toLowerCase()) >= 0) {
                                    return item.Name.toLowerCase().indexOf(q.toLowerCase()) >= 0;
                                }
                            }
                        });


                        for (var i = 0; i < SrViewModel.AMLContMultilist().length; i++) {
                            $(".taxo_" + SrViewModel.AMLContMultilist()[i].Id).hide();
                            $('#spandown' + SrViewModel.AMLContMultilist()[i].Id).hide();
                            $('#spanright' + SrViewModel.AMLContMultilist()[i].Id).show();
                            if (SrViewModel.AMLContMultilist()[i].childHeatMapData != undefined && SrViewModel.AMLContMultilist()[i].childHeatMapData.length > 0) {
                                AMLChildrenVisible(SrViewModel.AMLContMultilist()[i].childHeatMapData, false);
                            }
                        }

                        if (SrViewModel.Query() != undefined && SrViewModel.Query() == "") {
                            //for empty keyboard input
                            for (var i = 0; i < SrViewModel.AMLContMultilist().length; i++) {
                                $(".taxo_" + SrViewModel.AMLContMultilist()[i].Id).show();
                                $('#spanright' + SrViewModel.AMLContMultilist()[i].Id).hide();
                                $('#spandown' + SrViewModel.AMLContMultilist()[i].Id).show();
                                if (SrViewModel.AMLContMultilist()[i].childHeatMapData != undefined && SrViewModel.AMLContMultilist()[i].childHeatMapData.length > 0) {
                                    AMLChildrenVisible(SrViewModel.AMLContMultilist()[i].childHeatMapData, true);
                                }
                            }
                        }
                        if (searchedList != undefined) {
                            for (var j = 0; j < searchedList.length; j++) {
                                for (var i = 0; i < SrViewModel.ContRiskThemeDetails().length; i++) {
                                    if (SrViewModel.ContRiskThemeDetails()[i].Id == searchedList[j].Id) {

                                        $(".taxo_" + SrViewModel.ContRiskThemeDetails()[i].Id).show();
                                        $('#spandown' + SrViewModel.ContRiskThemeDetails()[i].Id).show();
                                        $('#spanright' + SrViewModel.ContRiskThemeDetails()[i].Id).hide();
                                    }
                                }
                            }
                        }
                        for (var i = 0; i < searchedList.length; i++) {
                            if (searchedList[i].LevelId < searchedList[i].MaxLevel) {
                                ko.utils.arrayFilter(SrViewModel.ContRiskThemeDetails(), function (param) {
                                    if (param.PId === searchedList[i].Id) {
                                        $(".taxo_" + param.Id).show();
                                        $('#spandown' + param.Id).show();
                                        $('#spanright' + param.Id).hide();
                                        IterateSearch(param.Id);
                                        //return true;
                                    }
                                });
                            }// < then max level
                        }
                    }
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SearchResult_MainAML() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function overrideDataTableReInitialize() {
            try {
                if ($.fn.dataTable.isDataTable('#tblOverrideRequests')) {
                    $('#tblOverrideRequests').dataTable().fnClearTable();
                }
                $('#tblOverrideRequests').DataTable(
                    {
                        "autoWidth": true,
                        "bSort": false,
                        //scrollY: "380px",
                        scrollX: false,
                        scrollCollapse: true,
                        bFilter: false,
                        paging: false,
                        "bInfo": false,
                        fixedHeader: {
                            header: true
                        }
                    });

                if ($.fn.dataTable.isDataTable('#tblOverrideRequestsRecal')) {
                    $('#tblOverrideRequestsRecal').dataTable().fnClearTable();
                }
                $('#tblOverrideRequestsRecal').DataTable(
                    {
                        //"aLengthMenu": [60, 20, 20],
                        "bSort": false,
                        //scrollY: "380px",
                        scrollX: false,
                        scrollCollapse: true,
                        bFilter: false,
                        paging: false,
                        "bInfo": false,
                        fixedHeader: {
                            header: true
                        }
                    });
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: overrideDataTableReInitialize() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function heatmapDataTableReInitialize() {
            try {
                if (SrViewModel.tabType() == 'HEATMAP_TYPE1') {
                    SrViewModel.inhHeatMapDataList([]);

                    //Areas of change logic
                    if (SrViewModel.SelectedTaxonomyOptionRefresh() != -9999) {
                        SrViewModel.inhHeatMapDataList(SrViewModel.inhHeatMapDataListDUP());
                    } else {
                        if (SrViewModel.inhHeatMapDataListDUPRaw() !== null) {
                            mappedInhData = $.map(SrViewModel.inhHeatMapDataListDUPRaw(), function (result) {
                                return new heatMapDataChangeModel(result);
                            });
                            SrViewModel.inhHeatMapDataList(mappedInhData);
                        }
                        else
                            SrViewModel.inhHeatMapDataList(null);
                    }

                    SrViewModel.cntrlHeatMapDataList([]);
                    if (SrViewModel.SelectedTaxonomyOptionRefresh() != -9999) {
                        SrViewModel.cntrlHeatMapDataList(SrViewModel.cntrlHeatMapDataListDUP());
                    } else {
                        if (SrViewModel.cntrlHeatMapDataListDUPRaw() !== null) {
                            mappedInhData = $.map(SrViewModel.cntrlHeatMapDataListDUPRaw(), function (result) {
                                return new heatMapDataChangeModel(result);
                            });
                            SrViewModel.cntrlHeatMapDataList(mappedInhData);
                        }
                        else
                            SrViewModel.cntrlHeatMapDataList(null);

                    }

                    SrViewModel.residualHeatMapDataList([]);
                    //Areas of change logic
                    if (SrViewModel.SelectedTaxonomyOptionRefresh() != -9999) {
                        SrViewModel.residualHeatMapDataList(SrViewModel.residualHeatMapDataListDUP());
                    } else {
                        if (SrViewModel.residualHeatMapDataListDUPRaw() !== null) {
                            mappedInhData = $.map(SrViewModel.residualHeatMapDataListDUPRaw(), function (result) {
                                return new heatMapDataChangeModel(result);
                            });
                            SrViewModel.residualHeatMapDataList(mappedInhData);
                        }
                        else
                            SrViewModel.residualHeatMapDataList(null);
                    }

                }
                else if (SrViewModel.tabType() == 'HEATMAP_TYPE2') {
                    if (SrViewModel.SelectedTaxonomyOption() != -999) {

                        SrViewModel.inhHeatMapDataList([]);

                        //Areas of change logic
                        if (SrViewModel.SelectedTaxonomyOptionRefresh() != -9999) {
                            SrViewModel.inhHeatMapDataList(SrViewModel.inhHeatMapDataListDUP());
                        } else {
                            mappedInhData = $.map(SrViewModel.inhHeatMapDataListDUPRaw(), function (result) {
                                return new heatMapDataChangeModel(result);
                            });
                            SrViewModel.inhHeatMapDataList(mappedInhData);
                        }
                    }

                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: heatmapDataTableReInitialize() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function GetUser() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Reporting/GetUser",
                    type: "GET",
                    headers: headers,

                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetUser() method in SocializationResponse.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {

                    SrViewModel.User(jsonResult);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetUser() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetUser() method in SocializationResponse.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetUser() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            };
        }

        function heatMapSwitchNA() {
            try {
                SrViewModel.heatMapViewNA() == true ? SrViewModel.heatMapViewNA(false) : SrViewModel.heatMapViewNA(true);
                //SrViewModel.InhColumnFlag(false);
                //SrViewModel.OrgAUConlspanInh(1);
                //SrViewModel.ContColumnFlag(false);
                //SrViewModel.OrgAUConlspanCont(1);
                //SrViewModel.ResColumnFlag(false);
                //SrViewModel.OrgAUConlspanRes(1);

                ClearSearchText();

                if (SrViewModel.InhRiskThemeDetails() != undefined) {
                    for (var i = 0; i < SrViewModel.InhRiskThemeDetails().length; i++) {
                        $(".taxo_" + SrViewModel.InhRiskThemeDetails()[i].Id).hide();
                        $('#spandown' + SrViewModel.InhRiskThemeDetails()[i].Id).hide();
                        $('#spanright' + SrViewModel.InhRiskThemeDetails()[i].Id).show();

                        if (SrViewModel.AssessmentType() == 2) {
                            //if (SrViewModel.heatMapViewNA() == true && (SrViewModel.InhRiskThemeDetails()[i].Show_Edit == false)) {
                            //    $(".taxo_" + SrViewModel.InhRiskThemeDetails()[i].Id).hide();
                            //} else {
                            $(".taxo_" + SrViewModel.InhRiskThemeDetails()[i].Id).show();
                            $('#spandown' + SrViewModel.InhRiskThemeDetails()[i].Id).show();
                            $('#spanright' + SrViewModel.InhRiskThemeDetails()[i].Id).hide();
                            //}
                        }
                    }
                }

                $('#expandA').hide();
                $('#collapseA').show();
                //heatmapDataTableReInitialize();
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: heatMapSwitchNA() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function ShowScoreSwitch() {
            try {
                SrViewModel.ShowHeatmapScore(SrViewModel.ShowHeatmapScore() ? false: true);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowScoreSwitch() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function GetActions() {
            try {
                SrViewModel.PushbackComment('');
                SrViewModel.TimelineCommentsFlag(true);
                SrViewModel.RemainingChars(SrViewModel.OverrideCommentsCharsLimit());
                GetUsersRoleWFDetails().then(function () {
                    GetSocioActions().then(function () {
                        $('#divActionError').hide();
                        $('#ActionsPopUp').modal('show');
                    });
                });
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetActions() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function GetSocioActions() {
            try {
                SrViewModel.SurveyActionsListValidation([]);
                SrViewModel.SurveyActionsList([]);
                return $.ajax({
                    url: "/api/Configuration/GetActionsList?BuId=" + SrViewModel.BusinessUnitId() + "&RoleId=" + appsecurity.userInfo().PrimaryRoleId(),
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                }).success(function (jsonResult, success) {
                    var mappedActionsList;
                    if (jsonResult != null && jsonResult != undefined) {

                        if (jsonResult.ErrorId == -99) {
                            logger.logError(jsonResult.ErrorCode + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                        }
                        else {
                            if (jsonResult.validation != null) {
                                mappedActionsList = $.map(jsonResult.validation, function (result) {
                                    return new SurveyActionsValidationModel(result);
                                });
                                SrViewModel.SurveyActionsListValidation(mappedActionsList);
                            }
                            if (jsonResult.surveyResponseActionModel != null) {
                                mappedActionsList = $.map(jsonResult.surveyResponseActionModel, function (result) {
                                    return new SurveyActionsModel(result);
                                });
                                SrViewModel.SurveyActionsList(mappedActionsList);
                            }
                        }
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                    }
                });
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetSocioActions() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function btnClickPerformAction(data, event) {
            try {
                SrViewModel.SelectedActionEventId('');
                SrViewModel.SelectedActionEventId($('input[name=rdbAction]:checked').val());
                if ($('input[name=rdbAction]:checked').val() === undefined) {
                    $('#divActionError label').text("Please select an action to perform.");
                    $('#divActionError').show();

                }
                else if (SrViewModel.PushbackComment().toString().trim() === "" || SrViewModel.PushbackComment() === undefined) {
                    $('#divActionError label').text("Please enter finalize comment.");
                    $('#divActionError').show();
                }
                else if (SrViewModel.PushbackComment().toString().trim().length > SrViewModel.OverrideCommentsCharsLimit()) {
                    $('#divActionError label').text("Comment cannot exceed " + SrViewModel.OverrideCommentsCharsLimit() +" characters.");
                    $('#divActionError').show();
                }
                else {
                    var parameters = ko.utils.arrayFilter(SrViewModel.SurveyActionsListValidation(), function (parameter) {
                        if (parseInt(parameter.EVENT_ID()) == parseInt($('input[name=rdbAction]:checked').val())) {
                            if (parameter.ERROR_STATUS() != 0) {
                                return true;
                            }
                        }
                    });
                    if (parameters.length > 0 && parameters[0] != null) {
                        $('#divActionError label').html(parameters[0].ERROR_MESSAGE());
                        $('#divActionError').show();
                        return;
                    }
                    else {
                        $('#divActionError').hide();
                        SetSurveyLevelComments("PBC");
                    }
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: btnClickPerformAction() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function PerformSurveyAction() {
            try {
                $('#ActionsPopUp').modal('hide');
                $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/SetPerformAction?EventId=" + $('input[name=rdbAction]:checked').val() + "&BuId=" + SrViewModel.BusinessUnitId() + "&RoleId=" + appsecurity.userInfo().PrimaryRoleId(),
                    headers: headers,
                    type: "POST",
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in PerformSurveyAction() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult == "1") {
                        logger.logSuccess('Survey action performed successfully.', 'Success', system.getModuleId(SrViewModel), true);
                        SrViewModel.SurveyDashBoard.NavigatedFrom("Response");
                        router.navigate("Landing", true);
                    }
                    else if (isNaN(jsonResult)) {
                        // Logger ticket - INC***
                        logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                    }
                    else
                        logger.logError('An error occurred while performing selected survey action.', 'Error', system.getModuleId(SrViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in PerformSurveyAction() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            };

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in PerformSurveyAction() method in SocializationResponse.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in PerformSurveyAction() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            };
        }

        function showWFDescription(data, event) {
            try {
                if ($('#WFDescDiv').is(':visible')) {
                    $('#WFDescDiv').hide();
                    $('#showWFDescBtn').show();
                    $('#hideWFDescBtn').hide();
                }
                else {
                    $('#WFDescDiv').show();
                    $('#hideWFDescBtn').show();
                    $('#showWFDescBtn').hide();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: showWFDescription() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function showTimelineComments(data, event) {
            try {
                if ($('#showCmpltTimelineBtn').is(':visible')) {
                    SrViewModel.TimelineCommentsFlag(true);
                    $('#showCmpltTimelineBtn').hide();
                    $('#showLessTimelineBtn').show();
                }
                else {
                    SrViewModel.TimelineCommentsFlag(false);
                    $('#showCmpltTimelineBtn').show();
                    $('#showLessTimelineBtn').hide();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: showTimelineComments() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function OcKeypress(data, event) {
            try {
                if (event.which == 16 || event.which == 17 || event.which == 18 || (event.which >= 112 && event.which <= 123) || event.which == 35 || event.which == 36 || event.which == 46 || event.which == 8)
                    return true;
                else {
                    if (event.currentTarget.value.length >= SrViewModel.OverrideCommentsCharsLimit()) {
                        return false;
                    }

                    return true;
                }
            }
            catch (e) {
                var msg = 'exception' + e + 'source in OcKeypress() in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function GetTaxonomyList() {
            try {
                $.ajax({
                    url: "/api/Configuration/GetTaxonomyListForSocialization",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: {
                        "PageType": 'SO',
                    },
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetTaxonomyList() method in SocializationResponse.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    if (jsonResult != null) {
                        if (jsonResult.length != 0 && jsonResult[0].TaxonomyId == -99) {
                            logger.logError(jsonResult[0].TaxonomyName + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                        }
                        else {
                            var mappedList = $.map(jsonResult, function (result) {
                                return new TaxonomyModel(result);
                            });
                            SrViewModel.TaxonomyLevelList([]);
                            SrViewModel.TaxonomyLevelList(mappedList);

                            if (SrViewModel.TaxonomyLevelList() != undefined || SrViewModel.TaxonomyLevelList().length > 0) {
                                SrViewModel.SelectedTaxonomyOptionText(SrViewModel.TaxonomyLevelList()[0].TaxonomyName());
                                SrViewModel.SelectedTaxonomyOptionRefresh(SrViewModel.TaxonomyLevelList()[0].TaxonomyId());
                            }
                        }
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetTaxonomyList() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetTaxonomyList() method in SocializationResponse.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetTaxonomyList() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            };
        }

        function TaxonomyModel(item) {
            try {
                var self = this;
                self.TaxonomyId = ko.observable(item.TaxonomyId);
                self.TaxonomyName = ko.observable($('<div/>').html(item.TaxonomyName).text());
                self.LevelId = ko.observable($('<div/>').html(item.LevelId).text());
                self.LevelMapId = ko.observable($('<div/>').html(item.LevelMapId).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: TaxonomyModel() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function OcKeyUp(data, event) {
            try {
                SrViewModel.RemainingChars(SrViewModel.OverrideCommentsCharsLimit() - event.currentTarget.value.length);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: OcKeyUp() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function NavigateToDashboard() {
            try {
                SrViewModel.tabType("");
                SrViewModel.SurveyDashBoard.NavigatedFrom("Response");
                router.navigate("Landing", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateToDashboard() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function NavigateToTracking() {
            try {
                SrViewModel.tabType("");
                SrViewModel.ObjGeneralSettings.NavPillIdSurveyTracking(SrViewModel.SurveyTrackingVM.NavPillId());
                SrViewModel.ObjGeneralSettings.isNavigatedBackFromSurveyResponsePage(true);
                router.navigate("#survey/SurveyTracking", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateToTracking() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function NavigateToAssignment() {
            try {
                SrViewModel.tabType("");
                router.navigate("#RaSocialization/Administration", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateToAssignment() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function SurveyActionsModel(item) {
            try {
                var self = this;
                self.EventId = ko.observable(item.EventId);
                self.EventName = ko.observable($('<div/>').html(item.EventName).text());
                self.NextState = ko.observable($('<div/>').html(item.NextState).text());
                self.IsMessage = ko.observable(item.IsMessage);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyActionsModel() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }
        
        function SurveyActionsValidationModel(item) {
            try {
                var self = this;
                self.EVENT_ID = ko.observable(item.EVENT_ID);
                self.EVENT_NAME = ko.observable(item.EVENT_NAME);
                self.ERROR_STATUS = ko.observable(item.ERROR_STATUS);
                self.ERROR_MESSAGE = ko.observable(item.ERROR_MESSAGE);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyActionsValidationModel() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function expandCollapseModel(item) {
            try {
                var self = this;
                self.colName = ko.observable("Collapse " + item.colType + " cells");
                self.isExpanded = ko.observable("table-cell");
                self.expand = function (data, e) {
                    if (data.isExpanded() == "table-cell") {
                        self.colName = ko.observable("Expand " + item.colType + " cells");
                        self.isExpanded("none");
                    }
                    else {
                        self.colName = ko.observable("Collapse " + item.colType + " cells");
                        self.isExpanded("table-cell");
                    }
                };
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: expandCollapseModel() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function heatMapDataModel(item) {
            try {
                var self = this;
                self.parentData = ko.observable(item);
                self.childrenData = ko.observable();
                if (item.childHeatMapData) {
                    var mappedChildData = $.map(item.childHeatMapData, function (result) {
                        return new heatMapChildDataModel(result);
                    });
                    self.childrenData(mappedChildData);
                }
                self.childrenVisible = ko.observable(false);
                self.socCompRiskLevel = ko.observable(item.socCompRiskLevel);
                self.socCompRiskCss = ko.observable(item.socCompRiskCss);
                self.socCompRiskId = ko.observable(item.socCompRiskId);
                self.internalType = ko.observable(item.internalType);
                self.isEdit = ko.observable(item.isEdit);
                self.Show_Edit = ko.observable(item.Show_Edit);
                self.Refresh_ChangeFlag = ko.observable(item.Refresh_ChangeFlag);
                self.VisibleForChangeAreas = ko.observable(true);
                self.childrenVisible(true);
                self.IsVisibleforSearch = ko.observable(true);

                self.seeCategories = function (data, event) {
                    try {

                        //if (SrViewModel.Query() != "") { // if search is applied return false
                        //    return false;
                        //}

                        if (self.childrenVisible() == false) {
                            self.childrenVisible(true);

                            if (data.parentData().LevelId != SrViewModel.MaxTaxonomyLevel()) {
                                for (var i = 0; i < SrViewModel.Multilist().length; i++) {
                                    if (data.parentData().LevelId > SrViewModel.Multilist()[i].LevelId && SrViewModel.Multilist()[i].childHeatMapData != null && SrViewModel.Multilist()[i].childHeatMapData.length > 0) {
                                        LastLevelShow(SrViewModel.Multilist()[i].childHeatMapData, data.parentData());
                                    } else if (data.parentData().LevelId == SrViewModel.Multilist()[i].LevelId) {
                                        if (data.parentData().id == SrViewModel.Multilist()[i].id) {
                                            if (SrViewModel.Multilist()[i].childHeatMapData != null && SrViewModel.Multilist()[i].childHeatMapData.length > 0) {
                                                RepeatTillLastLevelShow(SrViewModel.Multilist()[i].childHeatMapData, data.parentData());
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            self.childrenVisible(false);

                            if (data.parentData().LevelId != SrViewModel.MaxTaxonomyLevel()) {
                                for (var i = 0; i < SrViewModel.Multilist().length; i++) {
                                    if (data.parentData().LevelId > SrViewModel.Multilist()[i].LevelId && SrViewModel.Multilist()[i].childHeatMapData != null && SrViewModel.Multilist()[i].childHeatMapData.length > 0) {
                                        LastLevelHide(SrViewModel.Multilist()[i].childHeatMapData, data.parentData());
                                    } else if (data.parentData().LevelId == SrViewModel.Multilist()[i].LevelId) {
                                        if (data.parentData().id == SrViewModel.Multilist()[i].id) {
                                            if (SrViewModel.Multilist()[i].childHeatMapData != null && SrViewModel.Multilist()[i].childHeatMapData.length > 0) {
                                                RepeatTillLastLevelHide(SrViewModel.Multilist()[i].childHeatMapData);
                                            }
                                        }
                                    }
                                }
                            }
                        };
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: seeCategories() method in SocializationResponse.js';

                        logger.logMessage(msg);
                    }

                }
                self.setRiskColorValue = function (data, event) {
                    if (!SrViewModel.readOnlyFlag()) {
                        // SrViewModel.overrideCommentsDetails(new OverrideCommentModel(self, data));
                        SrViewModel.overrideCommentsDetails(data);

                        SrViewModel.OverrideCommentsChars(SrViewModel.OverrideCommentsCharsLimit());
                        $('#SetOverrideCommentsPopUp').modal('show');
                    }
                };
                self.isEditForSharedCtrl = ko.observable(item.isEditForSharedCtrl);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: heatMapDataModel() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function heatMapDataChangeModel(item) {
            try {
                var self = this;
                self.parentData = ko.observable(item);
                self.childrenData = ko.observable();
                if (item.childHeatMapData) {
                    var mappedChildData = $.map(item.childHeatMapData, function (result) {
                        return new heatMapChildDataModel(result);
                    });
                    self.childrenData(mappedChildData);
                }
                self.childrenVisible = ko.observable(false);
                self.socCompRiskLevel = ko.observable(item.socCompRiskLevel);
                self.socCompRiskCss = ko.observable(item.socCompRiskCss);
                self.socCompRiskId = ko.observable(item.socCompRiskId);
                self.internalType = ko.observable(item.internalType);
                self.isEdit = ko.observable(item.isEdit);
                self.Show_Edit = ko.observable(item.Show_Edit);
                self.Refresh_ChangeFlag = ko.observable(item.Refresh_ChangeFlag);
                self.VisibleForChangeAreas = ko.observable(item.Refresh_ChangeFlag);
                self.seeCategories = function (data, event) {
                    if (self.childrenVisible() == false)
                        self.childrenVisible(true);
                    else
                        self.childrenVisible(false);
                };
                self.setRiskColorValue = function (data, event) {
                    if (!SrViewModel.readOnlyFlag()) {
                        SrViewModel.overrideCommentsDetails(new OverrideCommentModel(self, data));
                        SrViewModel.OverrideCommentsChars(SrViewModel.OverrideCommentsCharsLimit());
                        $('#SetOverrideCommentsPopUp').modal('show');
                    }
                };
                self.isEditForSharedCtrl = ko.observable(item.isEditForSharedCtrl);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: heatMapDataChangeModel() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function OverridePopup(data, object, selectedData) {
            try {
                var finalData = '';
                if (data != undefined) {
                    if (data.length > 0)
                        finalData = data[data.length - 1];
                }
                if (object != undefined && object.$data != undefined) {
                    SrViewModel.EditableAreaName(object.$data.Name);
                    if (object.$data.BusinessUnitCountList != undefined && object.$data.BusinessUnitCountList[0] != undefined) {
                        SrViewModel.EditableBUName(object.$data.BusinessUnitCountList[0].BU_NAME);

                        if (object.$data.BusinessUnitCountList[0].ResponseList != undefined)
                            SrViewModel.BUColSpan(object.$data.BusinessUnitCountList[0].ResponseList.length);

                    }
                }

                SrViewModel.uniqueEditableTypes([]);
                SrViewModel.uniqueEditableTypes(SrViewModel.editableTypes());
                SrViewModel.overrideDropDownList([]);
                SrViewModel.overrideCommentsDetails([]);
                SrViewModel.IsOverallOverride(false);
                var selectOverride = 0;
                SrViewModel.SelectedComponentId('');

                if (SrViewModel.AssessmentType() == 2 && SrViewModel.RiskType() == 'ALL') {
                    if (selectedData != undefined) {

                        SrViewModel.uniqueEditableTypes([]);
                        var specificColumns = '';

                        if (selectedData.type === 'I' || selectedData.type === 'I_F') {
                            SrViewModel.ColumnType("Inherent Risk ");
                            SrViewModel.overrideDropDownList(SrViewModel.inhHeatMapDrpDwn());
                            specificColumns = ko.utils.arrayFilter(SrViewModel.editableTypes(), function (i) { if (i.colId() === 'I' || i.colId() === 'I_F') { return i; } });
                            ko.utils.arrayFilter(data, function (i) {
                                if (i.ZAT_TYPE === 'Q' && (i.type === 'I' || i.type === 'I_F')) {
                                    selectOverride = i.RISK_ID;
                                }
                            });
                        }
                        if (selectedData.type === 'C' || selectedData.type === 'C_F') {
                            SrViewModel.ColumnType("Controls Rating ");
                            SrViewModel.overrideDropDownList(SrViewModel.cntrlHeatMapDrpDwn());
                            specificColumns = ko.utils.arrayFilter(SrViewModel.editableTypes(), function (i) { if (i.colId() === 'C' || i.colId() === 'C_F') { return i; } });
                            ko.utils.arrayFilter(data, function (i) {
                                if (i.ZAT_TYPE === 'Q' && (i.type === 'C' || i.type === 'C_F')) {
                                    selectOverride = i.RISK_ID;
                                }
                            });
                        }
                        if (selectedData.type === 'R' || selectedData.type === 'R_F') {
                            SrViewModel.ColumnType("Residual Risk ");
                            SrViewModel.overrideDropDownList(SrViewModel.resHeatMapDrpDwn());
                            specificColumns = ko.utils.arrayFilter(SrViewModel.editableTypes(), function (i) { if (i.colId() === 'R' || i.colId() === 'R_F') { return i; } });
                            ko.utils.arrayFilter(data, function (i) {
                                if (i.ZAT_TYPE === 'Q' && (i.type === 'R' || i.type === 'R_F')) {
                                    selectOverride = i.RISK_ID;
                                }
                            });
                        }
                        SrViewModel.uniqueEditableTypes(specificColumns);
                        var tableList = ko.utils.arrayFilter(data, function (i) { if (i.type === selectedData.type) { return i; } });

                        SrViewModel.OverrideType(selectedData.type);
                        SrViewModel.overrideCommentsDetails(tableList);
                        SrViewModel.SelectedComponentId(selectOverride);
                    }
                } else {

                    if (finalData.type === 'I' || finalData.type === 'I_F') {
                        SrViewModel.ColumnType("Inherent Risk ");
                        SrViewModel.overrideDropDownList(SrViewModel.inhHeatMapDrpDwn());
                        ko.utils.arrayFilter(data, function (i) {
                            if (i.ZAT_TYPE === 'Q' && (i.type === 'I' || i.type === 'I_F')) {
                                selectOverride = i.RISK_ID;
                            }
                        });
                    }
                    if (finalData.type === 'C' || finalData.type === 'C_F') {
                        SrViewModel.ColumnType("Controls Rating ");
                        SrViewModel.overrideDropDownList(SrViewModel.cntrlHeatMapDrpDwn());
                        ko.utils.arrayFilter(data, function (i) {
                            if (i.ZAT_TYPE === 'Q' && (i.type === 'C' || i.type === 'C_F')) {
                                selectOverride = i.RISK_ID;
                            }
                        });
                    }
                    if (finalData.type === 'R' || finalData.type === 'R_F') {
                        SrViewModel.ColumnType("Residual Risk ");
                        SrViewModel.overrideDropDownList(SrViewModel.resHeatMapDrpDwn());
                        ko.utils.arrayFilter(data, function (i) {
                            if (i.ZAT_TYPE === 'Q' && (i.type === 'R' || i.type === 'R_F')) {
                                selectOverride = i.RISK_ID;
                            }
                        });
                    }

                    SrViewModel.OverrideType(finalData.type);
                    SrViewModel.overrideCommentsDetails(data);
                    SrViewModel.SelectedComponentId(selectOverride);
                }

                $('#SetOverrideCommentsPopUp').modal('show');
                var editor = CKEDITOR.instances['OverrideTextArea'];
                if (editor) {
                    editor.destroy(true);
                }
                CKEDITOR.replace('OverrideTextArea', {
                    removePlugins: SrViewModel.RemovePlugins(),
                    removeButtons: SrViewModel.RemoveButtons(),
                    disableNativeSpellChecker: false
                });

                $('#OverrideTextArea').html(SrViewModel.NarrationComment());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: OverridePopup() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function OverridePopupOverall(data, selectedData) {
            try {
                var finalData = '';
                var areaIndex = -1;
                ko.utils.arrayFilter(data, function (arr) {
                    if (arr.calcId === selectedData.calcId && arr.ZAT_UID === selectedData.ZAT_UID) {
                        areaIndex = ko.utils.arrayIndexOf(data, arr);
                    }
                });

                if (data != undefined) {
                    if (data.length > 0)
                        finalData = data[areaIndex - 1];
                }
                if (selectedData != undefined) {
                    SrViewModel.EditableAreaName(selectedData.areaName);
                    SrViewModel.EditableBUName(selectedData.areaName);
                    SrViewModel.BUColSpan(3);
                }

                SrViewModel.uniqueEditableTypes([]);
                SrViewModel.uniqueEditableTypes(SrViewModel.editableTypes());
                SrViewModel.overrideDropDownList([]);
                SrViewModel.overrideCommentsDetails([]);
                SrViewModel.IsOverallOverride(true);
                var selectOverride = 0;
                SrViewModel.SelectedComponentId('');

                if (SrViewModel.AssessmentType() == 2 && SrViewModel.RiskType() == 'ALL') {
                    if (selectedData != undefined) {

                        SrViewModel.uniqueEditableTypes([]);
                        var specificColumns = '';

                        if (selectedData.type === 'I' || selectedData.type === 'I_F') {
                            SrViewModel.ColumnType("Inherent Overall Risk ");
                            SrViewModel.overrideDropDownList(SrViewModel.inhHeatMapDrpDwn());
                            specificColumns = ko.utils.arrayFilter(SrViewModel.editableTypes(), function (i) { if (i.colId() === 'I' || i.colId() === 'I_F') { return i; } });
                            ko.utils.arrayFilter(data, function (i) {
                                if (i.ZAT_TYPE === 'Q' && (i.type === 'I' || i.type === 'I_F') && i.calcId === selectedData.calcId) {
                                    selectOverride = i.riskId;
                                }
                            });
                        }
                        if (selectedData.type === 'C' || selectedData.type === 'C_F') {
                            SrViewModel.ColumnType("Controls Overall Rating ");
                            SrViewModel.overrideDropDownList(SrViewModel.cntrlHeatMapDrpDwn());
                            specificColumns = ko.utils.arrayFilter(SrViewModel.editableTypes(), function (i) { if (i.colId() === 'C' || i.colId() === 'C_F') { return i; } });
                            ko.utils.arrayFilter(data, function (i) {
                                if (i.ZAT_TYPE === 'Q' && (i.type === 'C' || i.type === 'C_F') && i.calcId === selectedData.calcId) {
                                    selectOverride = i.riskId;
                                }
                            });
                        }
                        if (selectedData.type === 'R' || selectedData.type === 'R_F') {
                            SrViewModel.ColumnType("Residual Overall Risk ");
                            SrViewModel.overrideDropDownList(SrViewModel.resHeatMapDrpDwn());
                            specificColumns = ko.utils.arrayFilter(SrViewModel.editableTypes(), function (i) { if (i.colId() === 'R' || i.colId() === 'R_F') { return i; } });
                            ko.utils.arrayFilter(data, function (i) {
                                if (i.ZAT_TYPE === 'Q' && (i.type === 'R' || i.type === 'R_F') && i.calcId === selectedData.calcId) {
                                    selectOverride = i.riskId;
                                }
                            });
                        }
                        SrViewModel.uniqueEditableTypes(specificColumns);
                        var tableList = ko.utils.arrayFilter(data, function (i) { if (i.type === selectedData.type && i.calcId === selectedData.calcId) { return i; } });

                        SrViewModel.OverrideType(selectedData.type);
                        SrViewModel.overrideCommentsDetails(tableList);
                        SrViewModel.SelectedComponentId(selectOverride);
                    }
                } else {

                    if (finalData.type === 'I' || finalData.type === 'I_F') {
                        SrViewModel.ColumnType("Inherent Overall Risk ");
                        SrViewModel.overrideDropDownList(SrViewModel.inhHeatMapDrpDwn());
                        ko.utils.arrayFilter(data, function (i) {
                            if (i.ZAT_TYPE === 'Q' && (i.type === 'I' || i.type === 'I_F') && i.calcId === selectedData.calcId) {
                                selectOverride = i.riskId;
                            }
                        });
                    }
                    if (finalData.type === 'C' || finalData.type === 'C_F') {
                        SrViewModel.ColumnType("Controls Overall Rating ");
                        SrViewModel.overrideDropDownList(SrViewModel.cntrlHeatMapDrpDwn());
                        ko.utils.arrayFilter(data, function (i) {
                            if (i.ZAT_TYPE === 'Q' && (i.type === 'C' || i.type === 'C_F') && i.calcId === selectedData.calcId) {
                                selectOverride = i.riskId;
                            }
                        });
                    }
                    if (finalData.type === 'R' || finalData.type === 'R_F') {
                        SrViewModel.ColumnType("Residual Overall Risk ");
                        SrViewModel.overrideDropDownList(SrViewModel.resHeatMapDrpDwn());
                        ko.utils.arrayFilter(data, function (i) {
                            if (i.ZAT_TYPE === 'Q' && (i.type === 'R' || i.type === 'R_F') && i.calcId === selectedData.calcId) {
                                selectOverride = i.riskId;
                            }
                        });
                    }

                    SrViewModel.OverrideType(finalData.type);
                    var tableListData = ko.utils.arrayFilter(data, function (i) { if (i.calcId === selectedData.calcId) { return i; } });
                    SrViewModel.overrideCommentsDetails(tableListData);
                    SrViewModel.SelectedComponentId(selectOverride);
                }

                $('#SetOverrideCommentsPopUp').modal('show');
                var editor = CKEDITOR.instances['OverrideTextArea'];
                if (editor) {
                    editor.destroy(true);
                }
                CKEDITOR.replace('OverrideTextArea', {
                    removePlugins: SrViewModel.RemovePlugins(),
                    removeButtons: SrViewModel.RemoveButtons(),
                    disableNativeSpellChecker: false
                });

                $('#OverrideTextArea').html(SrViewModel.NarrationComment());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: OverridePopupOverall() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function requestModel(item) {
            try {
                var self = this;
                self.overrideDetail = ko.observable(item);
                self.approveOverride = function (data) {
                    SrViewModel.ActionsPopupHeading(((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RequestedForQASoc') == -1) ? 'Requested for' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RequestedForQASoc')].Name()) + ' \'' + data.overrideDetail().name + '\'' + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('at') == -1) ? 'at' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('at')].Name()) + data.overrideDetail().type + ' - ' + data.overrideDetail().OverriddenLevel + ' ' + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('level') == -1) ? 'level' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('level')].Name()));
                    SrViewModel.RemainingChars(SrViewModel.OverrideCommentsCharsLimit());
                    SrViewModel.approveDenyDetails(new approveDenyOverrideModel(self, data));
                    $('#OverrideApprovalPopup').modal('show');
                };
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: requestModel() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function reqComment(data) {
            try {
                SrViewModel.ActionsPopupHeading(((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RequestedForQASoc') == -1) ? 'Requested for' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RequestedForQASoc')].Name()) + ' \'' + data.overrideDetail().name + '\'' + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('at') == -1) ? 'at' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('at')].Name()) + data.overrideDetail().type + ' - ' + data.overrideDetail().OverriddenLevel + ' ' + ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('level') == -1) ? 'level' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('level')].Name()));
                SrViewModel.TableUid(data.overrideDetail().socID);
                SrViewModel.TableType(data.overrideDetail().generaltype);
                $('#OverrideCommentPopupRespRev').modal('show');
                ShowCommentContent('SO-OC');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in reqComment() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function ShowCommentContent(commentType) {
            try {
                $("#QAcomments").show();
                $("#QAattachments").hide();
                $('#commentsQAId').addClass('active');
                $('#attchmentsQAId').removeClass('active');
                $('#valErrorActionRespRev').hide();
                SrViewModel.RemainingChars(SrViewModel.OverrideCommentsCharsLimit());
                $("#OverrideRationaleText").val("");
                if (commentType == 'SO-OC') {
                    $('#ocommentsNav').addClass('active');
                    $('#orationalesNav').removeClass('active');
                    SrViewModel.IsRationaleFlag(false);
                }
                else {
                    $('#ocommentsNav').removeClass('active');
                    $('#orationalesNav').addClass('active');
                    SrViewModel.IsRationaleFlag(true);
                }
                getComments(SrViewModel.TableType(), SrViewModel.TableUid(), commentType);
                if (SrViewModel.readOnlyFlag() == false) {
                    $("#commentsFooterQA").show();
                }

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowCommentContent() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function ShowDocumentConent() {
            try {
                $("#QAcomments").hide();
                $("#QAattachments").show();
                $('#commentsQAId').removeClass('active');
                $('#attchmentsQAId').addClass('active');
                $("#commentsFooterQA").hide();
                $("#SummaryFileTextAreaOvr").val("");
                SrViewModel.RemainingChars(SrViewModel.OverrideCommentsCharsLimit());
                getComments(SrViewModel.TableType(), SrViewModel.TableUid(), "SO-OD");

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowDocumentConent() method in SocializationResponse.js';
                logger.logMessage(msg);
            }

        }
        
        function addEditOverrideComment(isNew, data, event) {
            try {
                if (isNew == 0) {
                    $('#valErrorActionRespRev').hide();
                    SrViewModel.RemainingChars(SrViewModel.OverrideCommentsCharsLimit() - data.comment().length);
                    $('#OverrideRationaleText').val(data.comment());
                    SrViewModel.SelectedCommentId(data.commentID());
                }
                else {
                    $('#valErrorActionRespRev').hide();
                    SrViewModel.RemainingChars(SrViewModel.OverrideCommentsCharsLimit());
                    SrViewModel.SelectedCommentId('');
                    $('#OverrideRationaleText').val('');
                }
            }
             catch (e) {
                 var msg = 'Exception: ' + e + ' | Source: addEditOverrideComment() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function approveDenyOverrideModel(details, data) {
            try {
                var self = this;
                self.actionId = ko.observable();
                self.approveDenyComment = ko.observable();
                self.saveOverride = function () {

                    $('#valErrorAction').hide();
                    var EventId = 0;
                    EventId = $("input[name='rdbActionQA']:checked").val();
                    if (EventId === undefined || EventId === "") {
                        $('#valErrorAction').html('Please select an action.');
                        $('#valErrorAction').show();
                        return;
                    }

                    if (self.approveDenyComment() === undefined || self.approveDenyComment() === "") {
                        $('#valErrorAction').html('Comment is required.');
                        $('#valErrorAction').show();
                        return;
                    }
                    var comment = self.approveDenyComment();
                    var statusId = self.actionId();
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    return $.ajax({
                        url: "/api/Configuration/ApproveDenyOverride",
                        type: "POST",
                        headers: headers,
                        data: {
                            deRatUid: SrViewModel.BusinessUnitId(),
                            type: data.overrideDetail().type,
                            comment: comment,
                            socId: data.overrideDetail().socID,
                            statusId: EventId,
                            AssessmentProfile: SrViewModel.appsecurity.CurrentProfileOfAssessmentId()
                        }
                    }).success(function (jsonResult, success) {
                        if (jsonResult != null) {
                            if (isNaN(jsonResult)) {
                                logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else if (!isNaN(jsonResult) && parseInt(jsonResult) > 0){
                                $('#OverrideApprovalPopup').modal('hide');
                                GetOverridesData()
                                logger.logSuccess('Override has been saved. Please submit the socialization survey of the assessment unit.', 'Success', system.getModuleId(SrViewModel), true);
                            }
                            else {
                                logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                            }
                        }else {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                        }
                    });
                };
                self.cancelOverride = function () {
                    $('#SetOverrideCommentsPopUp').modal('hide');
                };
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: approveDenyOverrideModel() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function OverrideCommentModel(details, data) {
            try {
                var self = this;
                SrViewModel.ErrorChars('');
                self.overrideComment = ko.observable();
                self.cancelOverrideComment = function () {
                    $('#SetOverrideCommentsPopUp').modal('hide');
                    $("#loadingSaveImgDiv").hide();
                };
                SrViewModel.overrideCommentsDetails(data);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in OverrideCommentModel() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function SaveOverrideComment(data) {
            try {
                var data = SrViewModel.overrideCommentsDetails();

                if (data != undefined) {

                    //var id = 'menu' + SrViewModel.EditableAreaName(),
                    //    optionId = document.getElementById(id).value;
                    var optionId = SrViewModel.SelectedComponentId(),
                        calcId = data[0].calcId,
                        type = data[0].type;

                    if (type == 'I_F' || type == 'C_F' || type == 'R_F')
                        type = type.toString().trim('_')[0];

                    $("#loadingSaveImgDiv").show();

                    var comment = CKEDITOR.instances["OverrideTextArea"].getData();;
                    if (comment == "" || comment == " " || comment == undefined) {
                        SrViewModel.ErrorChars('Please enter comments to save.');
                        $("#SetOverrideCommentsPopUp").show();
                        $("#loadingSaveImgDiv").hide();
                        return false;
                    }
                    $("#loadingActionItemList").show();
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;

                    return $.ajax({
                        url: "/api/Configuration/SaveComplianceOverrides",
                        type: "POST",
                        headers: headers,
                        data: {
                            deRatUid: SrViewModel.BusinessUnitId(),
                            calcUid: calcId,
                            type: type,
                            comment: comment,
                            complianceUid: optionId,
                            AssessmentProfile: SrViewModel.appsecurity.CurrentProfileOfAssessmentId()
                        }
                    })
                        .success(function (jsonResult, success) {
                            if (jsonResult != null) {
                                if (isNaN(jsonResult))
                                    logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);

                                else if (!isNaN(jsonResult) && parseInt(jsonResult) > 0){
                                    SrViewModel.ErrorChars('');
                                    SrViewModel.contentTabVisible(false);
                                    GetAllHeatmapData();
                                    $("#loadingSaveImgDiv").hide();
                                    $('#SetOverrideCommentsPopUp').modal('hide');
                                    logger.logSuccess('Override has been saved. Please submit the socialization survey.', 'Success', system.getModuleId(SrViewModel), true);
                                }
                                else {
                                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                                }
                            } else {
                                SrViewModel.ErrorChars('Please enter comments to save.');
                                $("#loadingSaveImgDiv").hide();
                                $("#SetOverrideCommentsPopUp").show();
                                return false;
                            }
                        });
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in SaveOverrideComment() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function heatMapChildDataModel(item) {
            try {
                var self = this;
                self.childData = ko.observable(item);
                self.socCompRiskLevel = ko.observable(item.socCompRiskLevel);
                self.socCompRiskCss = ko.observable(item.socCompRiskCss);
                self.socCompRiskId = ko.observable(item.socCompRiskId);
                self.isEdit = ko.observable(item.isEdit);
                self.Show_Edit = ko.observable(item.Show_Edit);
                self.IsVisibleforSearch = ko.observable(true);

                self.setRiskColorValue = function (data, event) {
                    if (!SrViewModel.readOnlyFlag()) {
                        SrViewModel.overrideCommentsDetails(new OverrideCommentModel(self, data));
                        SrViewModel.OverrideCommentsChars(SrViewModel.OverrideCommentsCharsLimit());
                        $('#SetOverrideCommentsPopUp').modal('show');
                    }
                };
                self.internalType = ko.observable(item.internalType);
                self.Refresh_ChangeFlag = ko.observable(item.Refresh_ChangeFlag);
                self.VisibleForChangeAreas = ko.observable(true);
                self.childrenVisible = ko.observable(false);
            }
            catch (e) {
            var msg = 'Exception: ' + e + ' | Source: heatMapChildDataModel() in SocializationResponse.js';
            logger.logMessage(msg);
            }
        }

        function ResponseMoveModel(item) {
            try {
                var self = this;
                self.SurveyProfileId = ko.observable(item.SurveyProfileId);
                self.SurveyTypeId = ko.observable(item.SurveyTypeId);
                self.PageHeaderName = ko.observable(item.PageHeaderName);
                self.BusinessUnitId = ko.observable(item.BusinessUnitId);
                self.BusinessUnitName = ko.observable(item.BusinessUnitName);
                self.BusinessUnitDescription = ko.observable(item.BusinessUnitDescription);
                self.SurveyType = ko.observable(item.SurveyType);
                self.SurveyId = ko.observable(item.SurveyId);
                self.RoleId = ko.observable(item.RoleId);
                self.RoleName = ko.observable(item.RoleName);
                self.SurveyStatus = ko.observable(item.SurveyStatus);
                self.areaId = ko.observable(item.areaId);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResponseMoveModel() in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function CommentsModel(item) {
            try {
                var self = this;
                self.commentID = ko.observable(item.commentID);
                self.addedBy = ko.observable(item.addedBy);
                self.comment = ko.observable(item.comment);
                self.addedByID = ko.observable(item.addedByUserID);
                self.commentAddedOn = ko.observable(item.commentAddedOn);
                self.roleName = ko.observable(item.roleName);
                self.isCommentEditable = ko.observable(item.isCommentEditable);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CommentsModel() in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function editOverrideCommentModel(item) {
            try {
                var self = this;
                self.isCommentEditable = ko.observable(true);
                self.RoleType = ko.observable(appsecurity.userInfo().PrimaryRoleName());
                self.UserName = ko.observable(SrViewModel.appsecurity.userInfo().lastName() + ", " + SrViewModel.appsecurity.userInfo().firstName());
                self.commentID = ko.observable(0);
                self.Comment = ko.observable(item.Comment);
                self.tableUid = ko.observable(item.tableUid);
                self.type = ko.observable(item.type);
                self.modalLabel = ko.observable(item.modalLabel);
                self.theme = ko.observable(item.theme);

                self.deleteOverrideRequest = function (data, event) {

                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    return $.ajax({
                        url: "/api/Configuration/DeleteOverrideRequestComment?commentID=" + data.commentID(),
                        type: "POST",
                        headers: headers,
                        contentType: 'application/json'
                    }).success(function (jsonResult, success) {
                        if (jsonResult != null) {
                            if (isNaN(jsonResult))
                                logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);

                            else if (!isNaN(jsonResult) && parseInt(jsonResult) > 0) {
                                logger.logSuccess('Comment has been deleted successfully.', 'Success', system.getModuleId(SrViewModel), true);
                                getComments(self.type(), self.tableUid(), "SO-OC");
                                self.Comment("");
                                SrViewModel.RemainingChars(SrViewModel.OverrideCommentsCharsLimit());
                                $("#OverrideRationaleText").val("");
                            }
                            else {
                                logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                            }
                        }
                        else {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                        }
                    });
                };
                self.commentList = ko.observableArray(item.commentsList);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: editOverrideCommentModel() in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function editOverrideRequest(data, event) {
            try {
                var comment = $("#OverrideRationaleText").val();
                $('#valErrorActionRespRev').hide();
                if (comment === undefined || comment === "") {
                    $('#valErrorActionRespRev').html('Comment is required.');
                    $('#valErrorActionRespRev').show();
                    return;
                }
                else if (comment.length > SrViewModel.OverrideCommentsCharsLimit()) {
                    $('#valErrorActionRespRev').html('Comment cannot exceed ' + SrViewModel.OverrideCommentsCharsLimit() + ' characters.');
                    $('#valErrorActionRespRev').show();
                    return;
                }
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Configuration/EditOverrideRequestComment",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    data: JSON.stringify({
                        buId: SrViewModel.BusinessUnitId(), //DERAT_UID
                        TABLE_UID: SrViewModel.TableUid(),
                        TYPE: SrViewModel.TableType(),
                        roleId: appsecurity.userInfo().PrimaryRoleId(),
                        comment: comment,
                        commentID: SrViewModel.SelectedCommentId()
                    })
                }).success(function (jsonResult, success) {
                    if (jsonResult != null) {
                        if (isNaN(jsonResult))
                            logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                        else if (!isNaN(jsonResult) && parseInt(jsonResult) > 0) {
                            logger.logSuccess('Comment has been saved successfully.', 'Success', system.getModuleId(SrViewModel), true);
                            getComments(SrViewModel.TableType(), SrViewModel.TableUid(), "SO-OC");
                            SrViewModel.RemainingChars(SrViewModel.OverrideCommentsCharsLimit());
                            $("#OverrideRationaleText").val("");
                            SrViewModel.SelectedCommentId('');
                        }
                        else {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                        }
                    }
                    else
                    {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                    }
                });
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: editOverrideRequest() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function getComments(type, socID, CommentType) {
            try {
                return $.ajax({
                    url: "/api/Configuration/GetAllCommentsOverrides",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { type: type, socId: socID, commentType: CommentType }
                }).success(function (jsonResult, Success) {
                    if (CommentType == 'SO-OC' || CommentType == 'SO-OR') {
                        var mappedcommentdetails = [];
                        if (jsonResult != null && jsonResult.length > 0) {
                            if (jsonResult[0].roleId == -99)
                                logger.logError(jsonResult[0].roleName + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                            else {
                                mappedcommentdetails = $.map(jsonResult, function (result) {
                                    return new CommentsModel(result);
                                });
                            }
                        } else {
                            //This part is handled in html - when SrViewModel.OverrideComments().length == 0
                            //There are no Override Comments available.
                        }

                        SrViewModel.OverrideCommentsChars(SrViewModel.OverrideCommentsCharsLimit());
                        SrViewModel.OverrideComments(mappedcommentdetails);
                        
                    } else if (CommentType === 'SO-OD') {

                        var docListPopUp = "";
                        if (jsonResult == null || jsonResult.length == 0) {
                            docListPopUp += '<div id="lbldocResponseComment" class="font-italic NoComments-leftPadding">There are no attachments available.</div>'

                            $('#doc_cmt_List_').html("");
                            $('#doc_cmt_List_').html(docListPopUp);
                            return true;

                        }
                        else if (jsonResult != null && jsonResult.length != 0) {
                            if (jsonResult[0].roleId == -99) {
                                logger.logError(jsonResult[0].roleName + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else {
                                var Mapped = $.map(jsonResult, function (result) {
                                    return new DocumentCommentModel(result);
                                });
                                SrViewModel.DocumentListFinal(Mapped);
                                if (SrViewModel.DocumentListFinal().length > 0) {
                                    var documentListPopUp = "";

                                    for (k = 0; k < SrViewModel.DocumentListFinal().length > 0; k++) {
                                        documentListPopUp += '<div class="comment-view"><div class="cbox"><span class="tip tip-down"></span>';
                                        documentListPopUp += '<div class="mb-1">' + SrViewModel.DocumentListFinal()[k].DCommentText() + '</div>';
                                        documentListPopUp += '<a href="javascript:void(0)" data-bind="click: $root.DownloadDocument" class="mb-2"> <i class="demo-icon icon-paperclip_special"></i> ' + SrViewModel.DocumentListFinal()[k].DocumentName() + '</a></div>'

                                        documentListPopUp += '<input type="text" id="copydoccmtBox_' + SrViewModel.DocumentListFinal()[k].DCommentId() + '" style="display:none;" value="' + SrViewModel.DocumentListFinal()[k].DCommentText() + '">';
                                        documentListPopUp += '<div class="sud-lbl"><span class="suser">' + SrViewModel.DocumentListFinal()[k].DUploadedBy() + ' (' + SrViewModel.DocumentListFinal()[k].roleName() + ')</span>'
                                        documentListPopUp += ' on  <span class="sdate">' + SrViewModel.DocumentListFinal()[k].DUploadedDate() + '</span>';

                                        documentListPopUp += '<span class="c-actions" title="Download Document" id= "downdoc_' + SrViewModel.DocumentListFinal()[k].DCommentId() + '" data-bind="click: function (data,event) { $root.DownloadDocument}"><i class="demo-icon icon-download_special"></i> Download</span>';
                                        documentListPopUp += '<span class="c-actions" title="Copy Document Comment to Clipboard" id= "copydoccmt_' + SrViewModel.DocumentListFinal()[k].DCommentId() + '" data-bind="click: function (data,event) { $root.CopyComment}"><i class="demo-icon icon-copy_special"></i> Copy to Clipboard</span>';
                                        if (SrViewModel.DocumentListFinal()[k].DIsCurrentUser() == "1" || SrViewModel.DocumentListFinal()[k].DIsCurrentUser()) {
                                            documentListPopUp += '<span class="c-actions" title="Delete Document" id= "deldoc_' + SrViewModel.DocumentListFinal()[k].DCommentId() + '" data-bind="click: function (data,event)  { $root.DeleteDocument($root.DocumentListFinal()[' + k + '] ,\'SO-OD\') }"><i class="demo-icon icon-bin_special"></i> Delete</span></div>';
                                        }
                                        documentListPopUp += '</div>';
                                    }

                                    $('#doc_cmt_List_').html("");
                                    $('#doc_cmt_List_').html(documentListPopUp);

                                    for (k = 0; k < SrViewModel.DocumentListFinal().length > 0; k++) {
                                        ko.applyBindingsToNode($('#downdoc_' + SrViewModel.DocumentListFinal()[k].DCommentId()), { click: SrViewModel.DownloadDocument }, SrViewModel.DocumentListFinal()[k]);
                                        ko.applyBindingsToNode($('#copydoccmt_' + SrViewModel.DocumentListFinal()[k].DCommentId()), { click: SrViewModel.CopyComment }, 'copydoccmtBox_' + SrViewModel.DocumentListFinal()[k].DCommentId());
                                        if (SrViewModel.DocumentListFinal()[k].DIsCurrentUser() == "1" || SrViewModel.DocumentListFinal()[k].DIsCurrentUser()) {
                                            ko.applyBindingsToNode($('#deldoc_' + SrViewModel.DocumentListFinal()[k].DCommentId()), { click: SrViewModel.DeleteDocument }, SrViewModel.DocumentListFinal()[k]);
                                        }
                                    }
                                }
                                SrViewModel.UploadComment("");
                                return true;
                            }
                        }
                    } else if (CommentType === 'SO-OR') {
                        if (jsonResult != null && jsonResult.length > 0) {
                            if (jsonResult[0].roleId == -99) {
                                logger.logError(jsonResult[0].roleName + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else {
                                mappedcommentdetails = $.map(jsonResult, function (result) {
                                    return new CommentsModel(result);
                                });
                                if (mappedcommentdetails != undefined && mappedcommentdetails.length > 0)
                                    SrViewModel.NarrationComment('');
                                SrViewModel.NarrationComment(mappedcommentdetails[0].comment());
                                $('#OverrideTextArea').html(SrViewModel.NarrationComment());
                            }
                        }
                        else {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                        }
                    }

                });
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: getComments() method in SocializationResponse.js';

                logger.logMessage(msg);
            }
        }

        //#region RA Surveys code
        //=--------------------------------Socialization surveys ------------------------------//
        function GetQualResponseDetails(tableUID) {
            try {
                $('#loadingImgOrCalc').show();
                $('#InnerInherentTabDiv').html("");
                $('#InnerInherentTabDiv111').html("");
                var zat_id = tableUID;
                $.ajax({
                    url: "/api/Configuration/GetQualitativeResponseDataByBU",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: {
                        DeRatId: SrViewModel.BusinessUnitId(), Table_Uid: zat_id, Type: SrViewModel.ClickedQualType(), AreaId: SrViewModel.ClickedRiskAreaId()
                    }
                })
                    .success(function (JsonResult, Success) {
                        if (JsonResult != null && JsonResult.length > 0) {
                            $('#NoSurveyError').hide();
                            $('#NoRiskAreaError').hide();

                            SrViewModel.QualResponseListData([]);
                            SrViewModel.QualResponseListData(JsonResult);
                            SrViewModel.inhHeatMapDrpDwn();

                            //SrViewModel.QualResponseListData([]);
                            //var mappedResponseList = $.map(JsonResult.QualResponseModel, function (result) {
                            //    return new QualResponseModel(result);
                            //})
                            //SrViewModel.QualResponseListData(mappedResponseList);

                            SrViewModel.DistinctRiskLevelList([]);
                            SrViewModel.DistinctRiskLevelList(SrViewModel.inhHeatMapDrpDwn());
                            BindDynamicFilter();
                            BindDynamicHtmlQualitative();
                        }
                        else {
                            $('#loadingImgOrCalc').hide();
                            $('#InnerInherentTabDiv').html('');
                            $('#InnerInherentTabDiv111').html('');
                            $('#InnerInherentTabDiv').html('<span class="">No data is available.</span>');
                            $('#NoSurveyError').hide();
                            $('#NoRiskAreaError').show();
                            $('#loadingImgMain').hide();
                        }
                    })
                    .fail(function (error, fail) {
                        $('#loadingImgOrCalc').hide();
                    });
            }
            catch (e) {

                var msg = 'Exception: ' + e + ' | Source: GetQualResponseDetails() method in Activity.js';
                logger.logMessage(msg);
            }
        }

        function BindDynamicHtmlQualitative() {
            try {
                var QualDynamicHTML = "";

                $("#TaxonomyLId").show();

                if (SrViewModel.QualResponseListData().length == 0)
                    QualDynamicHTML += '<span id="lblNoResponseComment" class="font-italic NoComments-leftPadding" style="display:block;">There are no Questions available.</span>'

                QualDynamicHTML += '<div id="accordion">'
                QualDynamicHTML += '<div class="header-card">';

                for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                    for (var j = 0; j < SrViewModel.QualResponseListData()[i].length; j++) {
                        for (var k = 0; k < SrViewModel.QualResponseListData()[i][j].length; k++) {
                            if (SrViewModel.QualResponseListData()[i][j][k].IsVisibleforSearch == true) {
                                if (SrViewModel.QualResponseListData()[i][j][k].IsHeader == 1) {

                                    QualDynamicHTML += '<div  class="card-header">';
                                    QualDynamicHTML += '<span class="cp_assessment">';
                                    QualDynamicHTML += '<a href= "#accHeader_"' + SrViewModel.QualResponseListData()[i][j][k].QuestionId + '" id ="accHeaderMain_"' + SrViewModel.QualResponseListData()[i][j][k].QuestionId + '" data-toggle="collapse" data-parent="#accordion" aria-expanded="true">';
                                    QualDynamicHTML += '<i class="fa fa-fw fa-caret-right"></i> <span>' + SrViewModel.QualResponseListData()[i][j][k].QuestionText + '</span>';
                                    QualDynamicHTML += '</a>';
                                    QualDynamicHTML += '</span>';
                                    QualDynamicHTML += '</div>';
                                }


                                if (SrViewModel.QualResponseListData()[i][j][k].IsHeader == 0) {
                                    QualDynamicHTML += '<div class="question-card pl-4">'
                                    QualDynamicHTML += '<div class="card">'
                                    var ColumnName = "Response";
                                    if (SrViewModel.QualResponseListData()[i][j][k].QualResponseObject[0].Applicability === true) {
                                        QualDynamicHTML += '<span class="card-title question-text p-2">' + SrViewModel.QualResponseListData()[i][j][k].QuestionText + '</span>'
                                        QualDynamicHTML += '<div class="col-md-11">'
                                        QualDynamicHTML += '<div>'
                                        QualDynamicHTML += '<h6 class="card-subtitle text-muted p-1" id="QualQuestionId">' + ColumnName + '</h6>'
                                        QualDynamicHTML += '<div class="p-1">';
                                        QualDynamicHTML += '<span>' + SrViewModel.QualResponseListData()[i][j][k].QualResponseObject[0].ResponseValue + '</span>';
                                        QualDynamicHTML += '</div>'
                                        QualDynamicHTML += '</div>'
                                        QualDynamicHTML += '</div>'
                                    }
                                    QualDynamicHTML += '</div>'
                                    QualDynamicHTML += '</div>'
                                }

                            }
                        }
                    }
                }

                QualDynamicHTML += '</div>';//header-card
                QualDynamicHTML += '</div>';//accordion

                $('#QualContDynamicHTMLDiv').html("");
                $('#QualContDynamicHTMLDiv').html(QualDynamicHTML);

                $('#NoSurveyError').hide();
                $('#NoRiskAreaError').hide();
                $('#lblNoResponseComment').hide();
                $('#InnerInherentTabDiv').show();


                if (QualDynamicHTML != "")
                    $("#TaxonomyLId").hide();

                $('#loadingImgOrCalc').hide();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetQualResponseDetails() method in Activity.js';
                logger.logMessage(msg);
            }
        }


        function GetControlResponseDetails(tableUID) {
            try {
                $('#loadingImgOrCalc').show();
                $('#InnerInherentTabDiv').html("");
                $('#InnerInherentTabDiv111').html('');
                var zat_id = tableUID;
                $.ajax({
                    url: "/api/Configuration/GetControlsResponseDataByBU",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: {
                        DeRatId: SrViewModel.BusinessUnitId(), Table_Uid: zat_id, AreaId: SrViewModel.ClickedRiskAreaId()
                    }
                }).success(function (JsonResult, success) {

                    if (JsonResult != null && JsonResult.length > 0) {
                        $('#NoSurveyError').hide();
                        $('#NoRiskAreaError').hide();

                        SrViewModel.ControlsResponseData(JsonResult);
                        SrViewModel.cntrlHeatMapDrpDwn();

                        SrViewModel.DistinctRiskLevelList([]);
                        SrViewModel.DistinctRiskLevelList(SrViewModel.cntrlHeatMapDrpDwn());
                        BindDynamicFilter();


                        BindDynamicHtmlForControls();
                    }
                    else {
                        $('#loadingImgOrCalc').hide();
                        $('#InnerInherentTabDiv').html('');
                        $('#InnerInherentTabDiv111').html('');
                        $('#InnerInherentTabDiv111').html('<span class="">No data is available.</span>');
                        $('#InnerControlsTabDiv').hide();
                        $('#NoSurveyError').hide();
                        $('#NoRiskAreaError').show();
                        $('#loadingImgMain').hide();

                    }
                })
                    .fail(function (fail, error) {
                        $('#loadingImgOrCalc').hide();
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetControlResponseData() method in Activity.js';
                logger.logMessage(msg);
            }
        }

        function BindDynamicHtmlForControls() {
            try {
                var ContDynamicHTML = "";
                $("#TaxonomyLId").show();
                $('#loadingImgOrCalc').show();


                if (SrViewModel.ControlsResponseData().length == 0)
                    ContDynamicHTML += '<span id="lblNoResponseComment" class="font-italic NoComments-leftPadding" style="display:block;">There are no Questions available.</span>'

                ContDynamicHTML += '<div id="accordion">'
                ContDynamicHTML += '<div class="header-card">';

                for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                    for (var j = 0; j < SrViewModel.ControlsResponseData()[i].length; j++) {
                        for (var k = 0; k < SrViewModel.ControlsResponseData()[i][j].length; k++) {
                            if (SrViewModel.ControlsResponseData()[i][j][k].IsVisibleforSearch == true) {
                                if (SrViewModel.ControlsResponseData()[i][j][k].IsHeader == 1) {

                                    ContDynamicHTML += '<div  class="card-header">';
                                    ContDynamicHTML += '<span class="cp_assessment">';
                                    ContDynamicHTML += '<a href= "#accHeader_"' + SrViewModel.ControlsResponseData()[i][j][k].QuestionId + '" id ="accHeaderMain_"' + SrViewModel.ControlsResponseData()[i][j][k].QuestionId + '" data-toggle="collapse" data-parent="#accordion" aria-expanded="true">';
                                    ContDynamicHTML += '<i class="fa fa-fw fa-caret-right"></i> <span>' + SrViewModel.ControlsResponseData()[i][j][k].QuestionText + '</span>';
                                    ContDynamicHTML += '</a>';
                                    ContDynamicHTML += '</span>';
                                    ContDynamicHTML += '</div>';
                                }


                                if (SrViewModel.ControlsResponseData()[i][j][k].IsHeader == 0) {
                                    ContDynamicHTML += '<div class="question-card pl-4">'
                                    ContDynamicHTML += '<div class="card">'


                                    ContDynamicHTML += '<span class="card-title question-text p-2 mb-0">' + SrViewModel.ControlsResponseData()[i][j][k].QuestionText + '</span>'
                                    ContDynamicHTML += '<div class="col-md-11">'
                                    ContDynamicHTML += '<div class="p-1">';
                                    if (SrViewModel.ControlsResponseData()[i][j][k].ResposneObejct[0].ResponseApplicability_cd === 1) {
                                        ContDynamicHTML += '<span>' + SrViewModel.ControlsResponseData()[i][j][k].ResposneObejct[0].Response_cd + '</span>'
                                    }
                                    if (SrViewModel.ControlsResponseData()[i][j][k].ResposneObejct[0].ResponseApplicability_ce === 1) {
                                        ContDynamicHTML += '<span>' + SrViewModel.ControlsResponseData()[i][j][k].ResposneObejct[0].Response_ce + '</span>'

                                    }
                                    ContDynamicHTML += '</div>'
                                    ContDynamicHTML += '</div>'

                                    ContDynamicHTML += '</div>'
                                    ContDynamicHTML += '</div>'
                                }

                            }
                        }
                    }
                }

                ContDynamicHTML += '</div>';//header-card
                ContDynamicHTML += '</div>';//accordion

                $('#QualContDynamicHTMLDiv').html("");
                $('#QualContDynamicHTMLDiv').html(ContDynamicHTML);
                $('#loadingImgOrCalc').hide();
                $('#NoSurveyError').hide();
                $('#NoRiskAreaError').hide();
                $('#lblNoResponseComment').hide();
                $('#InnerInherentTabDiv111').show();

                if (ContDynamicHTML != "")
                    $("#TaxonomyLId").hide();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: controls() method in Activity.js';
                logger.logMessage(msg);
            }
        }

        function BindDynamicFilter() {
            try {
                var DynamicHtml = "";
                DynamicHtml = ' <div class="dropdown pull-right">' +
                    '<button id="myValueDropdownSort" data-bind="click: FormatValueData" class="dropbtn" style="">Filter<span id="valueDrip" class="fa fa-angle-down" style="margin-left: 4px;"></span></button>' +
                    '<div id="myValueDropdown" class="dropdown-content d-none">';
                for (var i = 0; i < SrViewModel.DistinctRiskLevelList().length; i++) {
                    DynamicHtml += '<a style="color:white;" href="#" id="' + SrViewModel.DistinctRiskLevelList()[i].riskLevelName.replace(/\s/g, '') + '" data-bind="click: $root.valuechange"><i class="fa fa-check" id="' + SrViewModel.DistinctRiskLevelList()[i].riskLevelName.replace(/\s/g, '') + 'CR" aria-hidden="true" style="display:none;"></i><span style="margin-left:8px;">' + SrViewModel.DistinctRiskLevelList()[i].riskLevelName + '</span></a>';
                }
                DynamicHtml += '<span class="empty">&nbsp;</span>' +
                    '<a href="#" id="Resettodefault" data-bind="click: $root.valuechange"><span>Reset to default</span></a>' +
                    '</div>' +
                    '</div>';


                $('#FilterDiv').html("");
                $('#FilterDiv').html(DynamicHtml);

                var element = $('#FilterDiv')[0];
                ko.cleanNode(element);
                ko.applyBindings(SrViewModel, document.getElementById('FilterDiv'));
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BindDynamicFilter() method in Activity.js';
                logger.logMessage(msg);
            }
        }


        //Filter code starts here
        function valuechange(data, event) {
            try {
                $("#TaxonomyLId").show();
                var optionValue = event.currentTarget.id;
                if ($('#' + event.currentTarget.id).children() != undefined && $('#' + event.currentTarget.id).children()[1] != undefined
                    && $('#' + event.currentTarget.id).children()[1].innerText != undefined && $('#' + event.currentTarget.id).children().innerText != 'NA') {
                    optionValue = $('#' + event.currentTarget.id).children()[1].innerText;
                }

                if (!($('#' + event.currentTarget.id + 'CR').is(":visible"))) {
                    SrViewModel.RemoveArray().push(optionValue);
                    $('#' + event.currentTarget.id + 'CR').show();
                }
                else {
                    SrViewModel.RemoveArray.remove(optionValue);
                    $('#' + event.currentTarget.id + 'CR').hide();
                }
                if (SrViewModel.ClickedSurveyTypeText().toLowerCase() == 'qldr') {
                    if (event.currentTarget.id != "Resettodefault") {

                        for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {

                            for (var j = 0; j < SrViewModel.QualResponseListData()[i].length; j++) {
                                for (var k = 0; k < SrViewModel.QualResponseListData()[i][j].length; k++) {
                                    var counter = 0;
                                    if (SrViewModel.RemoveArray().length != 0) {
                                        for (var h = 0; h < SrViewModel.RemoveArray().length; h++) {
                                            if (SrViewModel.QualResponseListData()[i][j][k].QualResponseObject[0].RiskLevelDescription.replace(/\s/g, '').toLowerCase() == SrViewModel.RemoveArray()[h].replace(/\s/g, '').toLowerCase()) {
                                                counter++
                                            }
                                        }
                                    }
                                    else {
                                        counter++;
                                    }
                                    if (counter > 0) {
                                        SrViewModel.QualResponseListData()[i][j][k].IsVisibleforSearch = true;
                                    } else {
                                        SrViewModel.QualResponseListData()[i][j][k].IsVisibleforSearch = false;
                                    }
                                }
                            }
                        }
                    }
                    else {
                        $.map(SrViewModel.QualResponseListData(), function (item) {
                            $.map(item, function (result) {
                                $.map(result, function (result1) {
                                    if (SrViewModel.RemoveArray().length != 0) {
                                        result.IsVisibleforSearch = true;
                                        result1.IsVisibleforSearch = true;
                                    }
                                })
                            })
                        })
                        for (var i = 0; i < SrViewModel.DistinctRiskLevelList().length; i++) {
                            $('#' + SrViewModel.DistinctRiskLevelList()[i].riskLevelName.replace(/\s/g, '') + "CR").hide();
                        }
                        SrViewModel.RemoveArray([]);
                    }
                    BindDynamicHtmlQualitative();
                }
                else if (SrViewModel.ClickedSurveyTypeText().toLowerCase() == 'cdr') {
                    if (event.currentTarget.id != "Resettodefault") {

                        for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {

                            for (var j = 0; j < SrViewModel.ControlsResponseData()[i].length; j++) {
                                for (var k = 0; k < SrViewModel.ControlsResponseData()[i][j].length; k++) {
                                    var counter = 0;
                                    if (SrViewModel.RemoveArray().length != 0) {
                                        for (var h = 0; h < SrViewModel.RemoveArray().length; h++) {
                                            if (SrViewModel.ControlsResponseData()[i][j][k].ResposneObejct[0].RiskLevelDescription_cd.replace(/\s/g, '').toLowerCase() == SrViewModel.RemoveArray()[h].replace(/\s/g, '').toLowerCase() ||
                                                SrViewModel.ControlsResponseData()[i][j][k].ResposneObejct[0].RiskLevelDescription_ce.replace(/\s/g, '').toLowerCase() == SrViewModel.RemoveArray()[h].replace(/\s/g, '').toLowerCase()) {
                                                counter++
                                            }
                                        }
                                    }
                                    else {
                                        counter++;
                                    }
                                    if (counter > 0) {
                                        SrViewModel.ControlsResponseData()[i][j][k].IsVisibleforSearch = true;
                                    } else {
                                        SrViewModel.ControlsResponseData()[i][j][k].IsVisibleforSearch = false;
                                    }
                                }
                            }
                        }
                    }
                    else {
                        $.map(SrViewModel.ControlsResponseData(), function (item) {
                            $.map(item, function (result) {
                                $.map(result, function (result1) {
                                    if (SrViewModel.RemoveArray().length != 0) {
                                        result.IsVisibleforSearch = true;
                                        result1.IsVisibleforSearch = true;
                                    }
                                })
                            })
                        })

                        for (var i = 0; i < SrViewModel.DistinctRiskLevelList().length; i++) {
                            $('#' + SrViewModel.DistinctRiskLevelList()[i].riskLevelName.replace(/\s/g, '') + "CR").hide();
                        }
                        SrViewModel.RemoveArray([]);
                    }
                    BindDynamicHtmlForControls();
                }
            }
            catch (e) {
                $("#TaxonomyLId").hide();
                var msg = 'Exception: ' + e + ' | Source: valuechange() method in Activity.js';
                logger.logMessage(msg);
            }
        }
        function FormatValueData(data, event) {
            document.getElementById("myValueDropdown").classList.toggle("SocValueDropdown");
            document.getElementById("myValueDropdown").classList.toggle("d-none");

            document.getElementById("valueDrip").classList.toggle("fa-angle-up");
            document.getElementById("valueDrip").classList.toggle("fa-angle-down");
        }



        function FormatValueDataLevel(data, event) {
            $('#myDropdown').removeClass('show');
            $('#myDropdownSort').removeClass('open');
            $('#myValueDropdown').removeClass('show');
            $('#myValueDropdownSort').removeClass('open');
            $('#ReportLinkDiv').removeClass('show');
            $('#ReportLinkDivBtn').removeClass('open')
            document.getElementById("myValueDropdownLevel").classList.toggle("show");
            document.getElementById("myValueDropdownSortLevel").classList.toggle("open");
        }

        function GetColumnDetails(type) {
            try {
                var DynUrl = "";
                if (type == 'cdr')
                    DynUrl = "/api/Survey/GetControlsColumnDetailsSocio";
                else
                    DynUrl = "/api/Survey/GetQualColumnDetailsSocio";

                return $.ajax({
                    url: DynUrl,
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { Type: SrViewModel.ClickedSurveyTypeText() }
                })
                    .success(function (jsonResult, success) {
                        SrViewModel.QualColumnDetails([]);
                        SrViewModel.ControlColumnDetails([]);
                        var mappedcolumndetails = $.map(jsonResult, function (result) {
                            if (type == 'cdr')
                                return new ControlsColumnDetailsModel(result);
                            else
                                return new QualColumnDetailsModel(result);
                        })
                        if (type == 'cdr') {
                            SrViewModel.ControlColumnDetails(mappedcolumndetails);
                        }
                        else
                            SrViewModel.QualColumnDetails(mappedcolumndetails);

                    })
                    .fail(function (fail, error) {

                    })
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetQualColumnDetails() method in Activity.js';
                logger.logMessage(msg);
            }
        }

        function ControlsColumnDetailsModel(item) {
            var self = this;
            self.ColumnId = ko.observable(item.ColumnId);
            self.Columntext = ko.observable($('<div/>').html(item.Columntext).text());
        }
        function QualColumnDetailsModel(item) {
            var self = this;
            self.ColumnId = ko.observable(item.ColumnId);
            self.ColumnName = ko.observable(item.ColumnName);
        }

        //////////////////////////////// --- Tree view code ---- ///////////////////////////////////
        function ToggleNavigationMenu1() {
            var chk2 = $('#NavigationToggle2');
            chk2.prop("checked", false);
            $("#FilterAreaAccordion").toggleClass("collapsedTreeview");
            $("#bottomDivAreaType").toggleClass("col-lg-12 col-lg-9");
            $("#bottomDivAreaType").toggleClass("col-md-12 col-md-9");
            $("#bottomDivAreaType").toggleClass("col-sm-12 col-sm-9");
            $("#bottomDivAreaType").toggleClass("col-xs-12 col-xs-9");
            $("#divNavSwitch2").show();
            $("#divjsTree").hide();
        }
        function ToggleNavigationMenu2() {
            var chk1 = $('#NavigationToggle1');
            chk1.prop("checked", true);
            $("#FilterAreaAccordion").toggleClass("collapsedTreeview");
            $("#bottomDivAreaType").toggleClass("col-lg-12 col-lg-9");
            $("#bottomDivAreaType").toggleClass("col-md-12 col-md-9");
            $("#bottomDivAreaType").toggleClass("col-sm-12 col-sm-9");
            $("#bottomDivAreaType").toggleClass("col-xs-12 col-xs-9");
            $("#divNavSwitch2").hide();
            $("#divjsTree").show();
        }
        function CollapseAllTreeView() {
            if ($('#spanExpandAll').text() == ((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name())) {
                $('#jsTreeAreaLevel').treeview('collapseAll', { silent: true });
                $("#spanExpandAll").text((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton') == -1) ? 'Collapse' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton')].Name());
            }
            else {
                $('#jsTreeAreaLevel').treeview('expandAll', { silent: true });
                $("#spanExpandAll").text((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name());
            }
        }
        function ExpandAllTreeView() {
            $('#jsTreeAreaLevel').treeview('expandAll', { silent: true });
        }
        function SearchTreeView() {
            $('#jsTreeAreaLevel').treeview('search', ['Parent', {
                ignoreCase: true,
                exactMatch: false,
                revealResults: true,
            }]);
        }

        function InitiateLevelTree() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getJsTreeAreaLevel = {
                    url: "/api/Configuration/GetEALData",
                    type: "GET",
                    data: { RiskAreType: SrViewModel.ClickedSurveyTypeText(), SurveyCategoryID: SrViewModel.Zat_id_Tree().toString(), AssessmentTypes: SrViewModel.AssessmentTypeId().toString(), ScreenType: 'RA' },
                    headers: headers
                };
                $.ajax(getJsTreeAreaLevel)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in InitiateLevelTree() method in SocializationResponse.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                if (jsonResult != null) {
                    //implement js tree logic here
                    SrViewModel.AreaLeveljstree(jsonResult.AreaLevelsData);
                    var MappedJsTreeList = $.map(jsonResult.AreaLevelsData["#"], function (result) {
                        return new jsTreeModel(result);
                    });

                    $('#jsTreeAreaLevel').treeview({
                        data: MappedJsTreeList,
                        onNodeSelected: nodeClickEvent
                    });
                    //for initial load expand for treeview
                    $("#jsTreeAreaLevel ul:first li:first").trigger("click");
                    $("loadingImgOrCalc").hide();
                    $("loadingMainImgDiv").hide();

                }
            }

            function nodeClickEvent(event, node) {
                try {
                    // Your logic goes here
                    SrViewModel.Type(node.RA_Type());
                    if (node.dead_node == 1) {
                        $('#jsTreeAreaLevel').treeview('selectNode', [node.nodeId, { silent: true }]);

                        SrViewModel.ClickedRiskAreaId(parseInt(node.id));
                        SrViewModel.ClickedRiskAreaName($('<div/>').html(node.text).text());

                        if (SrViewModel.ClickedSurveyTypeText().toLowerCase() == 'qldr') {
                            GetQualResponseDetails(SrViewModel.Zat_id_Tree());
                        }
                        else {
                            GetControlResponseDetails(SrViewModel.Zat_id_Tree());
                        }

                    } else {
                        //recursively opening until the dead_node arrives.
                        if (!(node.state.expanded))
                            nodeClickEvent(event, node.nodes[0]);
                        $('#jsTreeAreaLevel').treeview((!(node.state.expanded) ? 'expandNode' : 'collapseNode'), [node.nodeId]);
                        $('#jsTreeAreaLevel').treeview('unselectNode', [node.nodeId, { silent: true }]);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in SocializationResponse.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            };
        }

        function jsTreeModel(item) {
            var self = this;

            self.id = item.AreaLevelId.toString();
            self.text = item.AreaLevelName;
            if (SrViewModel.AreaLeveljstree()[self.id].length > 0) {
                self.nodes = $.map(SrViewModel.AreaLeveljstree()[self.id], function (result) {
                    return new jsTreeModel(result);
                });
            }
            self.state = { expanded: false };
            self.dead_node = item.DeadNode;
            self.assessmentTypeList = ko.observableArray(item.AssessmentTypeList);
            self.RA_Type = ko.observable(item.RA_Type);
        }
        //////////////////////////////// --- Tree view code till here---- ///////////////////////////////////

        //#endregion

        //#region Reports Section

        function NavigateToSocioExportReport() {
            try {

                $('#loadingMainImgDivHm').show();
                var payLoad = {
                    t: appsecurity.getAuthenticationInfo(), OrgLevel: SrViewModel.BusinessUnitId()
                };
                utils.postAndRedirect(rootPath + "/FileDownload/ExportSocializationReportToExcel", payLoad, '_blank');
                $('#loadingMainImgDivHm').hide();

            }
            catch (e) {
                var msg = 'exception' + e + 'source in NavigateToSocioExportReport() in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function NavigateToSocioHistoricExportReport(data) {
            try {

                $('#loadingMainImgDivHm').show();
                var payLoad = {
                    t: appsecurity.getAuthenticationInfo(), OrgLevel: SrViewModel.BusinessUnitId()
                };
                utils.postAndRedirect(rootPath + "/FileDownload/ExportSocializationHistoricReportToExcel", payLoad, '_blank');
                $('#loadingMainImgDivHm').hide();

            }
            catch (e) {
                var msg = 'exception' + e + 'source in NavigateToSocioHistoricExportReport() in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function DisplayExportDropdown(data, event) {
            try {
                $('#myValueDropdownLevel').removeClass('show');
                $('#myValueDropdownSortLevel').removeClass('open');
                $('#myDropdown').removeClass('show')
                $('#myDropdownSort').removeClass('open')
                $('#myValueDropdown').removeClass('show')
                $('#myValueDropdownSort').removeClass('open')

                document.getElementById("ReportLinkDiv").classList.toggle("show");
                document.getElementById("ReportLinkDivBtn").classList.toggle("open");
            }
            catch (e) {
                var msg = 'exception' + e + 'source in DisplayExportDropdown() in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function ViewSelectedReport() {
            try {
                var selectedValue = document.getElementById("ReportsDropDown").value;
                if (selectedValue === "Reports")
                    return;
                else if (selectedValue === "SR")
                    NavigateToSocioExportReport();
                else if (selectedValue === "SHR")
                    NavigateToSocioHistoricExportReport();
                else if (selectedValue === "WFS")
                    StatusPopUpClick();
                $('#ReportsDropDown').prop('selectedIndex', 0);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ViewSelectedReport() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        function valuechangeLevel(data, event) {
            try {
                var optionId = document.getElementById("LevelsDropDown").value;
                var optionText = document.getElementById("LevelsDropDown").text;
                SrViewModel.ChangesTabClick(false);
                //if (SrViewModel.tabType() == 'HEATMAP_TYPE2' && optionId === '-999') {
                //    SrViewModel.SelectedTaxonomyOptionFlag(true);
                //} else {
                    SrViewModel.SelectedTaxonomyOptionFlag(false);
                //}
                SrViewModel.SelectedTaxonomyOptionText(optionText);
                SrViewModel.SelectedTaxonomyOption(optionId);
                SrViewModel.SelectedTaxonomyOptionRefresh(optionId);
                SrViewModel.contentTabVisible(false);

                if (SrViewModel.tabType() != "") {
                    GetAllHeatmapData();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: valuechangeLevel() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function showSurveyInfoClick(SurveyId) {
            try {
                if ($('#surveyInfoDiv_' + SurveyId).is(':visible')) {
                    $('#surveyInfoDiv_' + SurveyId).hide();
                    $('#surveyInfoDivMore_' + SurveyId).show();
                    $('#surveyInfoDivLess_' + SurveyId).hide();
                }
                else {
                    $('#surveyInfoDiv_' + SurveyId).show();
                    $('#surveyInfoDivLess_' + SurveyId).show();
                    $('#surveyInfoDivMore_' + SurveyId).hide();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: showSurveyInfoClick() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function showOverallSummaryDiv() {
            try {
                GetSurveyLevelComments("SN");
                GetSurveyLevelComments("SND");
                $('#OverallSummaryDiv').modal('show');
                var editor = CKEDITOR.instances['NarrationTextArea'];
                if (editor) {
                    editor.destroy(true);
                }
                CKEDITOR.replace('NarrationTextArea', {
                    removePlugins: SrViewModel.RemovePlugins(),
                    removeButtons: SrViewModel.RemoveButtons(),
                    disableNativeSpellChecker: false
                });
                $('#NarrationTextArea').html(SrViewModel.NarrationComment());
                document.getElementById('lblRDErrorSummary').innerHTML = "";
                document.getElementById('lblProgressMsgSummary').innerHTML = "";
                document.getElementById('SummaryFileTextAreaSocio').value = null;
                document.getElementById('SummaryFileUploader').value = null;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: showOverallSummaryDiv() method in SocializationResponse.js';

                logger.logMessage(msg);
            }
        }

        //saving for future reference
        //function ckeCharCheck() {
        //    try {
        //        var comment = CKEDITOR.instances["NarrationTextArea"].getData(),
        //            textLength = comment.replace(/(<p>|<\/p>|<strong>|<\/strong>|<em>|<\/em>|<u>|<\/u>|<ol>|<\/ol>|<ul>|<\/ul>|<li>|<\/li>)/gi, "").length,
        //            remainingChars = 4000 - textLength;

        //        if (remainingChars < 0)
        //            remainingChars = 0;

        //        SrViewModel.RemainingChars(remainingChars);

        //    } catch (e) {
        //        var msg = 'Exception: ' + e + ' | Source: ajaxFail in ckeCharCheck() method in SocializationResponse.js';
        //        logger.logMessage(msg);
        //    }
        //}

        function SaveSurveySummary() {
            try {
                var ckeComment = CKEDITOR.instances["NarrationTextArea"].getData();

                if (ckeComment == "" || ckeComment == undefined) {
                    $("#lblNarrationError").show();
                    document.getElementById('lblNarrationError').innerHTML = "Please enter some comment to save.";
                }
                else {
                    $("#lblNarrationError").hide();
                    document.getElementById('lblNarrationError').innerHTML = "";
                    SetSurveyLevelComments("SN");
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveSurveySummary() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function SetSurveyLevelComments(commentType) {
            try {
                var eventId = -1;
                var commentId = -1;
                if (commentType === 'SN') {
                    commentText = CKEDITOR.instances["NarrationTextArea"].getData();

                    if (SrViewModel.SurveySummaryCommentId() != undefined | SrViewModel.SurveySummaryCommentId() != 0)
                        commentId = parseInt(SrViewModel.SurveySummaryCommentId());
                } else if (commentType === 'PBC') {
                    eventId = parseInt(SrViewModel.SelectedActionEventId());
                    commentText = SrViewModel.PushbackComment()
                }
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/SetSurveyLevelComments",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        Draft: SrViewModel.SurveyId(), AssessmentProfileId: parseInt(SrViewModel.CurrentProfileOfAssessmentId()),
                        EventId: eventId, CommentId: commentId, RoleId: appsecurity.userInfo().PrimaryRoleId(), CommentText: commentText,
                        CommentType: commentType, SurveyType: SrViewModel.SurveyClassification()
                    }),
                    type: "POST",
                    headers: headers
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetSurveyLevelComments() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (commentType === 'PBC') {
                        if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                            logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                        }
                        else if (!isNaN(jsonResult) && parseInt(jsonResult) > 0) {
                            PerformSurveyAction();
                        }
                        else {
                            logger.logError("Error occurred while saving comments. Please try again.", 'Error', system.getModuleId(SrViewModel), true);
                        }
                    }
                    else if (commentType === 'SN') {
                        if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                            logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                        }
                        else if (!isNaN(jsonResult) && parseInt(jsonResult) > 0) {
                            logger.logSuccess('Summary details saved successfully.', 'Success', system.getModuleId(SrViewModel), true);
                            GetSurveyLevelComments(commentType);
                        }
                        else {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SetSurveyLevelComments() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SetSurveyLevelComments() method in SocializationResponse.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in SetSurveyLevelComments() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetSurveyLevelComments(commentType) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Survey/GetSurveyLevelComments",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    type: "POST",
                    headers: headers,
                    data: ko.toJSON({ Draft: SrViewModel.SurveyId(), SurveyType: SrViewModel.SurveyClassification(), CommentType: commentType, AssessmentProfileId: parseInt(SrViewModel.CurrentProfileOfAssessmentId()) })
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetSurveyLevelComments() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (commentType === "PBC") {
                        SrViewModel.SurveyTimelineComments([]);
                        if (jsonResult !== "") {
                            if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                                logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else {
                                var convertedObj = JSON.parse(jsonResult);
                                var mappedList = ko.mapping.fromJS(convertedObj.Comments)();
                                SrViewModel.SurveyTimelineComments(mappedList);
                            }
                        }
                        else {
                            $('#showCmpltTimelineBtn').hide();
                            $('#showLessTimelineBtn').hide();
                        }
                    }
                    else if (commentType === "SN") {
                        if (jsonResult !== "") {
                            if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                                logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else {
                                SrViewModel.NarrationComment('');
                                var summaryObj = JSON.parse(jsonResult);
                                var summaryComment = ko.mapping.fromJS(summaryObj.Comments)();
                                SrViewModel.SurveySummaryCommentId(summaryComment[0].CommentId());
                                SrViewModel.SurveySummaryComment("");
                                SrViewModel.NarrationComment(summaryComment[0].CommentText());
                                $('#NarrationTextArea').html(SrViewModel.NarrationComment());
                                SrViewModel.SummaryCommentBy(summaryComment[0].UserName());
                                SrViewModel.SummaryCommentCreatedDate(summaryComment[0].CreateDate());
                            }
                        }
                        else {
                            SrViewModel.SurveySummaryCommentId(0);
                            SrViewModel.SurveySummaryComment('');
                            SrViewModel.SummaryCommentBy('');
                            SrViewModel.SummaryCommentCreatedDate('');
                        }
                    }
                    else if (commentType === "SND") {
                        SrViewModel.SummaryDocumentsList([]);
                        if (jsonResult !== "") {
                            if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                                logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else {
                                var docObj = JSON.parse(jsonResult);
                                var mappedDocList = ko.mapping.fromJS(docObj.Comments)();
                                SrViewModel.SummaryDocumentsList(mappedDocList);
                            }
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetSurveyLevelComments() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyLevelComments() method in SocializationResponse.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetSurveyLevelComments() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            }
        }

        function collapse(Id) {
            try {

                $("#ICcollapse" + Id).hide()
                $("#ICexapnd" + Id).show()

                if (SrViewModel.AssessmentType() == 2 && SrViewModel.RiskType() == "ALL" && SrViewModel.ShowFinalLevel()) {
                    if ($("#colspan_" + Id) != undefined && $("#colspan_" + Id)[0] != undefined)
                        $("#colspan_" + Id)[0].colSpan = 3;

                    for (var i = 0; i < SrViewModel.editableTypes().length - 1; i++) {
                        if (SrViewModel.editableTypes()[i].ColType() != 'F')
                            $("#Bu" + Id + "_" + SrViewModel.editableTypes()[i].ResponseId()).hide();
                    }

                } else {
                    if ($("#colspan_" + Id) != undefined && $("#colspan_" + Id)[0] != undefined)
                        $("#colspan_" + Id)[0].colSpan = 1;

                    for (var i = 0; i < SrViewModel.editableTypes().length - 1; i++) {
                        $("#Bu" + Id + "_" + SrViewModel.editableTypes()[i].ResponseId()).hide();
                    }
                }

                if (SrViewModel.InhRiskThemeDetails() != undefined) {
                    for (var i = 0; i < SrViewModel.InhRiskThemeDetails().length; i++) {
                        var counter = 0;
                        for (var j = 0; j < SrViewModel.InhRiskThemeDetails()[i].BusinessUnitCountList.length; j++) {
                            for (var k = 0; k < SrViewModel.InhRiskThemeDetails()[i].BusinessUnitCountList[j].ResponseList.length - 1; k++) {
                                if (Id == SrViewModel.InhRiskThemeDetails()[i].BusinessUnitCountList[j].ResponseList[k].BU_ID) {
                                    counter++;
                                    var cellData = SrViewModel.InhRiskThemeDetails()[i].BusinessUnitCountList[j].ResponseList[k];
                                    $('#Bu' + Id + '-' + cellData.Id + '-' + cellData.ZAT_UID).hide();
                                }
                            }
                            if (counter > 0)
                                break;
                        }
                    }
                }

                if (SrViewModel.ContRiskThemeDetails() != undefined) {
                    for (var i = 0; i < SrViewModel.ContRiskThemeDetails().length; i++) {
                        var counter = 0;
                        for (var j = 0; j < SrViewModel.ContRiskThemeDetails()[i].BusinessUnitCountList.length; j++) {
                            for (var k = 0; k < SrViewModel.ContRiskThemeDetails()[i].BusinessUnitCountList[j].ResponseList.length - 1; k++) {
                                if (Id == SrViewModel.ContRiskThemeDetails()[i].BusinessUnitCountList[j].ResponseList[k].BU_ID) {
                                    counter++;
                                    var cellData = SrViewModel.ContRiskThemeDetails()[i].BusinessUnitCountList[j].ResponseList[k];
                                    $('#Bu' + Id + '-' + cellData.Id + '-' + cellData.ZAT_UID).hide();
                                }
                            }
                            if (counter > 0)
                                break;
                        }
                    }
                }

                if (SrViewModel.AssessmentType() == 1) {

                    if (SrViewModel.AggregateBUDetailsInherent() != undefined) {
                        for (var i = 0; i < SrViewModel.AggregateBUDetailsInherent().length; i++) {
                            if (Id == SrViewModel.AggregateBUDetailsInherent()[i].BU_ID) {
                                var cellData = SrViewModel.AggregateBUDetailsInherent()[i];
                                if (cellData.ZAT_TYPE != 'F')
                                    $('#Bu' + Id + '-' + cellData.ZAT_UID).hide();
                            }
                        }
                    }

                    if (SrViewModel.AggregateBUDetailsControl() != undefined) {
                        for (var i = 0; i < SrViewModel.AggregateBUDetailsControl().length; i++) {
                            if (Id == SrViewModel.AggregateBUDetailsControl()[i].BU_ID) {
                                var cellData = SrViewModel.AggregateBUDetailsControl()[i];
                                if (cellData.ZAT_TYPE != 'F')
                                    $('#Bu' + Id + '-' + cellData.ZAT_UID).hide();
                            }
                        }
                    }

                    if (SrViewModel.AggregateBUDetailsResidual() != undefined) {
                        for (var i = 0; i < SrViewModel.AggregateBUDetailsResidual().length; i++) {
                            if (Id == SrViewModel.AggregateBUDetailsResidual()[i].BU_ID) {
                                var cellData = SrViewModel.AggregateBUDetailsResidual()[i];
                                if (cellData.ZAT_TYPE != 'F')
                                    $('#Bu' + Id + '-' + cellData.ZAT_UID).hide();
                            }
                        }
                    }
                }

                else if (SrViewModel.AssessmentType() == 2) {
                    if (SrViewModel.CRAAggregateBUInformation() != undefined) {
                        for (var i = 0; i < SrViewModel.CRAAggregateBUInformation().length; i++) {
                            if (Id == SrViewModel.CRAAggregateBUInformation()[i].BU_ID) {
                                var cellData = SrViewModel.CRAAggregateBUInformation()[i];
                                if (cellData.ZAT_TYPE != 'F')
                                    $('#Bu' + Id + '-' + cellData.ZAT_UID).hide();
                            }
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: collapse() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function expand(Id) {
            try {

                $("#ICexapnd" + Id).hide();
                $("#ICcollapse" + Id).show();

                if (SrViewModel.AssessmentType() == 2 && SrViewModel.RiskType() == "ALL" && SrViewModel.ShowFinalLevel()) {
                    if ($("#colspan_" + Id) != undefined && $("#colspan_" + Id)[0] != undefined)
                        $("#colspan_" + Id)[0].colSpan = SrViewModel.editableTypes().length - 3;

                } else {
                    if ($("#colspan_" + Id) != undefined && $("#colspan_" + Id)[0] != undefined)
                        $("#colspan_" + Id)[0].colSpan = SrViewModel.editableTypes().length - 1;

                }
                for (var i = 0; i < SrViewModel.editableTypes().length; i++) {
                    if (SrViewModel.editableTypes()[i].ShowFlag()) {
                        $("#Bu" + Id + "_" + SrViewModel.editableTypes()[i].ResponseId()).show();
                    }
                }

                for (var i = 0; i < SrViewModel.InhRiskThemeDetails().length; i++) {
                    var counter = 0;
                    for (var j = 0; j < SrViewModel.InhRiskThemeDetails()[i].BusinessUnitCountList.length; j++) {

                        for (var k = 0; k < SrViewModel.InhRiskThemeDetails()[i].BusinessUnitCountList[j].ResponseList.length - 1; k++) {
                            if (Id == SrViewModel.InhRiskThemeDetails()[i].BusinessUnitCountList[j].ResponseList[k].BU_ID) {
                                counter++;
                                var cellData = SrViewModel.InhRiskThemeDetails()[i].BusinessUnitCountList[j].ResponseList[k];
                                if (cellData.ZAT_TYPE != 'Q' && cellData.ZAT_TYPE != 'F') {
                                    $('#Bu' + Id + '-' + cellData.Id + '-' + cellData.ZAT_UID).show();
                                }
                            }
                        }
                        if (counter > 0)
                            break;

                    }
                }

                if (SrViewModel.ContRiskThemeDetails() != undefined) {
                    for (var i = 0; i < SrViewModel.ContRiskThemeDetails().length; i++) {
                        var counter = 0;
                        for (var j = 0; j < SrViewModel.ContRiskThemeDetails()[i].BusinessUnitCountList.length; j++) {
                            for (var k = 0; k < SrViewModel.ContRiskThemeDetails()[i].BusinessUnitCountList[j].ResponseList.length - 1; k++) {
                                if (Id == SrViewModel.ContRiskThemeDetails()[i].BusinessUnitCountList[j].ResponseList[k].BU_ID) {
                                    counter++;
                                    var cellData = SrViewModel.ContRiskThemeDetails()[i].BusinessUnitCountList[j].ResponseList[k];
                                    if (cellData.ZAT_TYPE != 'Q' && cellData.ZAT_TYPE != 'F') {
                                        $('#Bu' + Id + '-' + cellData.Id + '-' + cellData.ZAT_UID).show();
                                    }
                                }
                            }
                            if (counter > 0)
                                break;
                        }
                    }
                }

                if (SrViewModel.AssessmentType() == 1) {

                    if (SrViewModel.AggregateBUDetailsInherent() != undefined) {
                        for (var i = 0; i < SrViewModel.AggregateBUDetailsInherent().length; i++) {
                            if (Id == SrViewModel.AggregateBUDetailsInherent()[i].BU_ID) {
                                var cellData = SrViewModel.AggregateBUDetailsInherent()[i];
                                if (cellData.ZAT_TYPE != 'Q' && cellData.ZAT_TYPE != 'F') {
                                    $('#Bu' + Id + '-' + cellData.ZAT_UID).show();
                                }
                            }
                        }
                    }

                    if (SrViewModel.AggregateBUDetailsControl() != undefined) {
                        for (var i = 0; i < SrViewModel.AggregateBUDetailsControl().length; i++) {
                            if (Id == SrViewModel.AggregateBUDetailsControl()[i].BU_ID) {
                                var cellData = SrViewModel.AggregateBUDetailsControl()[i];
                                if (cellData.ZAT_TYPE != 'Q' && cellData.ZAT_TYPE != 'F') {
                                    $('#Bu' + Id + '-' + cellData.ZAT_UID).show();
                                }
                            }
                        }
                    }

                    if (SrViewModel.AggregateBUDetailsResidual() != undefined) {
                        for (var i = 0; i < SrViewModel.AggregateBUDetailsResidual().length; i++) {
                            if (Id == SrViewModel.AggregateBUDetailsResidual()[i].BU_ID) {
                                var cellData = SrViewModel.AggregateBUDetailsResidual()[i];
                                if (cellData.ZAT_TYPE != 'Q' && cellData.ZAT_TYPE != 'F') {
                                    $('#Bu' + Id + '-' + cellData.ZAT_UID).show();
                                }
                            }
                        }
                    }
                }

                else if (SrViewModel.AssessmentType() == 2) {
                    if (SrViewModel.CRAAggregateBUInformation() != undefined) {
                        for (var i = 0; i < SrViewModel.CRAAggregateBUInformation().length; i++) {
                            if (Id == SrViewModel.CRAAggregateBUInformation()[i].BU_ID) {
                                var cellData = SrViewModel.CRAAggregateBUInformation()[i];
                                if (cellData.ZAT_TYPE != 'Q' && cellData.ZAT_TYPE != 'F') {
                                    $('#Bu' + Id + '-' + cellData.ZAT_UID).show();
                                }
                            }
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: expand() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function UploadDocument(data) {
            try {

                var Filelist = "";
                var FileName = "";
                var errormsgId = "";
                var ProgressBarMainDivId = "";
                var ProgressMsgId = "";

                if (data === 'SN' || data == 'SND') {
                    SrViewModel.UploadComment($("#SummaryFileTextAreaSocio").val());
                    errormsgId = '#lblRDErrorSummary';
                    ProgressBarMainDivId = '#ProgressBarMainDivSummary';
                    ProgressMsgId = '#lblProgressMsgSummary';
                    FileList = document.getElementById('SummaryFileUploader').files;
                    if (FileList.length > 0)
                        FileName = document.getElementById('SummaryFileUploader').files[0].name;
                } else if (data === 'SO-OD') {
                    SrViewModel.UploadComment($("#SummaryFileTextAreaOvr").val());
                    errormsgId = '#lblRDErrorSummaryOvr';
                    FileList = document.getElementById('SummaryFileUploaderOvr').files;
                    if (FileList.length > 0)
                        FileName = document.getElementById('SummaryFileUploaderOvr').files[0].name;
                }
                if (SrViewModel.UploadComment().toString().trim().length <= SrViewModel.OverrideCommentsCharsLimit()) {
                    if (FileList.length > 0) {
                        if (FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PNG'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'JPG'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'JPEG'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'DOCX'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'DOC'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLS'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PDF'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'CSV'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'TXT'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLSX'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLSM'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'BMP'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'RTF'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PPT'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PPTX'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'MSG') {

                            if (FileList[0].size <= 1073741824) {
                                if (SrViewModel.UploadComment().toString().trim() != "" && SrViewModel.UploadComment() != undefined) {
                                    $(errormsgId).text("");
                                    $(ProgressMsgId).removeClass('field-validation-error');
                                    var FormDataObj = new FormData();
                                    FormDataObj.append("File1", FileList[0]);
                                    var request = new XMLHttpRequest();
                                    $(ProgressBarMainDivId).show();
                                    request.onreadystatechange = function () {
                                        if (request.readyState == 1) {
                                            SrViewModel.ProgressMessage("Initializing File Upload...");
                                        }
                                        else if (request.readyState == 4) {

                                            if (request.status == 200) {
                                                if (request.responseText != null && request.responseText != "" && request.responseText != "null") {
                                                    SrViewModel.ProgressMessage("The file has been uploaded successfully.");

                                                    var DocName = "";
                                                    if (data === 'SN' || data === 'SND') {
                                                        DocName = document.getElementById('SummaryFileUploader').files[0].name;
                                                        SetDocumentComments(-1, "SND", DocName, JSON.parse(request.response), SrViewModel.UploadComment()).then(function () {
                                                            document.getElementById('SummaryFileUploader').value = null;
                                                            document.getElementById('SummaryFileTextAreaSocio').value = null;
                                                            GetSurveyLevelComments("SND");
                                                        });
                                                    }
                                                    else {

                                                        DocName = document.getElementById('SummaryFileUploaderOvr').files[0].name;
                                                        document.getElementById('SummaryFileUploaderOvr').value = null;

                                                        SetDocumentComments(SrViewModel.TableUid(), "SO-OD", DocName, JSON.parse(request.response), SrViewModel.UploadComment()).then(function () {
                                                            document.getElementById('SummaryFileTextAreaOvr').value = '';
                                                            getComments(SrViewModel.TableType(), SrViewModel.TableUid(), "SO-OD");
                                                            SrViewModel.RemainingChars(SrViewModel.OverrideCommentsCharsLimit());
                                                        });

                                                    }
                                                    $(ProgressBarMainDivId).hide();
                                                    SrViewModel.UploadComment("");
                                                    //$('#ProgressBarDiv').hide();
                                                    SrViewModel.ProgressMessage("");
                                                    logger.logSuccess((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileUploadSuccessMessage') == -1) ? 'The file has been uploaded successfully.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileUploadSuccessMessage')].Name(), 'Success', system.getModuleId(SrViewModel), true);
                                                }
                                                else {
                                                    $(ProgressBarMainDivId).show();
                                                    $(ProgressMsgId).addClass('field-validation-error');
                                                    SrViewModel.ProgressMessage("The file could not be uploaded.");

                                                }
                                            }
                                        }
                                        else
                                            ajaxFail(request, "");

                                    };
                                    request.upload.addEventListener('progress', function (event) {
                                        SrViewModel.ProgressPercent(parseInt((event.loaded / event.total) * 100) + '%');
                                        SrViewModel.ProgressMessage("Uploading File...");
                                    });
                                    request.withCredentials = true;
                                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                                    var headers = appsecurity.getSecurityHeaders();
                                    headers.__RequestVerificationToken = csrfToken;
                                    request.open('POST', '/api/Survey/FileUpload');
                                    request.setRequestHeader('Authorization', headers.Authorization);
                                    request.setRequestHeader('RT', headers.RT);
                                    request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                                    request.send(FormDataObj);
                                    logger.logMessage("The file has been uploaded successfully.");
                                    $(ProgressBarMainDivId).hide();
                                }
                                else
                                    $(errormsgId).text("Please enter some comment related to the uploaded file.");
                            }
                            else
                                $(errormsgId).text("Upload file size cannot exceed the limit. Please try uploading a file of lesser size.");
                        }
                        else
                            $(errormsgId).text("Please select a valid file to upload.");
                    }
                    else
                        $(errormsgId).text("Please select a file to upload.");
                }
                else
                    $(errormsgId).text("Upload Comment cannot exceed " + SrViewModel.OverrideCommentsCharsLimit() + " characters.");

                function ajaxFail(error, status) {

                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK")
                                        router.navigate("login", true);
                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in UploadDocuments() method in SocializationResponse.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadDocuments() method in SocializationResponse.js';
                        logger.logMessage(msg);
                    }
                };

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: UploadDocument() method in SocializationResponse.js';
                logger.logMessage(msg);
            }

        }

        function SetDocumentComments(QuestionId, CommentType, DocName, DocPath, CommentText) {
            try {
                var tableType = "";
                if (CommentType === 'SO-OD') {
                    tableType = SrViewModel.TableType();
                }
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Survey/SetDocumentComments",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        QuestionId: QuestionId, Draft: SrViewModel.SurveyId(), SurveyType: SrViewModel.SurveyClassification(), CommentType: CommentType, CommentText: CommentText, DocumentPath: DocPath, DocumentName: DocName, TableType: tableType
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(function (jsonResult, error) {
                        if (isNaN(jsonResult)) {
                            logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                        }
                        else if (CommentType === 'SND') {
                            //Code flows here
                        }
                    })
                    .fail(function () {
                        return;
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetDocumentComments() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function DocumentCommentModel(item) {
            try {
                var self = this;
                self.DCommentText = ko.observable(item.comment);
                self.DCommentId = ko.observable(item.commentID);
                self.DUploadedBy = ko.observable(item.addedBy);
                self.DUploadedDate = ko.observable(item.commentAddedOn);
                self.DIsCurrentUser = ko.observable(item.isCommentEditable);
                self.DocumentName = ko.observable(item.DocumentName);
                self.DocumentPath = ko.observable(item.DocumentPath);
                self.roleName = ko.observable(item.roleName);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DocumentCommentModel() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function DownloadDocument(data, event) {
            try {
                var DocumentInfo = data;
                var test = $.ajax({
                    url: "/api/Survey/CheckFilePresence",
                    type: "Get",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { CommentId: data.DCommentId(), FilePath: data.DocumentPath(), FileName: data.DocumentName() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in DownloadDocument() method in SocializationResponse.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status, xhr) {
                try {

                    if (jsonResult) {
                        var payLoad = {
                            t: appsecurity.getAuthenticationInfo(), FilePath: data.DocumentPath(), FileName: data.DocumentName()
                        };
                        utils.postAndRedirect(rootPath + "/FileDownload/DownloadFile", payLoad, '_blank');
                    }
                    else
                        logger.logError('The requested document is not available for download. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DownloadDocument() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DownloadDocument() method in SocializationResponse.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DownloadDocument() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            };
        }

        function DeleteDocument(data, commentType) {
            try {
                if (commentType != 'SND')
                    commentType = 'SO-OD';
                app.showMessage('Are you sure you want to delete this document?', 'Delete Document', ['Confirm', 'Cancel'])
                    .then(function (option) {
                        if (option === 'Confirm') {
                            DeleteResponseDocument(data, commentType);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DeleteDocument() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function DeleteResponseDocument(data, commentType) {
            try {

                var DocumentInfo = data;
                var test = $.ajax({
                    url: "/api/Survey/CheckFilePresence?CommentId=" + data.DCommentId() + "&FileName=" + data.DocumentName() + "&FilePath=" + data.DocumentPath(),
                    type: "Get",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in DeleteResponseDocument() method in SocializationResponse.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status, xhr) {
                try {
                    if (jsonResult) {
                        DeleteDocComments(data, commentType);
                    }
                    else
                        logger.logError('The requested document is not available to delete. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DeleteResponseDocument() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteResponseDocument() method in SocializationResponse.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteResponseDocument() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            };
        }

        function DeleteDocComments(data, commentType) {
            try {

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/DeleteDocComments",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        CommentId: data.DCommentId,
                        QuestionId: -1,
                        Draft: SrViewModel.SurveyId(),
                        CommentType: commentType,
                        SurveyType: SrViewModel.SurveyClassification()
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | DeleteDocComments() in SocializationResponse.js'
                logger.logMessage(msg);
            }
            function ajaxSuccess(result, status) {
                try {
                    if (isNaN(result)) {
                        logger.logError(result + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                    }
                    else if (!isNaN(result) && parseInt(result) >= 0) {
                        DeleteFile(data, result, commentType);
                    }
                    else
                        logger.logError('An error occurred while deleting the document.', 'Error', system.getModuleId(SrViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception' + e + ' | Source | ajaxSuccess in DeleteDocComments() in SocializationResponse.js'
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteDocComments() method in SocializationResponse.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteDocComments() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            }
        }

        function DeleteFile(data, DocCount, commentType) {
            try {

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/DeleteFile",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        DocumentPath: data.DocumentPath(),
                        DocumentName: data.DocumentName()
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | DeleteFile() in SocializationResponse.js'
                logger.logMessage(msg);
            }

            function ajaxSuccess(result, status) {
                try {
                    if (result.toLowerCase() == 'ok') {
                        logger.logSuccess('Document deleted successfully.', 'Success', system.getModuleId(SrViewModel), true);
                        if (commentType == "SND")
                            GetSurveyLevelComments(commentType);
                        else if (commentType == "SO-OD")
                            getComments(SrViewModel.TableType(), SrViewModel.TableUid(), commentType);
                    }
                    else if (result.substring(0,3) == "INC")
                        logger.logError(result + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                    else
                        logger.logError('An error occurred while deleting the document.', 'Error', system.getModuleId(SrViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception' + e + ' | Source | ajaxSuccess in DeleteFile() in SocializationResponse.js'
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteFile() method in SocializationResponse.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteFile() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            }
        }

        function ClearResult() {
            try {
                if (SrViewModel.Query() != "") {
                    $(".reset-search").show();
                    return false;
                }
                else {
                    $(".reset-search").hide();
                    ResetSearch_Main();
                }

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearResult() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function ClearSearchText() {
            try {
                SrViewModel.Query('');
                $('#searchFeature_ht').val('');
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearSearchText() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function CopyComment(data) {
            try {
                $('#' + data).show();
                var copyText = $('#' + data);
                copyText.focus();
                copyText.select();
                document.execCommand('copy');
                $('#' + data).hide();
                logger.logSuccess('Comment copied to clipboard successfully.', 'Success', system.getModuleId(SrViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CopyComment() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function ResidualFilter() {
            try {
                SrViewModel.RiskType('R');
                $('#filter li a').removeClass("active");
                $('#FilterRes').addClass("active");
                SrViewModel.showInherent(false);
                SrViewModel.showControl(false);
                SrViewModel.showResidual(true);
                GetAllHeatmapData();
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResidualFilter() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function ControlFilter() {
            try {
                SrViewModel.RiskType('C');
                $('#filter li a').removeClass("active");
                $('#FilterCnt').addClass("active");
                SrViewModel.showInherent(false);
                SrViewModel.showControl(true);
                SrViewModel.showResidual(false);
                GetAllHeatmapData();
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ControlFilter() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function InherentFilter() {
            try {
                SrViewModel.RiskType('I');
                $('#filter li a').removeClass("active");
                $('#FilterInh').addClass("active");
                SrViewModel.showInherent(true);
                SrViewModel.showControl(false);
                SrViewModel.showResidual(false);
                GetAllHeatmapData();
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: InherentFilter() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function FilterALL() {
            try {
                SrViewModel.RiskType('ALL');
                $('#filter li a').removeClass("active");
                $('#FilterAll').addClass("active");
                SrViewModel.showInherent(true);
                SrViewModel.showControl(true);
                SrViewModel.showResidual(true);
                GetAllHeatmapData();
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: FilterALL() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function expandInherent() {
            try {
                if (SrViewModel.Inhstate() == false) {
                    //expand
                    SrViewModel.showInherent(true);
                    SrViewModel.Inhstate(true);
                    $("#spanInh").addClass("fa-caret-down").removeClass("fa-caret-right");
                    if (SrViewModel.InhRiskThemeDetails() != undefined) {
                        for (var i = 0; i < SrViewModel.InhRiskThemeDetails().length; i++) {
                            var d = SrViewModel.InhRiskThemeDetails()[i];
                            if (!d.LevelState) {
                                d.LevelState = true;
                            }
                            //if ((SrViewModel.heatMapViewNA() && SrViewModel.InhRiskThemeDetails()[i].Show_Edit) || (!SrViewModel.heatMapViewNA())) {
                                $(".taxo_" + d.Id).show();
                                $('#spandown' + d.Id).show();
                                $('#spanright' + d.Id).hide();
                            //}
                            //else {
                            //    $(".taxo_" + d.Id).hide();
                            //}
                        }
                    }

                    if (SrViewModel.Query() != "") {
                        SearchResult_Main();
                    }
                }
                else {
                    //collapse
                    SrViewModel.showInherent(false);
                    SrViewModel.Inhstate(false);
                    $("#spanInh").addClass("fa-caret-right").removeClass("fa-caret-down");

                    if (SrViewModel.InhRiskThemeDetails() != undefined) {
                        for (var i = 0; i < SrViewModel.InhRiskThemeDetails().length; i++) {
                            var d = SrViewModel.InhRiskThemeDetails()[i];
                            if (d.LevelState) {
                                d.LevelState = false;
                            }

                            if (d.PId != 0) {
                                $(".taxo_" + d.Id).hide();
                                $('#spandown' + d.Id).hide();
                                $('#spanright' + d.Id).show();
                            } else {
                                $('#spandown' + d.Id).hide();
                                $('#spanright' + d.Id).show();
                            }
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: expandInherent() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function expandControl() {
            try {
                if (SrViewModel.Cntstate() == false) {
                    //expand
                    SrViewModel.showControl(true);
                    SrViewModel.Cntstate(true);
                    $("#spanCnh").addClass("fa-caret-down").removeClass("fa-caret-right");

                    if (SrViewModel.ContRiskThemeDetails() != undefined) {
                        for (var i = 0; i < SrViewModel.ContRiskThemeDetails().length; i++) {
                            var d = SrViewModel.ContRiskThemeDetails()[i];
                            if (!d.LevelState) {
                                d.LevelState = true;
                            }

                            //if ((SrViewModel.heatMapViewNA() && SrViewModel.ContRiskThemeDetails()[i].Show_Edit) || (!SrViewModel.heatMapViewNA())) {
                                $(".taxo_" + d.Id).show();
                                $('#spandown' + d.Id).show();
                                $('#spanright' + d.Id).hide();
                            //}
                            //else {
                            //    $(".taxo_" + d.Id).hide();
                            //}
                        }
                    }

                    if (SrViewModel.Query() != "") {
                        SearchResult_Main();
                    }
                }
                else {
                    //collapse
                    SrViewModel.showControl(false);
                    SrViewModel.Cntstate(false);
                    $("#spanCnh").addClass("fa-caret-right").removeClass("fa-caret-down");

                    if (SrViewModel.ContRiskThemeDetails() != undefined) {
                        for (var i = 0; i < SrViewModel.ContRiskThemeDetails().length; i++) {
                            var d = SrViewModel.ContRiskThemeDetails()[i];
                            if (d.LevelState) {
                                d.LevelState = false;
                            }

                            if (d.PId != 0) {
                                $(".taxo_" + d.Id).hide();
                                $('#spandown' + d.Id).hide();
                                $('#spanright' + d.Id).show();
                            } else {
                                $('#spandown' + d.Id).hide();
                                $('#spanright' + d.Id).show();
                            }
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: expandControl() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function expandResidual() {
            try {
                if (SrViewModel.Resstate() == false) {
                    SrViewModel.showResidual(true);
                    SrViewModel.Resstate(true);
                    $("#spanRes").addClass("fa-caret-down").removeClass("fa-caret-right");
                }
                else {
                    SrViewModel.showResidual(false);
                    SrViewModel.Resstate(false);
                    $("#spanRes").addClass("fa-caret-right").removeClass("fa-caret-down");
                }
            }            
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: expandResidual() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function GetUsersRoleWFDetails() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    url: "/api/Configuration/GetRoleUserDetailsForBUSocializationWorkFLow",
                    data: ko.toJSON({
                        "SurveyId": SrViewModel.SurveyId(),
                        "Survey_type": SrViewModel.SurveyClassification()
                    }),
                    type: "POST",
                    headers: headers
                })
                .success(function (jsonResult, success) {
                        SrViewModel.UsersRoleWFList([]);
                        if (jsonResult === null) {
                            $('#UsersRoleWFChevrons').hide();
                        }
                        else if (jsonResult.length > 0 && jsonResult !== null) {
                            if (jsonResult[0].RoleID == -99) {
                                logger.logError(jsonResult[0].RoleName + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                            }
                            else {
                                $('#UsersRoleWFChevrons').show();
                                SrViewModel.UsersRoleWFList(jsonResult);
                            }
                        } else {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                        }
                    })
                    .fail(function (error, status) {
                        try {
                            if (error.status === 401) {
                                app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                    .then(function (option) {
                                        if (option === "OK")
                                            navigation.unauthorized();
                                    });
                            }
                            else {
                                var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetUsersRoleWFDetails() method in SocializationResponse.js';
                                logger.logMessage(msg);
                            }
                        } catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetUsersRoleWFDetails() method in SocializationResponse.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in GetUsersRoleWFDetails() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function SearchResult() {
            try {
                if (SrViewModel.ClickedSurveyTypeText() == "qldr") {
                    var searchedList = ko.observableArray([]);
                    var q = SrViewModel.Query();
                    if (q != "") {
                        for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                            for (var j = 0; j < SrViewModel.QualResponseListData()[i].length; j++) {
                                for (var k = 0; k < SrViewModel.QualResponseListData()[i][j].length; k++) {
                                    if (SrViewModel.QualResponseListData()[i][j][k].QuestionText.toLowerCase().indexOf(q.toLowerCase()) >= 0) {
                                        searchedList.push(SrViewModel.QualResponseListData()[i][j][k]);
                                    }
                                }
                            }
                        }
                    }

                    //make it false for all first
                    $.map(SrViewModel.QualResponseListData(), function (item) {
                        $.map(item, function (result) {
                            $.map(result, function (result1) {
                                result.IsVisibleforSearch = false;
                                result1.IsVisibleforSearch = false;
                            })
                        })
                    })

                    if (SrViewModel.Query() != undefined && SrViewModel.Query() == "") {
                        //for empty keyboard input
                        $.map(SrViewModel.QualResponseListData(), function (item) {
                            $.map(item, function (result) {
                                $.map(result, function (result1) {
                                    result.IsVisibleforSearch = true;
                                    result1.IsVisibleforSearch = true;
                                })
                            })
                        })
                    }

                    if (searchedList() != undefined) {
                        for (var h = 0; h < searchedList().length; h++) {
                            for (var i = 0; i < SrViewModel.QualResponseListData().length; i++) {
                                for (var j = 0; j < SrViewModel.QualResponseListData()[i].length; j++) {
                                    for (var k = 0; k < SrViewModel.QualResponseListData()[i][j].length; k++) {
                                        if (SrViewModel.QualResponseListData()[i][j][k].QuestionId == searchedList()[h].QuestionId) {
                                            SrViewModel.QualResponseListData()[i][j][k].IsVisibleforSearch = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    BindDynamicHtmlQualitative();
                }
                else if (SrViewModel.ClickedSurveyTypeText() == "cdr") {
                    var searchedListCn = ko.observableArray([]);
                    var q = SrViewModel.Query();
                    if (q != "") {
                        for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                            for (var j = 0; j < SrViewModel.ControlsResponseData()[i].length; j++) {
                                for (var k = 0; k < SrViewModel.ControlsResponseData()[i][j].length; k++) {
                                    if (SrViewModel.ControlsResponseData()[i][j][k].QuestionText.toLowerCase().indexOf(q.toLowerCase()) >= 0) {
                                        searchedListCn.push(SrViewModel.ControlsResponseData()[i][j][k]);
                                    }
                                }
                            }
                        }
                    }

                    //make it false for all first
                    $.map(SrViewModel.ControlsResponseData(), function (item) {
                        $.map(item, function (result) {
                            $.map(result, function (result1) {
                                result.IsVisibleforSearch = false;
                                result1.IsVisibleforSearch = false;
                            })
                        })
                    })

                    if (SrViewModel.Query() != undefined && SrViewModel.Query() == "") {
                        //for empty keyboard input
                        $.map(SrViewModel.ControlsResponseData(), function (item) {
                            $.map(item, function (result) {
                                $.map(result, function (result1) {
                                    result.IsVisibleforSearch = true;
                                    result1.IsVisibleforSearch = true;
                                })
                            })
                        })
                    }
                    if (searchedListCn() != undefined) {
                        for (var h = 0; h < searchedListCn().length; h++) {
                            for (var i = 0; i < SrViewModel.ControlsResponseData().length; i++) {
                                for (var j = 0; j < SrViewModel.ControlsResponseData()[i].length; j++) {
                                    for (var k = 0; k < SrViewModel.ControlsResponseData()[i][j].length; k++) {
                                        if (SrViewModel.ControlsResponseData()[i][j][k].QuestionId == searchedListCn()[h].QuestionId) {
                                            SrViewModel.ControlsResponseData()[i][j][k].IsVisibleforSearch = true;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    BindDynamicHtmlForControls();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SearchResult() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function ResetSearch() {
            try {
                $('#searchFeature').val('');
                if (SrViewModel.ClickedSurveyTypeText() == "qldr") {
                    $.map(SrViewModel.QualResponseListData(), function (item) {
                        $.map(item, function (result) {
                            $.map(result, function (result1) {
                                result.IsVisibleforSearch = true;
                                result1.IsVisibleforSearch = true;
                            })
                        })
                    })
                    BindDynamicHtmlQualitative();
                } else {
                    $.map(SrViewModel.ControlsResponseData(), function (item) {
                        $.map(item, function (result) {
                            $.map(result, function (result1) {
                                result.IsVisibleforSearch = true;
                                result1.IsVisibleforSearch = true;
                            })
                        })
                    })
                    BindDynamicHtmlForControls();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResetSearch() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }


        //////////////////////////////////////////////Over all heatmap view code--------////////////////////////////////////

        //Apply filter event
        function ApplyBuFilters(data, event) {
            try {

                SrViewModel.SelectedBUs('');
                var SelectedBUsString = "";
                for (var i = 0; i < data.BusinessUnitListForFilters().length; i++) {
                    if (SelectedBUsString === "")
                        SelectedBUsString = data.BusinessUnitListForFilters()[i].DERAT_ID().toString();
                    else
                        SelectedBUsString += "," + data.BusinessUnitListForFilters()[i].DERAT_ID().toString();
                }
                SrViewModel.SelectedBUs(SelectedBUsString);
                SrViewModel.BUFiltersApplied(true);
                GetAllHeatmapData();

                closeSideNav();

                SrViewModel.NumberOfBUsSelected(data.BusinessUnitListForFilters().length);
                $('.badge').css({ 'display': 'inline-block' });
                //sortResetDefault();
                //$('#myDropdown').removeClass('show');
                //$('#myDropdownSort').removeClass('open');
                $("#f-filter").css("display", "");
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ApplyBuFilters() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        //clear filter event
        function ClearAllBuFilters(data, event) {
            try {
                SrViewModel.BusinessUnitList(SrViewModel.BusinessUnitListDUP());
                SrViewModel.SelectedCheckedBUList([]);
                SrViewModel.SelectedCheckedList([]);
                SrViewModel.SelectedBUs('');
                closeSideNav();
                SrViewModel.BUFiltersApplied(false);
                SrViewModel.NumberOfBUsSelected(0);
                $('.badge').css({ 'display': 'none' });
                document.getElementById('DynamicOrgOptedFilters').innerHTML = "";
                $('#DynamicOrgOptedFilters').css({ 'display': 'none' });
                $('#f-filter').css('display', 'none');
                GetAllHeatmapData();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearAllBuFilters() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function openSideNav() {
            try {
                $('#myValueDropdown').removeClass('show');
                $('#myValueDropdownSort').removeClass('open');
                $('#myDropdown').removeClass('show');
                $('#myDropdownSort').removeClass('open');
                $('#exportDropdown').removeClass('show');
                $('#exportDropdownBtn').removeClass('open');
                $('#myValueDropdownLevel').removeClass('show');
                $('#myValueDropdownSortLevel').removeClass('open');

                if ($('#BusinessUnitFilterBtnHm').hasClass("openFilter")) {
                    closeSideNav();
                } else {
                    $('#BusinessUnitFilterBtnHm').addClass("openFilter");
                    $('#OrganizationalLevel').show();
                    $('#BuselectFilter').show();
                    $('#FilterButton').show();
                    $('#OrgFilterError').hide();
                    $('#BUFilterError').hide();
                    if (SrViewModel.BUFiltersApplied() == false) {
                        $('#loadingImgMainHm').modal('show');
                        GetAllOrganizationalLevels();
                    }

                }
                SrViewModel.IsSideNavOpen(1);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: openSideNav() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function closeSideNav() {
            try {
                $('#BusinessUnitFilterBtnHm').removeClass("openFilter");
                $('#OrganizationalLevel').hide();
                $('#BuselectFilter').hide();
                $('#OrgFilterError').hide();
                $('#BUFilterError').hide();
                $('#loadingImgMainHm').modal('hide');
                $('#FilterButton').hide();
                SrViewModel.IsSideNavOpen(0);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: closeSideNav() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function GetAllOrganizationalLevels() {
            try {
                return $.ajax({
                    url: "/api/Configuration/getDistinctBusinessLevelsAllBUApplicability",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { TypeId: SrViewModel.AssessmentTypeId(), YOA: null }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllOrganizationalLevels() in SocializationResponse.js';
                logger.logMessage(msg);

            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        if (jsonResult.length != 0 && jsonResult[0].Incident_Description != null) {
                            logger.logError(jsonResult[0].Incident_Description + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                        }
                        else {
                            var OrganizationalLevels = $.map(jsonResult, function (result) {
                                return new BusinessLevelsModel(result);
                            });
                            if (OrganizationalLevels.length > 0) {
                                SrViewModel.OrgLvlDrpDwnList(OrganizationalLevels);
                                SrViewModel.OrgLvlValueList(SrViewModel.OrgLvlDrpDwnList()[0].BusinessLevelValueList());
                            } 
                            //Get all BU list with org sub level id's
                            GetAllBusinessUnitsForFilters();
                            SrViewModel.SelectedCheckedList('');
                            SrViewModel.SelectedCheckedBUList('');
                            document.getElementById('DynamicOrgOptedFilters').innerHTML = "";
                        }
                    }
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllOrganizationalLevels() in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in SocializationResponse.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            }
        }

        function BusinessLevelsModel(item) {
            try {
                var self = this;
                self.Bulevel = ko.observable($('<div/>').html(item.Bulevel).text());
                self.BlName = ko.observable($('<div/>').html(item.BlName).text());
                self.BlId = ko.observable(item.BlId)
                var MappedBuLevelValueList = $.map(item.BuLevelValueList, function (result) {
                    return new BuLevelValueListModel(result);
                });
                self.BusinessLevelValueList = ko.observableArray(MappedBuLevelValueList);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessLevelModel() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function BusinessUnitModelDUP(item) {
            try {
                var self = this;
                self.BusinessUnitId = ko.observable($('<div/>').html(item.BusinessUnitId()).text());
                self.DERAT_ID = ko.observable(item.DERAT_ID());
                self.BU_ID = ko.observable($('<div/>').html(item.BusinessUnitId()).text());
                self.BuId = ko.observable($('<div/>').html(item.BusinessUnitId()).text());
                self.BusinessUnitName = ko.observable($('<div/>').html(item.BusinessUnitName()).text());
                self.BuName = ko.observable($('<div/>').html(item.BusinessUnitName()).text());
                self.BU_NAME = ko.observable($('<div/>').html(item.BusinessUnitName()).text());
                self.AssessmentDate = ko.observable($('<div/>').html(item.AssessmentDate()).text());
                self.BuStatus = ko.observable($('<div/>').html(item.BuStatus()).text());
                self.SubLevelId = ko.observable(item.SubLevelId());
                self.isChecked = ko.observable(false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessUnitModel() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function BuLevelValueListModel(item) {
            try {
                var self = this;
                self.BlvalueId = ko.observable($('<div/>').html(item.BlvalueId).text());
                self.BlvalueName = ko.observable($('<div/>').html(item.BlvalueName).text());
                self.ParentBuLevel = ko.observable($('<div/>').html(item.ParentBuLevel).text());
                self.BlvalueShortName = ko.observable($('<div/>').html(item.BlvalueShortName).text());
                self.TargetRow = ko.observable(item.TargetRow);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BuLevelValueListModel() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function GetAllBusinessUnitsForFilters() {
            try {

                return $.ajax({
                    url: "/api/AMLRiskAssessment/GetAllBusinessUnitsForFiltersBUApplicability",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { TypeId: SrViewModel.AssessmentTypeId() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllBusinessUnitsForFilters() in SocializationResponse.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        if (jsonResult.length != 0 && jsonResult[0].Incident_Description != null)
                        {
                            logger.logError(jsonResult[0].Incident_Description + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                        }
                        else {
                            var mappedBuList = $.map(jsonResult, function (result) {
                                return new BusinessUnitModelFilter(result);
                            });
                            SrViewModel.BusinessUnitListForFilters(mappedBuList);
                            SrViewModel.BusinessUnitListForFiltersDUP(mappedBuList);

                            SrViewModel.BusinessUnitListDUP = ko.dependentObservable(function () {
                                var seen = [];
                                return mappedBuList.filter(function (n) {
                                    return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                                });
                            });
                            BindHTML();
                            $('#OrgFilterError').hide();
                            $('#BUFilterError').hide();
                        }
                    }
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SrViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllBusinessUnitsForFilters() in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllBusinessUnitsForFilters() method in SocializationResponse.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllBusinessUnitsForFilters() method in SocializationResponse.js';
                    logger.logMessage(msg);
                }
            }
        }

        function BusinessUnitModelFilter(item) {
            try {
                var self = this;
                self.BU_ID = ko.observable(item.BU_ID);
                self.DERAT_ID = ko.observable(item.DERAT_ID);
                self.BU_NAME = ko.observable($('<div/>').html(item.BU_NAME).text());
                self.BusinessUnitId = ko.observable($('<div/>').html(item.BuId).text());
                self.BusinessUnitName = ko.observable($('<div/>').html(item.BuName).text());
                self.BuName = ko.observable($('<div/>').html(item.BuName).text());
                self.AssessmentDate = ko.observable($('<div/>').html(item.BuAssessmentDate).text());
                self.BuStatus = ko.observable($('<div/>').html(item.BuStatus).text());
                self.SubLevelId = ko.observable(item.SubLevelId);
                self.isChecked = ko.observable(false);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: BusinessUnitModelFilter() in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function BindHTML() {
            try {
                //Org Level Filter Fossil style
                var OrgList = "";

                OrgList += '<div class="filter-nav1"><ul class="nav nav-tabs"><li class="fl-lbl"><span>Add Filters </span> </li>';

                for (var i = 0; i < SrViewModel.OrgLvlDrpDwnList().length; i++) {
                    if (i == 0) {
                        OrgList += '<li class="active"><a href="#tab_' + SrViewModel.OrgLvlDrpDwnList()[i].BlId() + '" data-toggle="tab">' + SrViewModel.OrgLvlDrpDwnList()[i].BlName() + ' <i class="fa fa-chevron-down" aria-hidden="true"></i> </a></li>'
                    } else {
                        OrgList += '<li class=""><a href="#tab_' + SrViewModel.OrgLvlDrpDwnList()[i].BlId() + '" data-toggle="tab">' + SrViewModel.OrgLvlDrpDwnList()[i].BlName() + ' <i class="fa fa-chevron-down" aria-hidden="true" ></i> </a></li>'
                    }
                }
                OrgList += '<li class=""><a href="#tab_BU" data-toggle="tab">' + SrViewModel.BUTitle() + ' <i class="fa fa-chevron-down" aria-hidden="true"></i> </a></li>'

                OrgList += '</ul><div class="tab-content filter-content">';

                for (var i = 0; i < SrViewModel.OrgLvlDrpDwnList().length; i++) {
                    if (i == 0) {
                        OrgList += '<div class="tab-pane active" id="tab_' + SrViewModel.OrgLvlDrpDwnList()[i].BlId() + '">'
                    } else {
                        OrgList += '<div class="tab-pane" id="tab_' + SrViewModel.OrgLvlDrpDwnList()[i].BlId() + '">'
                    }
                    if (SrViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList() != undefined) {
                        if (SrViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length > 0) {
                            for (var j = 0; j < SrViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; j++) {
                                OrgList += '<label  class="ft-selection"><input id=sublevel' + SrViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueId() + ' type="checkbox" data-bind="event:{change:$root.SubCheckboxSelected}" style="font-weight: 600;position : fixed;clip : rect(0,0,0,0);pointer-events : none;"><i class="fa fa-check ' + SrViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueId() + '" aria-hidden="true" style="display:none"></i><span class="cc-facet-result-text tag-text">' + SrViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueName() + '</span></label>';
                            }

                        }
                    }
                    OrgList += '</div>';
                }
                OrgList += '<div class="tab-pane" id="tab_BU">';

                SrViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                    var seen = [];
                    return SrViewModel.BusinessUnitListForFilters().filter(function (n) {
                        return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                    });
                });

                SrViewModel.BusinessUnitListForFilters(SrViewModel.DistinctFileredBUs());

                for (var w = 0; w < SrViewModel.BusinessUnitListForFilters().length; w++) {
                    OrgList += '<label class="ft-selection">' +
                        '<input id=sublevelBU' + SrViewModel.BusinessUnitListForFilters()[w].BusinessUnitId() + ' type="checkbox" data-bind="event:{change:$root.SubCheckboxSelected}" style="font-weight: 600;position : fixed;clip : rect(0,0,0,0);pointer-events : none;">' +
                        '<i class="fa fa-check ' + SrViewModel.BusinessUnitListForFilters()[w].BusinessUnitId() + '" aria-hidden="true" style="display:none"></i>' +
                        '<span class="cc-facet-result-text tag-text">' + SrViewModel.BusinessUnitListForFilters()[w].BusinessUnitName() + '</span>' +
                        '</label>';
                }
                OrgList += '</div>';

                if (OrgList == "") {
                    OrgList = '<div id="NoorganizationalLevelerror" class="alert-warning"><label class="control-label">Organizational Levels are not configured for this Year of Assessment.</label></div>';

                }
                document.getElementById('OrganizationalLevel').innerHTML = OrgList;

                for (var i = 0; i < SrViewModel.OrgLvlDrpDwnList().length; i++) {
                    for (var l = 0; l < SrViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; l++) {
                        ko.applyBindingsToNode($('#sublevel' + SrViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[l].BlvalueId()), { event: { change: SrViewModel.SubCheckboxSelected } }, SrViewModel);
                    }
                }

                for (var k = 0; k < SrViewModel.BusinessUnitListForFilters().length; k++) {
                    ko.applyBindingsToNode($('#sublevelBU' + SrViewModel.BusinessUnitListForFilters()[k].BusinessUnitId()), { event: { change: SrViewModel.SubCheckboxSelected } }, SrViewModel);
                }
                $('#loadingImgMainHm').modal('hide');
                SrViewModel.NumberOfBUsSelected(SrViewModel.BusinessUnitListForFilters().length);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: BindHTML() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function SubCheckboxSelected(data, event) {
            try {
                $('#OrgFilterError').hide();
                $('#BUFilterError').hide();
                var selectedSubOrgLevelID = event.currentTarget.id.substr(event.currentTarget.id.indexOf("el") + 2);
                var BUselected = "";
                if (isNaN(parseInt(selectedSubOrgLevelID)) && SrViewModel.SelectedCheckedList().length > 0) {
                    $('#BUFilterError').show();
                    return false;
                }
                else if (!isNaN(parseInt(selectedSubOrgLevelID)) && SrViewModel.SelectedCheckedBUList().length > 0) {
                    $('#OrgFilterError').show();
                    return false;
                }
                else if (!isNaN(parseInt(selectedSubOrgLevelID)) && SrViewModel.SelectedCheckedBUList().length == 0) {
                    for (var i = 0; i < SrViewModel.OrgLvlDrpDwnList().length; i++) {
                        var counterCheck = 0;
                        for (var g = 0; g < SrViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; g++) {
                            if (SrViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId() == selectedSubOrgLevelID) {
                                if (event.currentTarget.checked) {
                                    $("#sublevel" + SrViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop("checked", true);
                                    $('.fa-check.' + SrViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).css({ 'display': 'inline-block' });

                                    SrViewModel.SelectedCheckedList.push({
                                        SubLevelId: SrViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId(),
                                        SubLevelName: SrViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueName(),
                                        OrgLevelName: SrViewModel.OrgLvlDrpDwnList()[i].BlName()
                                    });
                                }
                                else {
                                    $("#sublevel" + SrViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop("checked", false);
                                    $('.fa-check.' + SrViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).css({ 'display': 'none' });
                                    if (SrViewModel.SelectedCheckedList().length > 0) {
                                        SrViewModel.SelectedCheckedList.remove(function (item) { return item.SubLevelId == SrViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId() })
                                    }
                                }
                            }

                            //Mark parent check box as checked if all sub levels are selected
                            if ($("#sublevel" + SrViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop('checked')) {
                                counterCheck++;
                            }
                            if (counterCheck > 0 && counterCheck == SrViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length) {
                                $("#" + SrViewModel.OrgLvlDrpDwnList()[i].BlId()).prop("checked", true);
                            }
                            else if (counterCheck > 0 && counterCheck == SrViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length) {
                                $("#" + SrViewModel.OrgLvlDrpDwnList()[i].BlId()).prop("checked", false);
                            }
                        }
                    }
                    //Logic to re-set the BU list
                    SrViewModel.BusinessUnitListForFilters([]);
                    if (SrViewModel.SelectedCheckedList().length > 0) {
                        var mappedBuList = $.map(SrViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                            for (var m = 0; m < SrViewModel.SelectedCheckedList().length; m++) {
                                if (result.SubLevelId() == SrViewModel.SelectedCheckedList()[m].SubLevelId)
                                    return new BusinessUnitModelDUP(result);
                            }
                        });
                        SrViewModel.BusinessUnitListForFilters(mappedBuList);
                        //Main tain this list to retain the org filters on deselection of applicability filters
                        SrViewModel.FinalOrgFilterList(mappedBuList);

                    }
                    else {
                        SrViewModel.BusinessUnitListForFilters([]);
                        mappedBuList = $.map(SrViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                            return new BusinessUnitModelDUP(result);
                        });
                        SrViewModel.BusinessUnitListForFilters(mappedBuList);
                        SrViewModel.FinalOrgFilterList(mappedBuList);
                    }
                    SetFilterSelection();

                } else if (isNaN(parseInt(selectedSubOrgLevelID)) && SrViewModel.SelectedCheckedList().length == 0) {
                    BUselected = event.currentTarget.id.substr(event.currentTarget.id.indexOf("BU") + 2);

                    for (var i = 0; i < SrViewModel.BusinessUnitListDUP().length; i++) {
                        if (SrViewModel.BusinessUnitListDUP()[i].BusinessUnitId() == BUselected) {
                            if (event.currentTarget.checked) {
                                $("#sublevelBU" + BUselected).prop("checked", true);
                                $('.fa-check.' + BUselected).css({ 'display': 'inline-block' });

                                SrViewModel.SelectedCheckedBUList.push({
                                    SubLevelId: SrViewModel.BusinessUnitListDUP()[i].BusinessUnitId(),
                                    SubLevelName: SrViewModel.BusinessUnitListDUP()[i].BusinessUnitName()
                                });
                            }
                            else {
                                $("#sublevelBU" + BUselected).prop("checked", false);
                                $('.fa-check.' + BUselected).css({ 'display': 'none' });
                                if (SrViewModel.SelectedCheckedBUList().length > 0) {
                                    SrViewModel.SelectedCheckedBUList.remove(function (item) { return item.SubLevelId == SrViewModel.BusinessUnitListDUP()[i].BusinessUnitId() })
                                }
                            }
                        }
                    }

                    if (SrViewModel.SelectedCheckedBUList().length > 0) {
                        //Logic to re-set the BU list
                        SrViewModel.BusinessUnitListForFilters([]);

                        var mappedBuList = $.map(SrViewModel.BusinessUnitListDUP(), function (result) {
                            for (var m = 0; m < SrViewModel.SelectedCheckedBUList().length; m++) {
                                if (result.BusinessUnitId() == SrViewModel.SelectedCheckedBUList()[m].SubLevelId)
                                    return new BusinessUnitModelDUP(result);
                            }
                        });
                        SrViewModel.BusinessUnitListForFilters(mappedBuList);
                    }
                    else {
                        SrViewModel.BusinessUnitListForFilters([]);
                        var mappedBuList = $.map(SrViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                            return new BusinessUnitModelDUP(result);
                        });
                        SrViewModel.BusinessUnitListForFilters(mappedBuList);
                        SrViewModel.FinalOrgFilterList(mappedBuList);
                    }
                    SetBUFilterSelection();
                }
                //Set count of BU's selected
                if (SrViewModel.BusinessUnitListForFilters().length > 0) {
                    SrViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                        var seen = [];
                        return SrViewModel.BusinessUnitListForFilters().filter(function (n) {
                            return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                        });
                    });
                    SrViewModel.BusinessUnitListForFilters(SrViewModel.DistinctFileredBUs());
                }

                SrViewModel.NumberOfBUsSelected(SrViewModel.BusinessUnitListForFilters().length)
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: SubCheckboxSelected function in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function SetBUFilterSelection() {
            try {
                document.getElementById('DynamicOrgOptedFilters').innerHTML = "";

                var contentHtml = "";
                for (var k = 0; k < SrViewModel.SelectedCheckedBUList().length; k++) {
                    contentHtml += '<div id="DynamicBUOptedFilters_' + SrViewModel.SelectedCheckedBUList()[k].SubLevelId + '" class="fitem"><span class="hetamap-filter"><span>BU </span> : ' + SrViewModel.SelectedCheckedBUList()[k].SubLevelName + '<span id="ClearFilterTextBU_' + SrViewModel.SelectedCheckedBUList()[k].SubLevelId + '" data-bind="click:ClearBUFilterSelection" class="f-clear"><i class="demo-icon icon-cross_special"></i></span></span></div>';
                }

                document.getElementById('DynamicOrgOptedFilters').innerHTML = contentHtml;
                for (var k = 0; k < SrViewModel.SelectedCheckedBUList().length; k++) {
                    ko.applyBindingsToNode($('#ClearFilterTextBU_' + SrViewModel.SelectedCheckedBUList()[k].SubLevelId), { click: SrViewModel.ClearBUFilterSelection }, SrViewModel);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetBUFilterSelection() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function ClearBUFilterSelection(data, event) {
            try {

                var selectedSubOrgLevelID = event.currentTarget.id.substr(event.currentTarget.id.indexOf("_") + 1);
                document.getElementById('DynamicBUOptedFilters_' + selectedSubOrgLevelID).innerHTML = "";

                $('.fa-check.' + selectedSubOrgLevelID).css({ 'display': 'none' });
                if (SrViewModel.SelectedCheckedBUList().length > 0) {
                    SrViewModel.SelectedCheckedBUList.remove(function (item) { return item.SubLevelId == selectedSubOrgLevelID })
                }

                //Logic to re-set the BU list
                SrViewModel.BusinessUnitListForFilters([]);
                if (SrViewModel.SelectedCheckedBUList().length > 0) {
                    var mappedBuList = $.map(SrViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        for (var m = 0; m < SrViewModel.SelectedCheckedBUList().length; m++) {
                            if (result.BusinessUnitId() == SrViewModel.SelectedCheckedBUList()[m].SubLevelId)
                                return new BusinessUnitModelDUP(result);
                        }
                    });
                    SrViewModel.BusinessUnitListForFilters(mappedBuList);

                }
                else {
                    SrViewModel.BusinessUnitListForFilters([]);
                    var mappedBuList = $.map(SrViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        return new BusinessUnitModelDUP(result);
                    });
                    SrViewModel.BusinessUnitListForFilters(mappedBuList);

                    $('#OrgFilterError').hide();
                }
                //Set count of BU's selected
                if (SrViewModel.BusinessUnitListForFilters().length > 0) {
                    SrViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                        var seen = [];
                        return SrViewModel.BusinessUnitListForFilters().filter(function (n) {
                            return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                        });
                    });
                    SrViewModel.BusinessUnitListForFilters(SrViewModel.DistinctFileredBUs());
                }

                SrViewModel.NumberOfBUsSelected(SrViewModel.BusinessUnitListForFilters().length);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearBUFilterSelection() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function SetFilterSelection() {
            try {
                document.getElementById('DynamicOrgOptedFilters').innerHTML = "";
                //Mark Org levels filter seletion
                var contentHtml = "";
                for (var k = 0; k < SrViewModel.SelectedCheckedList().length; k++) {
                    contentHtml += '<div id="DynamicOptedFilters_' + SrViewModel.SelectedCheckedList()[k].SubLevelId + '" class="fitem"><span class="hetamap-filter"><span>' + SrViewModel.SelectedCheckedList()[k].OrgLevelName + '</span> : ' + SrViewModel.SelectedCheckedList()[k].SubLevelName + '<span id="ClearFilterText_' + SrViewModel.SelectedCheckedList()[k].SubLevelId + '" data-bind="click:ClearOrgFilterSelection" ><i class="demo-icon icon-cross_special"></i></span></span></div>';
                }
                document.getElementById('DynamicOrgOptedFilters').innerHTML = contentHtml;
                for (var k = 0; k < SrViewModel.SelectedCheckedList().length; k++) {
                    ko.applyBindingsToNode($('#ClearFilterText_' + SrViewModel.SelectedCheckedList()[k].SubLevelId), { click: SrViewModel.ClearOrgFilterSelection }, SrViewModel);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetFilterSelection() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function ClearOrgFilterSelection(data, event) {
            try {

                var selectedSubOrgLevelID = event.currentTarget.id.substr(event.currentTarget.id.indexOf("_") + 1);

                document.getElementById('DynamicOptedFilters_' + selectedSubOrgLevelID).innerHTML = "";

                $('.fa-check.' + selectedSubOrgLevelID).css({ 'display': 'none' });
                if (SrViewModel.SelectedCheckedList().length > 0) {
                    SrViewModel.SelectedCheckedList.remove(function (item) { return item.SubLevelId == selectedSubOrgLevelID });
                }

                //Logic to re-set the BU list
                SrViewModel.BusinessUnitListForFilters([]);
                if (SrViewModel.SelectedCheckedList().length > 0) {
                    var mappedBuList = $.map(SrViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        for (var m = 0; m < SrViewModel.SelectedCheckedList().length; m++) {
                            if (result.SubLevelId() == SrViewModel.SelectedCheckedList()[m].SubLevelId)
                                return new BusinessUnitModelDUP(result);
                        }
                    });
                    SrViewModel.BusinessUnitListForFilters(mappedBuList);
                    //Main tain this list to retain the org filters on deselection of applicability filters
                    SrViewModel.FinalOrgFilterList(mappedBuList);

                }
                else {
                    SrViewModel.BusinessUnitListForFilters([]);
                    var mappedBuList = $.map(SrViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        return new BusinessUnitModelDUP(result);
                    });
                    SrViewModel.BusinessUnitListForFilters(mappedBuList);
                    SrViewModel.FinalOrgFilterList(mappedBuList);
                    $('#BUFilterError').hide();
                }
                //Set count of BU's selected
                if (SrViewModel.BusinessUnitListForFilters().length > 0) {
                    SrViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                        var seen = [];
                        return SrViewModel.BusinessUnitListForFilters().filter(function (n) {
                            return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                        });
                    });
                    SrViewModel.BusinessUnitListForFilters(SrViewModel.DistinctFileredBUs());
                }
                SrViewModel.NumberOfBUsSelected(SrViewModel.BusinessUnitListForFilters().length);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearOrgFilterSelection() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function CollapseAll() {
            try {

                if (SrViewModel.ShowFinalLevel()) {

                    SrViewModel.showInherent(false);
                    SrViewModel.Inhstate(false);
                    $("#spanInh").addClass("fa-caret-right").removeClass("fa-caret-down");

                    if (SrViewModel.AssessmentType() != 2) {
                        SrViewModel.showControl(false);
                        SrViewModel.Cntstate(false);
                        $("#spanCnh").addClass("fa-caret-right").removeClass("fa-caret-down");

                        SrViewModel.showResidual(false);
                        SrViewModel.Resstate(false);
                        //$("#spanRes").addClass("fa-caret-right").removeClass("fa-caret-down");
                    }
                }

                if (SrViewModel.InhRiskThemeDetails() != undefined) {
                    for (var i = 0; i < SrViewModel.InhRiskThemeDetails().length; i++) {
                        var d = SrViewModel.InhRiskThemeDetails()[i];

                        if (d.LevelState) {
                            d.LevelState = false;
                        }

                        if (d.PId != 0) {
                            $(".taxo_" + d.Id).hide();
                            $('#spandown' + d.Id).hide();
                            $('#spanright' + d.Id).show();
                        } else {
                            $('#spandown' + d.Id).hide();
                            $('#spanright' + d.Id).show();
                        }
                    }
                }
                if (SrViewModel.ContRiskThemeDetails() != undefined) {
                    for (var i = 0; i < SrViewModel.ContRiskThemeDetails().length; i++) {
                        var d = SrViewModel.ContRiskThemeDetails()[i];

                        if (d.LevelState) {
                            d.LevelState = false;
                        }

                        if (d.PId != 0) {
                            $(".taxo_" + d.Id).hide();
                            $('#spandown' + d.Id).hide();
                            $('#spanright' + d.Id).show();
                        } else {
                            $('#spandown' + d.Id).hide();
                            $('#spanright' + d.Id).show();
                        }
                    }
                }
                $('#expandA').show();
                $('#collapseA').hide();

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CpllapseAll() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

        function ExpandAll() {
            try {

                if (SrViewModel.ShowFinalLevel()) {
                    SrViewModel.showInherent(true);
                    SrViewModel.Inhstate(true);
                    $("#spanInh").addClass("fa-caret-down").removeClass("fa-caret-right");

                    if (SrViewModel.AssessmentType() != 2) {
                        SrViewModel.showControl(true);
                        SrViewModel.Cntstate(true);
                        $("#spanCnh").addClass("fa-caret-down").removeClass("fa-caret-right");

                        SrViewModel.showResidual(true);
                        SrViewModel.Resstate(true);
                        //$("#spanRes").addClass("fa-caret-down").removeClass("fa-caret-right");
                    }
                }
                if (SrViewModel.InhRiskThemeDetails() != undefined) {
                    for (var i = 0; i < SrViewModel.InhRiskThemeDetails().length; i++) {
                        var d = SrViewModel.InhRiskThemeDetails()[i];
                        if (!d.LevelState) {
                            d.LevelState = true;
                        }

                        //if ((SrViewModel.heatMapViewNA() && d.Show_Edit) || (!SrViewModel.heatMapViewNA())) {
                            $(".taxo_" + d.Id).show();
                            $('#spandown' + d.Id).show();
                            $('#spanright' + d.Id).hide();
                        //}
                        //else {
                        //    $(".taxo_" + d.Id).hide();
                        //}
                    }
                }
                if (SrViewModel.ContRiskThemeDetails() != undefined) {
                    for (var i = 0; i < SrViewModel.ContRiskThemeDetails().length; i++) {
                        var d = SrViewModel.ContRiskThemeDetails()[i];
                        if (!d.LevelState) {
                            d.LevelState = true;
                        }

                        //if ((SrViewModel.heatMapViewNA() && d.Show_Edit) || (!SrViewModel.heatMapViewNA())) {
                            $(".taxo_" + d.Id).show();
                            $('#spandown' + d.Id).show();
                            $('#spanright' + d.Id).hide();
                        //}
                        //else {
                        //    $(".taxo_" + d.Id).hide();
                        //}
                    }
                }

                $('#expandA').hide();
                $('#collapseA').show();

                if (SrViewModel.Query() != "") {
                    SearchResult_Main();
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ExpandAll() method in SocializationResponse.js';
                logger.logMessage(msg);
            }
        }

    }); //closing tag of page top element
;
